// tslint:disable
// This file is generated by buildArtConfig script.
// Please don't edit it manually.
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
import { artConfigProductionsOverrides } from "./artConfigProductionsOverrides";
import { IdAssetBundleBuildings } from "./IdAssetBundleBuildings";
import { IdAssetBundleBuildingsInitial } from "./IdAssetBundleBuildingsInitial";
export var artConfigProductions = __assign({ aloeVera_meadow1: [
        [
            {
                id: IdAssetBundleBuildings.meadow_seeds_aloeVera_1,
                offset: [-47, -117],
            },
        ],
        [
            {
                id: IdAssetBundleBuildings.meadow_seeds_aloeVera_2,
                offset: [-45, -125],
            },
        ],
        [
            {
                id: IdAssetBundleBuildings.meadow_seeds_aloeVera_3,
                offset: [-39, -121],
            },
        ],
    ], aloeVera_meadow2: [
        [
            {
                id: IdAssetBundleBuildings.meadow_seeds_aloeVera_1,
                offset: [-47, -117],
            },
        ],
        [
            {
                id: IdAssetBundleBuildings.meadow_seeds_aloeVera_2,
                offset: [-45, -125],
            },
        ],
        [
            {
                id: IdAssetBundleBuildings.meadow_seeds_aloeVera_3,
                offset: [-39, -121],
            },
        ],
    ], aloeVera_meadow3: [
        [
            {
                id: IdAssetBundleBuildings.meadow_seeds_aloeVera_1,
                offset: [-47, -117],
            },
        ],
        [
            {
                id: IdAssetBundleBuildings.meadow_seeds_aloeVera_2,
                offset: [-45, -125],
            },
        ],
        [
            {
                id: IdAssetBundleBuildings.meadow_seeds_aloeVera_3,
                offset: [-39, -121],
            },
        ],
    ], aloeVera_meadow4: [
        [
            {
                id: IdAssetBundleBuildings.meadow_seeds_aloeVera_1,
                offset: [-47, -117],
            },
        ],
        [
            {
                id: IdAssetBundleBuildings.meadow_seeds_aloeVera_2,
                offset: [-45, -125],
            },
        ],
        [
            {
                id: IdAssetBundleBuildings.meadow_seeds_aloeVera_3,
                offset: [-39, -121],
            },
        ],
    ], aloeVera_meadow5: [
        [
            {
                id: IdAssetBundleBuildings.meadow_seeds_aloeVera_1,
                offset: [-47, -117],
            },
        ],
        [
            {
                id: IdAssetBundleBuildings.meadow_seeds_aloeVera_2,
                offset: [-45, -125],
            },
        ],
        [
            {
                id: IdAssetBundleBuildings.meadow_seeds_aloeVera_3,
                offset: [-39, -121],
            },
        ],
    ], aloeVera_meadow6: [
        [
            {
                id: IdAssetBundleBuildings.meadow_seeds_aloeVera_1,
                offset: [-47, -117],
            },
        ],
        [
            {
                id: IdAssetBundleBuildings.meadow_seeds_aloeVera_2,
                offset: [-45, -125],
            },
        ],
        [
            {
                id: IdAssetBundleBuildings.meadow_seeds_aloeVera_3,
                offset: [-39, -121],
            },
        ],
    ], aloeVera_meadow7: [
        [
            {
                id: IdAssetBundleBuildings.meadow_seeds_aloeVera_1,
                offset: [-47, -117],
            },
        ],
        [
            {
                id: IdAssetBundleBuildings.meadow_seeds_aloeVera_2,
                offset: [-45, -125],
            },
        ],
        [
            {
                id: IdAssetBundleBuildings.meadow_seeds_aloeVera_3,
                offset: [-39, -121],
            },
        ],
    ], almonds_almondOrchard1: [
        [
            {
                id: IdAssetBundleBuildings.almond_orchard_blossom_1,
                offset: [-67, -175],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_blossom_1,
                offset: [-51, -169],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_blossom_1,
                offset: [-82, -167],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_blossom_1,
                offset: [-23, -157],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_blossom_1,
                offset: [-7, -151],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_blossom_1,
                offset: [-39, -149],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_blossom_1,
                offset: [21, -134],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_blossom_1,
                offset: [37, -128],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_blossom_1,
                offset: [5, -126],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_blossom_1,
                offset: [-127, -145],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_blossom_1,
                offset: [-111, -139],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_blossom_1,
                offset: [-143, -137],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_blossom_1,
                offset: [-83, -125],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_blossom_1,
                offset: [-67, -119],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_blossom_1,
                offset: [-98, -117],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_blossom_1,
                offset: [-40, -102],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_blossom_1,
                offset: [-24, -96],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_blossom_1,
                offset: [-56, -94],
            },
        ],
        [
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_1,
                offset: [-84, -166],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_1,
                offset: [-52, -170],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_2,
                offset: [-69, -174],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_1,
                offset: [-40, -147],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_1,
                offset: [-8, -152],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_2,
                offset: [-26, -156],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_1,
                offset: [5, -125],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_1,
                offset: [37, -129],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_2,
                offset: [19, -133],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_1,
                offset: [-144, -136],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_1,
                offset: [-112, -140],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_2,
                offset: [-130, -144],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_1,
                offset: [-101, -116],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_1,
                offset: [-69, -120],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_2,
                offset: [-86, -125],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_1,
                offset: [-58, -93],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_1,
                offset: [-26, -97],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_2,
                offset: [-43, -101],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_1,
                offset: [-120, -93],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_1,
                offset: [-116, -89],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_1,
                offset: [-111, -93],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_1,
                offset: [-114, -93],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_1,
                offset: [-123, -93],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_1,
                offset: [-120, -90],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_1,
                offset: [-109, -91],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_1,
                offset: [-112, -90],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_1,
                offset: [-116, -95],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_1,
                offset: [-108, -95],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_2,
                offset: [-104, -92],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_2,
                offset: [-120, -96],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_1,
                offset: [57, -120],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_1,
                offset: [62, -116],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_1,
                offset: [66, -120],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_1,
                offset: [64, -120],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_1,
                offset: [54, -120],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_1,
                offset: [57, -117],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_1,
                offset: [68, -118],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_1,
                offset: [65, -117],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_1,
                offset: [61, -122],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_1,
                offset: [69, -122],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_2,
                offset: [74, -119],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_2,
                offset: [57, -123],
            },
        ],
    ], almonds_almondOrchard2: [
        [
            {
                id: IdAssetBundleBuildings.almond_orchard_blossom_1,
                offset: [-66, -192],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_blossom_1,
                offset: [-49, -183],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_blossom_1,
                offset: [-36, -177],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_blossom_1,
                offset: [-79, -182],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_blossom_1,
                offset: [-21, -167],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_blossom_1,
                offset: [-4, -158],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_blossom_1,
                offset: [9, -153],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_blossom_1,
                offset: [-34, -157],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_blossom_1,
                offset: [21, -145],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_blossom_1,
                offset: [38, -136],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_blossom_1,
                offset: [51, -131],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_blossom_1,
                offset: [8, -135],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_blossom_1,
                offset: [-134, -157],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_blossom_1,
                offset: [-117, -148],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_blossom_1,
                offset: [-104, -142],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_blossom_1,
                offset: [-147, -147],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_blossom_1,
                offset: [-90, -135],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_blossom_1,
                offset: [-73, -126],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_blossom_1,
                offset: [-60, -120],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_blossom_1,
                offset: [-103, -125],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_blossom_1,
                offset: [-42, -116],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_blossom_1,
                offset: [-25, -107],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_blossom_1,
                offset: [-12, -102],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_blossom_1,
                offset: [-55, -106],
            },
        ],
        [
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_1,
                offset: [-79, -183],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_1,
                offset: [-50, -183],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_2,
                offset: [-36, -176],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_2,
                offset: [-66, -193],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_1,
                offset: [-34, -158],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_1,
                offset: [-5, -158],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_2,
                offset: [9, -151],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_2,
                offset: [-21, -167],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_1,
                offset: [8, -135],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_1,
                offset: [38, -135],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_2,
                offset: [51, -129],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_2,
                offset: [21, -145],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_1,
                offset: [-146, -148],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_1,
                offset: [-117, -148],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_2,
                offset: [-103, -142],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_2,
                offset: [-133, -158],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_1,
                offset: [-105, -126],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_1,
                offset: [-75, -126],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_2,
                offset: [-61, -120],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_2,
                offset: [-92, -136],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_1,
                offset: [-56, -106],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_1,
                offset: [-26, -106],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_2,
                offset: [-13, -100],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_2,
                offset: [-43, -116],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_1,
                offset: [-120, -96],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_1,
                offset: [-107, -93],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_2,
                offset: [-113, -100],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_2,
                offset: [-102, -97],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_2,
                offset: [-113, -92],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_2,
                offset: [-110, -93],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_1,
                offset: [-108, -99],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_1,
                offset: [-116, -95],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_1,
                offset: [-109, -98],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_1,
                offset: [-104, -92],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_1,
                offset: [61, -118],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_1,
                offset: [74, -115],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_2,
                offset: [67, -121],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_2,
                offset: [78, -119],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_2,
                offset: [67, -114],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_2,
                offset: [70, -115],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_1,
                offset: [72, -121],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_1,
                offset: [64, -117],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_1,
                offset: [71, -119],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_1,
                offset: [76, -114],
            },
        ],
    ], almonds_almondOrchard3: [
        [
            {
                id: IdAssetBundleBuildings.almond_orchard_blossom_1,
                offset: [-70, -210],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_blossom_1,
                offset: [-53, -196],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_blossom_1,
                offset: [-40, -190],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_blossom_1,
                offset: [-87, -195],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_blossom_1,
                offset: [-70, -195],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_blossom_1,
                offset: [-25, -184],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_blossom_1,
                offset: [-9, -169],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_blossom_1,
                offset: [5, -164],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_blossom_1,
                offset: [-43, -168],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_blossom_1,
                offset: [-25, -168],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_blossom_1,
                offset: [19, -161],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_blossom_1,
                offset: [36, -147],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_blossom_1,
                offset: [49, -141],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_blossom_1,
                offset: [2, -146],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_blossom_1,
                offset: [20, -146],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_blossom_1,
                offset: [-141, -174],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_blossom_1,
                offset: [-124, -160],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_blossom_1,
                offset: [-111, -156],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_blossom_1,
                offset: [-158, -159],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_blossom_1,
                offset: [-140, -159],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_blossom_1,
                offset: [-95, -152],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_blossom_1,
                offset: [-78, -138],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_blossom_1,
                offset: [-66, -134],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_blossom_1,
                offset: [-112, -137],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_blossom_1,
                offset: [-95, -137],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_blossom_1,
                offset: [-44, -136],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_blossom_1,
                offset: [-27, -122],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_blossom_1,
                offset: [-14, -116],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_blossom_1,
                offset: [-61, -121],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_blossom_1,
                offset: [-44, -121],
            },
        ],
        [
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_1,
                offset: [-123, -100],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_1,
                offset: [-110, -96],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_2,
                offset: [-117, -103],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_2,
                offset: [-106, -100],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_2,
                offset: [-117, -96],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_2,
                offset: [-114, -97],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_1,
                offset: [-112, -102],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_1,
                offset: [-120, -98],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_1,
                offset: [-113, -101],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_1,
                offset: [-108, -96],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_1,
                offset: [58, -121],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_1,
                offset: [71, -118],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_2,
                offset: [64, -124],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_2,
                offset: [76, -122],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_2,
                offset: [64, -117],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_2,
                offset: [68, -118],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_1,
                offset: [70, -124],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_1,
                offset: [61, -120],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_1,
                offset: [68, -122],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_1,
                offset: [74, -117],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_1,
                offset: [-87, -195],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_1,
                offset: [-53, -195],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_1,
                offset: [-70, -210],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_2,
                offset: [-70, -194],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_2,
                offset: [-39, -191],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_1,
                offset: [-43, -169],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_1,
                offset: [-9, -169],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_1,
                offset: [-25, -184],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_2,
                offset: [-25, -168],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_2,
                offset: [5, -165],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_1,
                offset: [1, -146],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_1,
                offset: [35, -146],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_1,
                offset: [19, -161],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_2,
                offset: [18, -145],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_2,
                offset: [49, -141],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_1,
                offset: [-159, -159],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_1,
                offset: [-125, -159],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_1,
                offset: [-141, -173],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_2,
                offset: [-141, -158],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_2,
                offset: [-111, -157],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_1,
                offset: [-114, -138],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_1,
                offset: [-80, -138],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_1,
                offset: [-96, -152],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_2,
                offset: [-96, -137],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_2,
                offset: [-66, -136],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_1,
                offset: [-61, -121],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_1,
                offset: [-27, -121],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_1,
                offset: [-44, -136],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_2,
                offset: [-44, -120],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_2,
                offset: [-13, -116],
            },
        ],
    ], almonds_almondOrchard4: [
        [
            {
                id: IdAssetBundleBuildings.almond_orchard_blossom_1,
                offset: [-87, -225],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_blossom_1,
                offset: [-70, -210],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_blossom_1,
                offset: [-52, -207],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_blossom_1,
                offset: [-104, -205],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_blossom_1,
                offset: [-87, -209],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_blossom_1,
                offset: [-65, -220],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_blossom_1,
                offset: [-35, -193],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_blossom_1,
                offset: [-18, -179],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_blossom_1,
                offset: [0, -176],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_blossom_1,
                offset: [-52, -173],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_blossom_1,
                offset: [-34, -178],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_blossom_1,
                offset: [-12, -188],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_blossom_1,
                offset: [28, -156],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_blossom_1,
                offset: [44, -142],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_blossom_1,
                offset: [62, -139],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_blossom_1,
                offset: [10, -136],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_blossom_1,
                offset: [28, -141],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_blossom_1,
                offset: [50, -151],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_blossom_1,
                offset: [-149, -182],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_blossom_1,
                offset: [-132, -167],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_blossom_1,
                offset: [-114, -165],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_blossom_1,
                offset: [-166, -162],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_blossom_1,
                offset: [-149, -166],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_blossom_1,
                offset: [-127, -177],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_blossom_1,
                offset: [-94, -155],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_blossom_1,
                offset: [-77, -141],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_blossom_1,
                offset: [-59, -138],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_blossom_1,
                offset: [-111, -135],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_blossom_1,
                offset: [-94, -140],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_blossom_1,
                offset: [-72, -151],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_blossom_1,
                offset: [-37, -129],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_blossom_1,
                offset: [-20, -114],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_blossom_1,
                offset: [-2, -111],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_blossom_1,
                offset: [-54, -109],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_blossom_1,
                offset: [-37, -113],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_blossom_1,
                offset: [-15, -124],
            },
        ],
        [
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_1,
                offset: [-104, -206],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_1,
                offset: [-70, -209],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_1,
                offset: [-87, -226],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_1,
                offset: [-64, -220],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_2,
                offset: [-87, -210],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_2,
                offset: [-52, -207],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_1,
                offset: [-53, -172],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_1,
                offset: [-19, -176],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_1,
                offset: [-36, -192],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_1,
                offset: [-12, -186],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_2,
                offset: [-35, -176],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_2,
                offset: [-1, -173],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_1,
                offset: [10, -136],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_1,
                offset: [44, -139],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_1,
                offset: [27, -156],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_1,
                offset: [51, -150],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_2,
                offset: [28, -140],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_2,
                offset: [63, -137],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_1,
                offset: [-167, -163],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_1,
                offset: [-133, -166],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_1,
                offset: [-150, -182],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_1,
                offset: [-126, -176],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_2,
                offset: [-149, -167],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_2,
                offset: [-114, -164],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_1,
                offset: [-112, -137],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_1,
                offset: [-78, -140],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_1,
                offset: [-95, -157],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_1,
                offset: [-71, -151],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_2,
                offset: [-94, -141],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_2,
                offset: [-59, -138],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_1,
                offset: [-55, -109],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_1,
                offset: [-21, -112],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_1,
                offset: [-38, -129],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_1,
                offset: [-14, -123],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_2,
                offset: [-37, -113],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_2,
                offset: [-3, -110],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_1,
                offset: [-147, -102],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_1,
                offset: [-134, -99],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_2,
                offset: [-141, -106],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_2,
                offset: [-129, -103],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_2,
                offset: [-141, -98],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_2,
                offset: [-137, -99],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_1,
                offset: [-135, -105],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_1,
                offset: [-144, -101],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_1,
                offset: [-137, -104],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_1,
                offset: [-131, -98],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_1,
                offset: [66, -115],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_1,
                offset: [79, -112],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_2,
                offset: [72, -119],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_2,
                offset: [84, -116],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_2,
                offset: [72, -111],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_2,
                offset: [76, -112],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_1,
                offset: [78, -118],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_1,
                offset: [69, -114],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_1,
                offset: [76, -117],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_1,
                offset: [82, -111],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_1,
                offset: [-65, -64],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_1,
                offset: [-52, -60],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_2,
                offset: [-59, -67],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_2,
                offset: [-48, -64],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_2,
                offset: [-59, -60],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_2,
                offset: [-56, -61],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_1,
                offset: [-54, -66],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_1,
                offset: [-62, -62],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_1,
                offset: [-55, -65],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_1,
                offset: [-50, -60],
            },
        ],
    ], almonds_almondOrchard5: [
        [
            {
                id: IdAssetBundleBuildings.almond_orchard_blossom_1,
                offset: [-61, -229],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_blossom_1,
                offset: [-45, -215],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_blossom_1,
                offset: [-27, -212],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_blossom_1,
                offset: [-79, -209],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_blossom_1,
                offset: [-61, -214],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_blossom_1,
                offset: [-39, -225],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_blossom_1,
                offset: [-8, -206],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_blossom_1,
                offset: [8, -192],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_blossom_1,
                offset: [26, -189],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_blossom_1,
                offset: [-26, -186],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_blossom_1,
                offset: [-8, -191],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_blossom_1,
                offset: [14, -202],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_blossom_1,
                offset: [53, -176],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_blossom_1,
                offset: [70, -162],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_blossom_1,
                offset: [88, -159],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_blossom_1,
                offset: [36, -156],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_blossom_1,
                offset: [53, -161],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_blossom_1,
                offset: [75, -171],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_blossom_1,
                offset: [-107, -189],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_blossom_1,
                offset: [-90, -175],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_blossom_1,
                offset: [-72, -172],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_blossom_1,
                offset: [-124, -169],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_blossom_1,
                offset: [-107, -174],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_blossom_1,
                offset: [-85, -185],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_blossom_1,
                offset: [-52, -163],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_blossom_1,
                offset: [-35, -148],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_blossom_1,
                offset: [-17, -145],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_blossom_1,
                offset: [-69, -143],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_blossom_1,
                offset: [-52, -147],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_blossom_1,
                offset: [-30, -158],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_blossom_1,
                offset: [7, -142],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_blossom_1,
                offset: [24, -128],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_blossom_1,
                offset: [42, -125],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_blossom_1,
                offset: [-10, -122],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_blossom_1,
                offset: [8, -127],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_blossom_1,
                offset: [30, -138],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_blossom_1,
                offset: [-171, -173],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_blossom_1,
                offset: [-155, -159],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_blossom_1,
                offset: [-137, -156],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_blossom_1,
                offset: [-189, -153],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_blossom_1,
                offset: [-171, -158],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_blossom_1,
                offset: [-149, -168],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_blossom_1,
                offset: [-110, -142],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_blossom_1,
                offset: [-94, -127],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_blossom_1,
                offset: [-76, -124],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_blossom_1,
                offset: [-128, -122],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_blossom_1,
                offset: [-110, -126],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_blossom_1,
                offset: [-88, -137],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_blossom_1,
                offset: [-55, -114],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_blossom_1,
                offset: [-38, -99],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_blossom_1,
                offset: [-20, -96],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_blossom_1,
                offset: [-72, -94],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_blossom_1,
                offset: [-54, -98],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_blossom_1,
                offset: [-32, -109],
            },
        ],
        [
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_1,
                offset: [-78, -209],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_1,
                offset: [-44, -212],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_1,
                offset: [-61, -229],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_1,
                offset: [-38, -223],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_2,
                offset: [-61, -213],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_2,
                offset: [-26, -210],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_1,
                offset: [-26, -189],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_1,
                offset: [8, -193],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_1,
                offset: [-9, -209],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_1,
                offset: [15, -203],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_2,
                offset: [-8, -193],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_2,
                offset: [26, -190],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_1,
                offset: [35, -156],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_1,
                offset: [69, -160],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_1,
                offset: [52, -176],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_1,
                offset: [76, -170],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_2,
                offset: [53, -160],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_2,
                offset: [88, -157],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_1,
                offset: [-124, -171],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_1,
                offset: [-90, -174],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_1,
                offset: [-107, -191],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_1,
                offset: [-84, -185],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_2,
                offset: [-107, -175],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_2,
                offset: [-72, -172],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_1,
                offset: [-69, -145],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_1,
                offset: [-35, -148],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_1,
                offset: [-52, -165],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_1,
                offset: [-29, -159],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_2,
                offset: [-52, -149],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_2,
                offset: [-17, -146],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_1,
                offset: [-9, -124],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_1,
                offset: [25, -127],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_1,
                offset: [8, -144],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_1,
                offset: [32, -138],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_2,
                offset: [9, -128],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_2,
                offset: [44, -125],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_1,
                offset: [-189, -154],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_1,
                offset: [-156, -157],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_1,
                offset: [-172, -173],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_1,
                offset: [-149, -167],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_2,
                offset: [-172, -158],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_2,
                offset: [-137, -155],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_1,
                offset: [-128, -122],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_1,
                offset: [-94, -126],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_1,
                offset: [-111, -142],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_1,
                offset: [-88, -136],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_2,
                offset: [-111, -126],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_2,
                offset: [-76, -123],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_1,
                offset: [-72, -94],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_1,
                offset: [-38, -98],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_1,
                offset: [-55, -114],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_1,
                offset: [-31, -108],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_2,
                offset: [-54, -98],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_2,
                offset: [-20, -95],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_1,
                offset: [-143, -100],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_1,
                offset: [-130, -96],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_2,
                offset: [-137, -103],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_2,
                offset: [-125, -100],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_2,
                offset: [-137, -96],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_2,
                offset: [-133, -97],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_1,
                offset: [-131, -102],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_1,
                offset: [-140, -98],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_1,
                offset: [-133, -101],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_1,
                offset: [-127, -96],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_1,
                offset: [73, -115],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_1,
                offset: [86, -112],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_2,
                offset: [79, -119],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_2,
                offset: [90, -116],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_2,
                offset: [79, -111],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_2,
                offset: [82, -112],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_1,
                offset: [84, -118],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_1,
                offset: [76, -114],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_1,
                offset: [83, -117],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_1,
                offset: [88, -111],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_1,
                offset: [-30, -62],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_1,
                offset: [-17, -58],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_2,
                offset: [-24, -65],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_2,
                offset: [-12, -62],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_2,
                offset: [-24, -58],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_2,
                offset: [-20, -59],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_1,
                offset: [-18, -64],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_1,
                offset: [-27, -60],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_1,
                offset: [-20, -63],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_1,
                offset: [-14, -58],
            },
        ],
    ], almonds_almondOrchard6: [
        [
            {
                id: IdAssetBundleBuildings.almond_orchard_blossom_1,
                offset: [-50, -233],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_blossom_1,
                offset: [-38, -219],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_blossom_1,
                offset: [-15, -216],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_blossom_1,
                offset: [-67, -213],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_blossom_1,
                offset: [-49, -210],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_blossom_1,
                offset: [-27, -229],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_blossom_1,
                offset: [1, -212],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_blossom_1,
                offset: [13, -197],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_blossom_1,
                offset: [36, -194],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_blossom_1,
                offset: [-16, -192],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_blossom_1,
                offset: [2, -188],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_blossom_1,
                offset: [24, -207],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_blossom_1,
                offset: [51, -182],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_blossom_1,
                offset: [63, -168],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_blossom_1,
                offset: [87, -165],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_blossom_1,
                offset: [35, -163],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_blossom_1,
                offset: [52, -159],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_blossom_1,
                offset: [74, -178],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_blossom_1,
                offset: [-113, -207],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_blossom_1,
                offset: [-101, -193],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_blossom_1,
                offset: [-77, -190],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_blossom_1,
                offset: [-129, -187],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_blossom_1,
                offset: [-112, -183],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_blossom_1,
                offset: [-90, -202],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_blossom_1,
                offset: [-57, -180],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_blossom_1,
                offset: [-45, -166],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_blossom_1,
                offset: [-22, -163],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_blossom_1,
                offset: [-74, -160],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_blossom_1,
                offset: [-56, -157],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_blossom_1,
                offset: [-34, -175],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_blossom_1,
                offset: [-1, -153],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_blossom_1,
                offset: [11, -139],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_blossom_1,
                offset: [34, -136],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_blossom_1,
                offset: [-18, -133],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_blossom_1,
                offset: [0, -130],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_blossom_1,
                offset: [22, -149],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_blossom_1,
                offset: [-170, -175],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_blossom_1,
                offset: [-159, -161],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_blossom_1,
                offset: [-135, -158],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_blossom_1,
                offset: [-187, -155],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_blossom_1,
                offset: [-169, -152],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_blossom_1,
                offset: [-148, -170],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_blossom_1,
                offset: [-107, -148],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_blossom_1,
                offset: [-95, -133],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_blossom_1,
                offset: [-72, -130],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_blossom_1,
                offset: [-124, -128],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_blossom_1,
                offset: [-106, -124],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_blossom_1,
                offset: [-84, -143],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_blossom_1,
                offset: [-59, -126],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_blossom_1,
                offset: [-47, -111],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_blossom_1,
                offset: [-24, -108],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_blossom_1,
                offset: [-76, -106],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_blossom_1,
                offset: [-58, -102],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_blossom_1,
                offset: [-36, -121],
            },
        ],
        [
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_1,
                offset: [-67, -212],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_1,
                offset: [-37, -218],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_1,
                offset: [-51, -232],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_1,
                offset: [-27, -229],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_2,
                offset: [-50, -210],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_2,
                offset: [-15, -215],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_1,
                offset: [-17, -188],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_1,
                offset: [13, -194],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_1,
                offset: [0, -208],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_1,
                offset: [23, -205],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_2,
                offset: [0, -186],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_2,
                offset: [36, -191],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_1,
                offset: [36, -157],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_1,
                offset: [66, -163],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_1,
                offset: [52, -177],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_1,
                offset: [76, -174],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_2,
                offset: [53, -155],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_2,
                offset: [88, -161],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_1,
                offset: [-130, -182],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_1,
                offset: [-100, -189],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_1,
                offset: [-113, -203],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_1,
                offset: [-89, -199],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_2,
                offset: [-113, -181],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_2,
                offset: [-77, -186],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_1,
                offset: [-73, -159],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_1,
                offset: [-43, -165],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_1,
                offset: [-56, -179],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_1,
                offset: [-32, -175],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_2,
                offset: [-56, -157],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_2,
                offset: [-20, -162],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_1,
                offset: [-18, -129],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_1,
                offset: [12, -136],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_1,
                offset: [-1, -150],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_1,
                offset: [22, -146],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_2,
                offset: [-1, -128],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_2,
                offset: [35, -133],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_1,
                offset: [-185, -153],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_1,
                offset: [-156, -160],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_1,
                offset: [-169, -174],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_1,
                offset: [-145, -170],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_2,
                offset: [-168, -152],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_2,
                offset: [-133, -157],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_1,
                offset: [-123, -126],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_1,
                offset: [-93, -133],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_1,
                offset: [-107, -147],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_1,
                offset: [-83, -143],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_2,
                offset: [-106, -125],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_2,
                offset: [-71, -130],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_1,
                offset: [-76, -104],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_1,
                offset: [-46, -111],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_1,
                offset: [-59, -125],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_1,
                offset: [-35, -121],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_2,
                offset: [-59, -103],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_2,
                offset: [-23, -108],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_1,
                offset: [-124, -93],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_1,
                offset: [-111, -89],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_2,
                offset: [-118, -96],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_2,
                offset: [-107, -93],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_2,
                offset: [-118, -89],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_2,
                offset: [-115, -90],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_1,
                offset: [-113, -95],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_1,
                offset: [-121, -91],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_1,
                offset: [-114, -94],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_1,
                offset: [-109, -89],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_1,
                offset: [40, -93],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_1,
                offset: [53, -90],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_2,
                offset: [46, -96],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_2,
                offset: [57, -94],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_2,
                offset: [46, -89],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_2,
                offset: [49, -90],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_1,
                offset: [51, -96],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_1,
                offset: [43, -92],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_1,
                offset: [50, -94],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_1,
                offset: [55, -89],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_1,
                offset: [-20, -64],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_1,
                offset: [-7, -60],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_2,
                offset: [-14, -67],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_2,
                offset: [-2, -64],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_2,
                offset: [-14, -60],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_2,
                offset: [-10, -61],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_1,
                offset: [-8, -66],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_1,
                offset: [-17, -62],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_1,
                offset: [-10, -65],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_1,
                offset: [-4, -60],
            },
        ],
    ], almonds_almondOrchard7: [
        [
            {
                id: IdAssetBundleBuildings.almond_orchard_blossom_1,
                offset: [-47, -247],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_blossom_1,
                offset: [-35, -233],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_blossom_1,
                offset: [-12, -230],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_blossom_1,
                offset: [-64, -227],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_blossom_1,
                offset: [-46, -223],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_blossom_1,
                offset: [-24, -242],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_blossom_1,
                offset: [4, -225],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_blossom_1,
                offset: [16, -211],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_blossom_1,
                offset: [39, -208],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_blossom_1,
                offset: [-13, -205],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_blossom_1,
                offset: [5, -202],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_blossom_1,
                offset: [27, -221],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_blossom_1,
                offset: [54, -196],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_blossom_1,
                offset: [66, -182],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_blossom_1,
                offset: [90, -179],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_blossom_1,
                offset: [38, -176],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_blossom_1,
                offset: [55, -172],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_blossom_1,
                offset: [77, -191],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_blossom_1,
                offset: [-110, -221],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_blossom_1,
                offset: [-98, -206],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_blossom_1,
                offset: [-74, -203],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_blossom_1,
                offset: [-126, -201],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_blossom_1,
                offset: [-109, -197],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_blossom_1,
                offset: [-87, -216],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_blossom_1,
                offset: [-54, -194],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_blossom_1,
                offset: [-42, -179],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_blossom_1,
                offset: [-19, -176],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_blossom_1,
                offset: [-71, -174],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_blossom_1,
                offset: [-53, -170],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_blossom_1,
                offset: [-31, -189],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_blossom_1,
                offset: [2, -167],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_blossom_1,
                offset: [14, -153],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_blossom_1,
                offset: [37, -150],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_blossom_1,
                offset: [-15, -147],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_blossom_1,
                offset: [3, -143],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_blossom_1,
                offset: [25, -162],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_blossom_1,
                offset: [-167, -189],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_blossom_1,
                offset: [-156, -174],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_blossom_1,
                offset: [-132, -171],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_blossom_1,
                offset: [-184, -169],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_blossom_1,
                offset: [-167, -165],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_blossom_1,
                offset: [-145, -184],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_blossom_1,
                offset: [-104, -161],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_blossom_1,
                offset: [-92, -147],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_blossom_1,
                offset: [-69, -144],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_blossom_1,
                offset: [-121, -141],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_blossom_1,
                offset: [-103, -138],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_blossom_1,
                offset: [-81, -157],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_blossom_1,
                offset: [-56, -139],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_blossom_1,
                offset: [-44, -125],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_blossom_1,
                offset: [-21, -122],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_blossom_1,
                offset: [-73, -119],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_blossom_1,
                offset: [-55, -116],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_blossom_1,
                offset: [-33, -135],
            },
        ],
        [
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_1,
                offset: [-65, -225],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_1,
                offset: [-35, -232],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_1,
                offset: [-49, -246],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_1,
                offset: [-25, -242],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_2,
                offset: [-48, -224],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_2,
                offset: [-13, -229],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_1,
                offset: [-15, -201],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_1,
                offset: [15, -208],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_1,
                offset: [2, -222],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_1,
                offset: [25, -218],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_2,
                offset: [2, -200],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_2,
                offset: [38, -205],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_1,
                offset: [38, -170],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_1,
                offset: [68, -177],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_1,
                offset: [54, -191],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_1,
                offset: [78, -187],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_2,
                offset: [55, -169],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_2,
                offset: [90, -174],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_1,
                offset: [-128, -196],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_1,
                offset: [-98, -202],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_1,
                offset: [-111, -217],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_1,
                offset: [-87, -213],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_2,
                offset: [-111, -194],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_2,
                offset: [-75, -200],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_1,
                offset: [-71, -172],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_1,
                offset: [-41, -178],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_1,
                offset: [-54, -193],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_1,
                offset: [-30, -189],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_2,
                offset: [-54, -170],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_2,
                offset: [-18, -176],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_1,
                offset: [-16, -143],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_1,
                offset: [14, -149],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_1,
                offset: [1, -164],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_1,
                offset: [24, -160],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_2,
                offset: [1, -141],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_2,
                offset: [37, -147],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_1,
                offset: [-183, -167],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_1,
                offset: [-154, -173],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_1,
                offset: [-167, -187],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_1,
                offset: [-143, -184],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_2,
                offset: [-167, -165],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_2,
                offset: [-131, -170],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_1,
                offset: [-121, -140],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_1,
                offset: [-91, -146],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_1,
                offset: [-105, -161],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_1,
                offset: [-81, -157],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_2,
                offset: [-104, -138],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_2,
                offset: [-69, -144],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_1,
                offset: [-74, -118],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_1,
                offset: [-44, -124],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_1,
                offset: [-57, -139],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_1,
                offset: [-33, -135],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_2,
                offset: [-57, -116],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_2,
                offset: [-21, -122],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_1,
                offset: [-126, -108],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_1,
                offset: [-113, -105],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_2,
                offset: [-120, -112],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_2,
                offset: [-109, -109],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_2,
                offset: [-120, -104],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_2,
                offset: [-117, -105],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_1,
                offset: [-115, -111],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_1,
                offset: [-123, -107],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_1,
                offset: [-116, -110],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_1,
                offset: [-111, -104],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_1,
                offset: [38, -108],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_1,
                offset: [51, -104],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_2,
                offset: [44, -111],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_2,
                offset: [55, -108],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_2,
                offset: [44, -104],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_2,
                offset: [47, -105],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_1,
                offset: [49, -110],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_1,
                offset: [41, -106],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_1,
                offset: [48, -109],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_1,
                offset: [53, -104],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_1,
                offset: [-22, -78],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_1,
                offset: [-9, -75],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_2,
                offset: [-16, -82],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_2,
                offset: [-4, -79],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_2,
                offset: [-16, -74],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_2,
                offset: [-12, -75],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_1,
                offset: [-10, -81],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_1,
                offset: [-19, -77],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_1,
                offset: [-12, -80],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_1,
                offset: [-6, -74],
            },
        ],
    ], almonds_freeRangeAlmondOrchard1: [
        [
            {
                id: IdAssetBundleBuildings.almond_orchard_blossom_1,
                offset: [-67, -275],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_blossom_1,
                offset: [-51, -261],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_blossom_1,
                offset: [-87, -254],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_blossom_1,
                offset: [-65, -246],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_blossom_1,
                offset: [-29, -246],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_blossom_1,
                offset: [-38, -276],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_blossom_1,
                offset: [-27, -196],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_blossom_1,
                offset: [-11, -183],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_blossom_1,
                offset: [-56, -175],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_blossom_1,
                offset: [-34, -172],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_blossom_1,
                offset: [19, -170],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_blossom_1,
                offset: [1, -197],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_blossom_1,
                offset: [45, -248],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_blossom_1,
                offset: [61, -219],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_blossom_1,
                offset: [-3, -237],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_blossom_1,
                offset: [21, -225],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_blossom_1,
                offset: [92, -206],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_blossom_1,
                offset: [74, -234],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_blossom_1,
                offset: [23, -246],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_blossom_1,
                offset: [-150, -239],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_blossom_1,
                offset: [-134, -225],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_blossom_1,
                offset: [-181, -194],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_blossom_1,
                offset: [-170, -221],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_blossom_1,
                offset: [-82, -215],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_blossom_1,
                offset: [-100, -225],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_blossom_1,
                offset: [-114, -236],
            },
        ],
        [
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_1,
                offset: [-87, -254],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_1,
                offset: [-27, -245],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_1,
                offset: [-54, -259],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_1,
                offset: [-67, -273],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_2,
                offset: [-63, -245],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_2,
                offset: [-39, -273],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_1,
                offset: [20, -167],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_1,
                offset: [-54, -175],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_1,
                offset: [-14, -185],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_1,
                offset: [-29, -196],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_2,
                offset: [0, -197],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_2,
                offset: [-31, -173],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_1,
                offset: [92, -204],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_1,
                offset: [-3, -236],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_1,
                offset: [72, -233],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_1,
                offset: [43, -247],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_1,
                offset: [23, -245],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_2,
                offset: [61, -218],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_2,
                offset: [21, -223],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_1,
                offset: [-81, -214],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_1,
                offset: [-170, -223],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_1,
                offset: [-101, -227],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_1,
                offset: [-114, -237],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_1,
                offset: [-150, -238],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_1,
                offset: [-181, -193],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_2,
                offset: [-134, -224],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_2,
                offset: [-152, -216],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_1,
                offset: [-135, -141],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_1,
                offset: [-120, -112],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_1,
                offset: [-107, -130],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_1,
                offset: [-36, -91],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_1,
                offset: [15, -142],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_2,
                offset: [-1, -112],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_2,
                offset: [52, -141],
            },
        ],
    ], almonds_freeRangeAlmondOrchard2: [
        [
            {
                id: IdAssetBundleBuildings.almond_orchard_blossom_1,
                offset: [-67, -275],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_blossom_1,
                offset: [-51, -261],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_blossom_1,
                offset: [-87, -254],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_blossom_1,
                offset: [-65, -246],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_blossom_1,
                offset: [-29, -246],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_blossom_1,
                offset: [-38, -276],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_blossom_1,
                offset: [-27, -196],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_blossom_1,
                offset: [-11, -183],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_blossom_1,
                offset: [-56, -175],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_blossom_1,
                offset: [-34, -172],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_blossom_1,
                offset: [19, -170],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_blossom_1,
                offset: [1, -197],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_blossom_1,
                offset: [45, -248],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_blossom_1,
                offset: [61, -219],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_blossom_1,
                offset: [-3, -237],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_blossom_1,
                offset: [21, -225],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_blossom_1,
                offset: [92, -206],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_blossom_1,
                offset: [74, -234],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_blossom_1,
                offset: [23, -246],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_blossom_1,
                offset: [-150, -239],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_blossom_1,
                offset: [-134, -225],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_blossom_1,
                offset: [-181, -194],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_blossom_1,
                offset: [-170, -221],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_blossom_1,
                offset: [-82, -215],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_blossom_1,
                offset: [-100, -225],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_blossom_1,
                offset: [-114, -236],
            },
        ],
        [
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_1,
                offset: [-87, -254],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_1,
                offset: [-27, -245],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_1,
                offset: [-54, -259],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_1,
                offset: [-67, -273],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_2,
                offset: [-63, -245],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_2,
                offset: [-39, -273],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_1,
                offset: [20, -167],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_1,
                offset: [-54, -175],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_1,
                offset: [-14, -185],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_1,
                offset: [-29, -196],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_2,
                offset: [0, -197],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_2,
                offset: [-31, -173],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_1,
                offset: [92, -204],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_1,
                offset: [-3, -236],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_1,
                offset: [72, -233],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_1,
                offset: [43, -247],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_1,
                offset: [23, -245],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_2,
                offset: [61, -218],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_2,
                offset: [21, -223],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_1,
                offset: [-81, -214],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_1,
                offset: [-170, -223],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_1,
                offset: [-101, -227],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_1,
                offset: [-114, -237],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_1,
                offset: [-150, -238],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_1,
                offset: [-181, -193],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_2,
                offset: [-134, -224],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_2,
                offset: [-152, -216],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_1,
                offset: [-135, -141],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_1,
                offset: [-120, -112],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_1,
                offset: [-107, -130],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_1,
                offset: [-36, -91],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_1,
                offset: [15, -142],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_2,
                offset: [-1, -112],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_2,
                offset: [52, -141],
            },
        ],
    ], almonds_freeRangeAlmondOrchard3: [
        [
            {
                id: IdAssetBundleBuildings.almond_orchard_blossom_1,
                offset: [-67, -275],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_blossom_1,
                offset: [-51, -261],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_blossom_1,
                offset: [-87, -254],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_blossom_1,
                offset: [-65, -246],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_blossom_1,
                offset: [-29, -246],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_blossom_1,
                offset: [-38, -276],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_blossom_1,
                offset: [-27, -196],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_blossom_1,
                offset: [-11, -183],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_blossom_1,
                offset: [-56, -175],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_blossom_1,
                offset: [-34, -172],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_blossom_1,
                offset: [19, -170],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_blossom_1,
                offset: [1, -197],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_blossom_1,
                offset: [45, -248],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_blossom_1,
                offset: [61, -219],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_blossom_1,
                offset: [-3, -237],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_blossom_1,
                offset: [21, -225],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_blossom_1,
                offset: [92, -206],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_blossom_1,
                offset: [74, -234],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_blossom_1,
                offset: [23, -246],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_blossom_1,
                offset: [-150, -239],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_blossom_1,
                offset: [-134, -225],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_blossom_1,
                offset: [-181, -194],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_blossom_1,
                offset: [-170, -221],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_blossom_1,
                offset: [-82, -215],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_blossom_1,
                offset: [-100, -225],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_blossom_1,
                offset: [-114, -236],
            },
        ],
        [
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_1,
                offset: [-87, -254],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_1,
                offset: [-27, -245],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_1,
                offset: [-54, -259],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_1,
                offset: [-67, -273],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_2,
                offset: [-63, -245],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_2,
                offset: [-39, -273],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_1,
                offset: [20, -167],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_1,
                offset: [-54, -175],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_1,
                offset: [-14, -185],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_1,
                offset: [-29, -196],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_2,
                offset: [0, -197],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_2,
                offset: [-31, -173],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_1,
                offset: [92, -204],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_1,
                offset: [-3, -236],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_1,
                offset: [72, -233],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_1,
                offset: [43, -247],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_1,
                offset: [23, -245],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_2,
                offset: [61, -218],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_2,
                offset: [21, -223],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_1,
                offset: [-81, -214],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_1,
                offset: [-170, -223],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_1,
                offset: [-101, -227],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_1,
                offset: [-114, -237],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_1,
                offset: [-150, -238],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_1,
                offset: [-181, -193],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_2,
                offset: [-134, -224],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_2,
                offset: [-152, -216],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_1,
                offset: [-135, -141],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_1,
                offset: [-120, -112],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_1,
                offset: [-107, -130],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_1,
                offset: [-36, -91],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_1,
                offset: [15, -142],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_2,
                offset: [-1, -112],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_2,
                offset: [52, -141],
            },
        ],
    ], almonds_freeRangeAlmondOrchard4: [
        [
            {
                id: IdAssetBundleBuildings.almond_orchard_blossom_1,
                offset: [-67, -275],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_blossom_1,
                offset: [-51, -261],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_blossom_1,
                offset: [-87, -254],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_blossom_1,
                offset: [-65, -246],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_blossom_1,
                offset: [-29, -246],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_blossom_1,
                offset: [-38, -276],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_blossom_1,
                offset: [-27, -196],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_blossom_1,
                offset: [-11, -183],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_blossom_1,
                offset: [-56, -175],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_blossom_1,
                offset: [-34, -172],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_blossom_1,
                offset: [19, -170],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_blossom_1,
                offset: [1, -197],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_blossom_1,
                offset: [45, -248],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_blossom_1,
                offset: [61, -219],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_blossom_1,
                offset: [-3, -237],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_blossom_1,
                offset: [21, -225],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_blossom_1,
                offset: [92, -206],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_blossom_1,
                offset: [74, -234],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_blossom_1,
                offset: [23, -246],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_blossom_1,
                offset: [-150, -239],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_blossom_1,
                offset: [-134, -225],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_blossom_1,
                offset: [-181, -194],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_blossom_1,
                offset: [-170, -221],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_blossom_1,
                offset: [-82, -215],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_blossom_1,
                offset: [-100, -225],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_blossom_1,
                offset: [-114, -236],
            },
        ],
        [
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_1,
                offset: [-87, -254],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_1,
                offset: [-27, -245],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_1,
                offset: [-54, -259],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_1,
                offset: [-67, -273],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_2,
                offset: [-63, -245],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_2,
                offset: [-39, -273],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_1,
                offset: [20, -167],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_1,
                offset: [-54, -175],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_1,
                offset: [-14, -185],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_1,
                offset: [-29, -196],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_2,
                offset: [0, -197],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_2,
                offset: [-31, -173],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_1,
                offset: [92, -204],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_1,
                offset: [-3, -236],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_1,
                offset: [72, -233],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_1,
                offset: [43, -247],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_1,
                offset: [23, -245],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_2,
                offset: [61, -218],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_2,
                offset: [21, -223],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_1,
                offset: [-81, -214],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_1,
                offset: [-170, -223],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_1,
                offset: [-101, -227],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_1,
                offset: [-114, -237],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_1,
                offset: [-150, -238],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_1,
                offset: [-181, -193],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_2,
                offset: [-134, -224],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_2,
                offset: [-152, -216],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_1,
                offset: [-135, -141],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_1,
                offset: [-120, -112],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_1,
                offset: [-107, -130],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_1,
                offset: [-36, -91],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_1,
                offset: [15, -142],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_2,
                offset: [-1, -112],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_2,
                offset: [52, -141],
            },
        ],
    ], almonds_freeRangeAlmondOrchard5: [
        [
            {
                id: IdAssetBundleBuildings.almond_orchard_blossom_1,
                offset: [-67, -275],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_blossom_1,
                offset: [-51, -261],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_blossom_1,
                offset: [-87, -254],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_blossom_1,
                offset: [-65, -246],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_blossom_1,
                offset: [-29, -246],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_blossom_1,
                offset: [-38, -276],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_blossom_1,
                offset: [-27, -196],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_blossom_1,
                offset: [-11, -183],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_blossom_1,
                offset: [-56, -175],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_blossom_1,
                offset: [-34, -172],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_blossom_1,
                offset: [19, -170],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_blossom_1,
                offset: [1, -197],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_blossom_1,
                offset: [45, -248],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_blossom_1,
                offset: [61, -219],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_blossom_1,
                offset: [-3, -237],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_blossom_1,
                offset: [21, -225],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_blossom_1,
                offset: [92, -206],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_blossom_1,
                offset: [74, -234],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_blossom_1,
                offset: [23, -246],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_blossom_1,
                offset: [-150, -239],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_blossom_1,
                offset: [-134, -225],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_blossom_1,
                offset: [-181, -194],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_blossom_1,
                offset: [-170, -221],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_blossom_1,
                offset: [-82, -215],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_blossom_1,
                offset: [-100, -225],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_blossom_1,
                offset: [-114, -236],
            },
        ],
        [
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_1,
                offset: [-87, -254],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_1,
                offset: [-27, -245],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_1,
                offset: [-54, -259],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_1,
                offset: [-67, -273],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_2,
                offset: [-63, -245],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_2,
                offset: [-39, -273],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_1,
                offset: [20, -167],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_1,
                offset: [-54, -175],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_1,
                offset: [-14, -185],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_1,
                offset: [-29, -196],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_2,
                offset: [0, -197],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_2,
                offset: [-31, -173],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_1,
                offset: [92, -204],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_1,
                offset: [-3, -236],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_1,
                offset: [72, -233],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_1,
                offset: [43, -247],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_1,
                offset: [23, -245],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_2,
                offset: [61, -218],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_2,
                offset: [21, -223],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_1,
                offset: [-81, -214],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_1,
                offset: [-170, -223],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_1,
                offset: [-101, -227],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_1,
                offset: [-114, -237],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_1,
                offset: [-150, -238],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_1,
                offset: [-181, -193],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_2,
                offset: [-134, -224],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_2,
                offset: [-152, -216],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_1,
                offset: [-135, -141],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_1,
                offset: [-120, -112],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_1,
                offset: [-107, -130],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_1,
                offset: [-36, -91],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_1,
                offset: [15, -142],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_2,
                offset: [-1, -112],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_2,
                offset: [52, -141],
            },
        ],
    ], almonds_freeRangeAlmondOrchard6: [
        [
            {
                id: IdAssetBundleBuildings.almond_orchard_blossom_1,
                offset: [-67, -275],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_blossom_1,
                offset: [-51, -261],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_blossom_1,
                offset: [-87, -254],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_blossom_1,
                offset: [-65, -246],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_blossom_1,
                offset: [-29, -246],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_blossom_1,
                offset: [-38, -276],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_blossom_1,
                offset: [-27, -196],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_blossom_1,
                offset: [-11, -183],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_blossom_1,
                offset: [-56, -175],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_blossom_1,
                offset: [-34, -172],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_blossom_1,
                offset: [19, -170],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_blossom_1,
                offset: [1, -197],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_blossom_1,
                offset: [45, -248],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_blossom_1,
                offset: [61, -219],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_blossom_1,
                offset: [-3, -237],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_blossom_1,
                offset: [21, -225],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_blossom_1,
                offset: [92, -206],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_blossom_1,
                offset: [74, -234],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_blossom_1,
                offset: [23, -246],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_blossom_1,
                offset: [-150, -239],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_blossom_1,
                offset: [-134, -225],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_blossom_1,
                offset: [-181, -194],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_blossom_1,
                offset: [-170, -221],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_blossom_1,
                offset: [-82, -215],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_blossom_1,
                offset: [-100, -225],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_blossom_1,
                offset: [-114, -236],
            },
        ],
        [
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_1,
                offset: [-87, -254],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_1,
                offset: [-27, -245],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_1,
                offset: [-54, -259],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_1,
                offset: [-67, -273],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_2,
                offset: [-63, -245],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_2,
                offset: [-39, -273],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_1,
                offset: [20, -167],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_1,
                offset: [-54, -175],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_1,
                offset: [-14, -185],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_1,
                offset: [-29, -196],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_2,
                offset: [0, -197],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_2,
                offset: [-31, -173],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_1,
                offset: [92, -204],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_1,
                offset: [-3, -236],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_1,
                offset: [72, -233],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_1,
                offset: [43, -247],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_1,
                offset: [23, -245],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_2,
                offset: [61, -218],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_2,
                offset: [21, -223],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_1,
                offset: [-81, -214],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_1,
                offset: [-170, -223],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_1,
                offset: [-101, -227],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_1,
                offset: [-114, -237],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_1,
                offset: [-150, -238],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_1,
                offset: [-181, -193],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_2,
                offset: [-134, -224],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_2,
                offset: [-152, -216],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_1,
                offset: [-135, -141],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_1,
                offset: [-120, -112],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_1,
                offset: [-107, -130],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_1,
                offset: [-36, -91],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_1,
                offset: [15, -142],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_2,
                offset: [-1, -112],
            },
            {
                id: IdAssetBundleBuildings.almond_orchard_almond_2,
                offset: [52, -141],
            },
        ],
    ], apples_appleOrchard1: [
        [
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [-57, -179],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [-44, -171],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [-62, -166],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [-12, -161],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [-4, -146],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [-22, -148],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [31, -142],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [21, -132],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [38, -125],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [-27, -111],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [-37, -99],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [-21, -95],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [-73, -132],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [-79, -122],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [-63, -117],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [-110, -152],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [-121, -145],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [-103, -140],
            },
        ],
        [
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_1,
                offset: [-57, -179],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_1,
                offset: [-43, -172],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_1,
                offset: [-61, -167],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_1,
                offset: [-12, -163],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_1,
                offset: [-3, -147],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_1,
                offset: [-21, -149],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_1,
                offset: [31, -143],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_1,
                offset: [22, -134],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_1,
                offset: [37, -127],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_1,
                offset: [-27, -112],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_1,
                offset: [-21, -98],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_1,
                offset: [-36, -100],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_1,
                offset: [-72, -132],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_1,
                offset: [-79, -123],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_1,
                offset: [-62, -119],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_1,
                offset: [-109, -154],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_1,
                offset: [-120, -147],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_1,
                offset: [-103, -141],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_3,
                offset: [-104, -92],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_3,
                offset: [-111, -94],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_3,
                offset: [-106, -94],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_3,
                offset: [-99, -93],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_3,
                offset: [-94, -94],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_3,
                offset: [-106, -97],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_3,
                offset: [-98, -98],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_3,
                offset: [-102, -99],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_3,
                offset: [62, -117],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_3,
                offset: [74, -117],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_3,
                offset: [59, -122],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_3,
                offset: [76, -122],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_3,
                offset: [64, -122],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_3,
                offset: [71, -123],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_3,
                offset: [67, -126],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_3,
                offset: [67, -117],
            },
        ],
    ], apples_appleOrchard2: [
        [
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [-51, -182],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [-39, -175],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [-57, -170],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [-63, -185],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [-50, -196],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [-10, -169],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [-2, -154],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [-20, -156],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [-16, -143],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [4, -165],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [37, -146],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [27, -136],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [44, -129],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [33, -122],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [23, -148],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [-21, -118],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [-31, -106],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [-15, -102],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [-32, -92],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [-36, -120],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [-71, -141],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [-77, -131],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [-60, -126],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [-64, -110],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [-84, -121],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [-108, -157],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [-119, -151],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [-101, -145],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [-112, -134],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [-130, -142],
            },
        ],
        [
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_1,
                offset: [-51, -182],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_1,
                offset: [-39, -175],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_1,
                offset: [-57, -170],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_1,
                offset: [-63, -185],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_1,
                offset: [-50, -195],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_1,
                offset: [-10, -169],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_1,
                offset: [-2, -154],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_1,
                offset: [-20, -156],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_1,
                offset: [-16, -143],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_1,
                offset: [4, -165],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_1,
                offset: [37, -145],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_1,
                offset: [26, -135],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_1,
                offset: [43, -128],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_1,
                offset: [32, -122],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_1,
                offset: [22, -148],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_1,
                offset: [-21, -117],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_1,
                offset: [-31, -106],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_1,
                offset: [-15, -102],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_1,
                offset: [-32, -92],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_1,
                offset: [-36, -120],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_1,
                offset: [-71, -141],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_1,
                offset: [-77, -130],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_1,
                offset: [-61, -125],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_1,
                offset: [-65, -110],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_1,
                offset: [-84, -121],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_1,
                offset: [-109, -157],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_1,
                offset: [-119, -150],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_1,
                offset: [-102, -145],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_1,
                offset: [-112, -134],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_1,
                offset: [-130, -141],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_3,
                offset: [-104, -91],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_3,
                offset: [-111, -93],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_3,
                offset: [-107, -93],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_3,
                offset: [-99, -93],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_3,
                offset: [-95, -94],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_3,
                offset: [-107, -96],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_3,
                offset: [-99, -97],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_3,
                offset: [-103, -98],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_3,
                offset: [61, -117],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_3,
                offset: [74, -117],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_3,
                offset: [59, -121],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_3,
                offset: [76, -122],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_3,
                offset: [64, -122],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_3,
                offset: [71, -122],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_3,
                offset: [66, -126],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_3,
                offset: [67, -117],
            },
        ],
    ], apples_appleOrchard3: [
        [
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [-70, -198],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [-58, -191],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [-76, -186],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [-82, -201],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [-68, -212],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [-21, -178],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [-13, -164],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [-31, -166],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [-27, -153],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [-7, -175],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [47, -149],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [37, -139],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [54, -132],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [43, -126],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [33, -152],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [-16, -122],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [-27, -111],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [-11, -107],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [-27, -97],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [-32, -125],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [-74, -155],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [-80, -145],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [-63, -140],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [-67, -124],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [-86, -135],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [-121, -175],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [-131, -168],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [-114, -163],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [-124, -152],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [-142, -160],
            },
        ],
        [
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_1,
                offset: [-70, -198],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_1,
                offset: [-58, -191],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_1,
                offset: [-76, -186],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_1,
                offset: [-82, -201],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_1,
                offset: [-68, -212],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_1,
                offset: [-21, -179],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_1,
                offset: [-13, -164],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_1,
                offset: [-31, -166],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_1,
                offset: [-27, -153],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_1,
                offset: [-7, -175],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_1,
                offset: [47, -149],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_1,
                offset: [37, -139],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_1,
                offset: [54, -132],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_1,
                offset: [43, -126],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_1,
                offset: [33, -152],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_1,
                offset: [-16, -123],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_1,
                offset: [-27, -111],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_1,
                offset: [-11, -107],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_1,
                offset: [-27, -97],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_1,
                offset: [-32, -125],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_1,
                offset: [-74, -155],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_1,
                offset: [-80, -145],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_1,
                offset: [-63, -140],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_1,
                offset: [-67, -125],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_1,
                offset: [-87, -135],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_1,
                offset: [-121, -175],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_1,
                offset: [-131, -168],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_1,
                offset: [-114, -163],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_1,
                offset: [-124, -152],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_1,
                offset: [-142, -160],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_3,
                offset: [-128, -100],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_3,
                offset: [-135, -102],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_3,
                offset: [-130, -102],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_3,
                offset: [-123, -101],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_3,
                offset: [-119, -102],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_3,
                offset: [-130, -105],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_3,
                offset: [-123, -106],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_3,
                offset: [-127, -107],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_3,
                offset: [-53, -63],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_3,
                offset: [-60, -65],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_3,
                offset: [-55, -64],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_3,
                offset: [-48, -64],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_3,
                offset: [-43, -65],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_3,
                offset: [-55, -67],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_3,
                offset: [-47, -68],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_3,
                offset: [-51, -70],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_3,
                offset: [61, -117],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_3,
                offset: [74, -117],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_3,
                offset: [58, -121],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_3,
                offset: [75, -122],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_3,
                offset: [63, -121],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_3,
                offset: [71, -122],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_3,
                offset: [66, -125],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_3,
                offset: [66, -116],
            },
        ],
    ], apples_appleOrchard4: [
        [
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [-51, -214],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [-39, -206],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [-57, -201],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [-63, -217],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [-50, -227],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [-45, -195],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [3, -204],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [11, -189],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [-6, -191],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [-2, -178],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [18, -200],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [18, -176],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [64, -171],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [53, -161],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [70, -154],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [59, -148],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [49, -174],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [43, -154],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [14, -140],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [4, -129],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [20, -125],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [3, -115],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [-1, -143],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [-11, -124],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [-57, -172],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [-63, -162],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [-46, -157],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [-50, -142],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [-69, -153],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [-40, -148],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [-99, -201],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [-109, -195],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [-92, -189],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [-102, -179],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [-120, -186],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [-114, -176],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [-109, -133],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [-97, -125],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [-115, -120],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [-121, -136],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [-107, -146],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [-102, -114],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [-61, -116],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [-53, -101],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [-71, -103],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [-66, -90],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [-47, -112],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [-47, -88],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [-155, -163],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [-166, -153],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [-149, -146],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [-160, -139],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [-169, -165],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [-176, -146],
            },
        ],
        [
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_1,
                offset: [-51, -214],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_1,
                offset: [-39, -206],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_1,
                offset: [-57, -201],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_1,
                offset: [-63, -217],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_1,
                offset: [-50, -227],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_1,
                offset: [-45, -195],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_1,
                offset: [3, -204],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_1,
                offset: [11, -189],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_1,
                offset: [-6, -191],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_1,
                offset: [-2, -178],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_1,
                offset: [18, -200],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_1,
                offset: [18, -176],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_1,
                offset: [64, -171],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_1,
                offset: [53, -161],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_1,
                offset: [70, -154],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_1,
                offset: [59, -148],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_1,
                offset: [49, -174],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_1,
                offset: [43, -154],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_1,
                offset: [14, -141],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_1,
                offset: [4, -129],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_1,
                offset: [20, -125],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_1,
                offset: [3, -115],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_1,
                offset: [-1, -143],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_1,
                offset: [-11, -124],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_1,
                offset: [-57, -173],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_1,
                offset: [-63, -163],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_1,
                offset: [-46, -158],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_1,
                offset: [-50, -142],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_1,
                offset: [-69, -153],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_1,
                offset: [-40, -148],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_1,
                offset: [-99, -201],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_1,
                offset: [-109, -195],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_1,
                offset: [-92, -189],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_1,
                offset: [-102, -179],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_1,
                offset: [-120, -186],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_1,
                offset: [-114, -176],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_1,
                offset: [-109, -133],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_1,
                offset: [-97, -125],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_1,
                offset: [-115, -120],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_1,
                offset: [-121, -136],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_1,
                offset: [-107, -146],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_1,
                offset: [-102, -114],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_1,
                offset: [-61, -116],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_1,
                offset: [-53, -101],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_1,
                offset: [-71, -103],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_1,
                offset: [-66, -90],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_1,
                offset: [-47, -112],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_1,
                offset: [-47, -88],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_1,
                offset: [-155, -163],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_1,
                offset: [-166, -153],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_1,
                offset: [-149, -146],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_1,
                offset: [-160, -139],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_1,
                offset: [-169, -165],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_1,
                offset: [-176, -146],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_3,
                offset: [-124, -93],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_3,
                offset: [-131, -95],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_3,
                offset: [-127, -95],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_3,
                offset: [-119, -94],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_3,
                offset: [-115, -95],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_3,
                offset: [-127, -98],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_3,
                offset: [-119, -99],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_3,
                offset: [-123, -100],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_3,
                offset: [-9, -64],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_3,
                offset: [-16, -66],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_3,
                offset: [-12, -65],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_3,
                offset: [-4, -65],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_3,
                offset: [0, -66],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_3,
                offset: [-12, -68],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_3,
                offset: [-4, -69],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_3,
                offset: [-8, -71],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_3,
                offset: [34, -95],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_3,
                offset: [47, -95],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_3,
                offset: [31, -100],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_3,
                offset: [48, -100],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_3,
                offset: [36, -100],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_3,
                offset: [43, -101],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_3,
                offset: [39, -104],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_3,
                offset: [39, -95],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_3,
                offset: [-26, -151],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_3,
                offset: [-28, -156],
            },
        ],
    ], apples_appleOrchard5: [
        [
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [-52, -219],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [-40, -211],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [-58, -206],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [-64, -222],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [-50, -232],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [-45, -200],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [-34, -232],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [-27, -217],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [4, -206],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [12, -191],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [-6, -193],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [-2, -180],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [18, -202],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [18, -169],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [34, -178],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [34, -189],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [85, -173],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [75, -164],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [92, -157],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [81, -150],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [71, -176],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [64, -157],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [53, -142],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [54, -164],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [15, -146],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [5, -134],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [21, -130],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [4, -120],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [0, -148],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [-10, -129],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [30, -149],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [33, -118],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [-60, -178],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [-66, -168],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [-49, -163],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [-53, -148],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [-73, -159],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [-44, -154],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [-40, -175],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [-28, -154],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [-97, -209],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [-107, -203],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [-90, -197],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [-101, -187],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [-118, -194],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [-112, -184],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [-87, -174],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [-79, -188],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [-109, -136],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [-97, -128],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [-115, -123],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [-121, -139],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [-108, -149],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [-103, -117],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [-91, -143],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [-81, -124],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [-54, -117],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [-46, -102],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [-64, -104],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [-60, -91],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [-40, -120],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [-40, -89],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [-28, -107],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [-28, -92],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [-152, -168],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [-162, -159],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [-145, -152],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [-156, -145],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [-166, -171],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [-173, -152],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [-183, -162],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [-161, -183],
            },
        ],
        [
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_1,
                offset: [-52, -218],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_1,
                offset: [-40, -211],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_1,
                offset: [-58, -206],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_1,
                offset: [-64, -221],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_1,
                offset: [-50, -232],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_1,
                offset: [-45, -200],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_1,
                offset: [-27, -217],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_1,
                offset: [-34, -232],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_1,
                offset: [4, -206],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_1,
                offset: [12, -191],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_1,
                offset: [-6, -193],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_1,
                offset: [-2, -180],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_1,
                offset: [18, -202],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_1,
                offset: [18, -169],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_1,
                offset: [34, -178],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_1,
                offset: [34, -192],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_1,
                offset: [85, -173],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_1,
                offset: [75, -163],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_1,
                offset: [92, -156],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_1,
                offset: [81, -150],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_1,
                offset: [71, -176],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_1,
                offset: [64, -156],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_1,
                offset: [53, -141],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_1,
                offset: [54, -163],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_1,
                offset: [15, -146],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_1,
                offset: [5, -134],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_1,
                offset: [21, -130],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_1,
                offset: [4, -120],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_1,
                offset: [0, -148],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_1,
                offset: [-10, -129],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_1,
                offset: [30, -149],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_1,
                offset: [33, -118],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_1,
                offset: [-60, -178],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_1,
                offset: [-66, -168],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_1,
                offset: [-49, -163],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_1,
                offset: [-53, -148],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_1,
                offset: [-73, -159],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_1,
                offset: [-44, -154],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_1,
                offset: [-28, -154],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_1,
                offset: [-40, -175],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_1,
                offset: [-97, -209],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_1,
                offset: [-107, -203],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_1,
                offset: [-90, -197],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_1,
                offset: [-101, -186],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_1,
                offset: [-118, -194],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_1,
                offset: [-112, -183],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_1,
                offset: [-87, -174],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_1,
                offset: [-79, -188],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_1,
                offset: [-109, -135],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_1,
                offset: [-97, -128],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_1,
                offset: [-115, -123],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_1,
                offset: [-121, -138],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_1,
                offset: [-108, -149],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_1,
                offset: [-103, -117],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_1,
                offset: [-91, -142],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_1,
                offset: [-81, -123],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_1,
                offset: [-54, -117],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_1,
                offset: [-46, -102],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_1,
                offset: [-64, -104],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_1,
                offset: [-60, -91],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_1,
                offset: [-40, -120],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_1,
                offset: [-40, -89],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_1,
                offset: [-28, -107],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_1,
                offset: [-28, -92],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_1,
                offset: [-152, -168],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_1,
                offset: [-162, -158],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_1,
                offset: [-145, -151],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_1,
                offset: [-156, -145],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_1,
                offset: [-166, -171],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_1,
                offset: [-173, -151],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_1,
                offset: [-183, -162],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_1,
                offset: [-161, -183],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_3,
                offset: [-124, -92],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_3,
                offset: [-131, -94],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_3,
                offset: [-126, -93],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_3,
                offset: [-119, -93],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_3,
                offset: [-114, -94],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_3,
                offset: [-126, -96],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_3,
                offset: [-118, -97],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_3,
                offset: [-122, -99],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_3,
                offset: [-3, -61],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_3,
                offset: [-10, -63],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_3,
                offset: [-5, -62],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_3,
                offset: [2, -62],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_3,
                offset: [6, -63],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_3,
                offset: [-5, -65],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_3,
                offset: [2, -66],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_3,
                offset: [-2, -68],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_3,
                offset: [34, -95],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_3,
                offset: [47, -95],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_3,
                offset: [31, -100],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_3,
                offset: [48, -100],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_3,
                offset: [36, -100],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_3,
                offset: [43, -101],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_3,
                offset: [39, -104],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_3,
                offset: [39, -95],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_3,
                offset: [-19, -143],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_3,
                offset: [-24, -140],
            },
        ],
    ], apples_appleOrchard6: [
        [
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [-50, -221],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [-38, -214],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [-56, -209],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [-63, -224],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [-49, -234],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [-33, -234],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [-26, -219],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [-62, -236],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [-71, -208],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [-47, -248],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [3, -218],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [11, -203],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [-7, -205],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [-3, -192],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [17, -214],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [17, -181],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [33, -190],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [33, -201],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [-14, -180],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [-14, -191],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [82, -186],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [72, -176],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [95, -166],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [78, -163],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [68, -189],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [61, -169],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [50, -154],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [51, -176],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [74, -140],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [85, -147],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [11, -156],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [1, -145],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [17, -141],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [0, -131],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [-4, -159],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [-14, -140],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [26, -160],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [29, -128],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [13, -117],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [28, -116],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [-57, -187],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [-63, -177],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [-46, -172],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [-50, -157],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [-69, -167],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [-40, -163],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [-37, -184],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [-25, -163],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [-103, -219],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [-113, -213],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [-96, -207],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [-106, -196],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [-124, -204],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [-118, -193],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [-93, -184],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [-84, -198],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [-109, -180],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [-115, -143],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [-95, -144],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [-130, -139],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [-119, -154],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [-105, -164],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [-100, -132],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [-89, -158],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [-78, -139],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [-128, -121],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [-106, -113],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [-90, -121],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [-55, -132],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [-47, -117],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [-65, -119],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [-60, -106],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [-41, -135],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [-41, -104],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [-28, -122],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [-29, -107],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [-24, -92],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [-50, -89],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [-69, -92],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [-156, -178],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [-166, -168],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [-149, -161],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [-160, -155],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [-170, -181],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [-177, -161],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [-187, -172],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [-165, -193],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [-174, -146],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [-141, -180],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [-148, -143],
            },
        ],
        [
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_1,
                offset: [-50, -221],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_1,
                offset: [-38, -214],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_1,
                offset: [-56, -209],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_1,
                offset: [-63, -224],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_1,
                offset: [-49, -234],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_1,
                offset: [-26, -219],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_1,
                offset: [-33, -234],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_1,
                offset: [-47, -248],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_1,
                offset: [-71, -208],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_1,
                offset: [-62, -236],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_1,
                offset: [3, -218],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_1,
                offset: [11, -203],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_1,
                offset: [-7, -205],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_1,
                offset: [-3, -192],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_1,
                offset: [17, -214],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_1,
                offset: [17, -181],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_1,
                offset: [33, -190],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_1,
                offset: [33, -204],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_1,
                offset: [-14, -180],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_1,
                offset: [-14, -194],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_1,
                offset: [82, -186],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_1,
                offset: [72, -176],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_1,
                offset: [95, -166],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_1,
                offset: [78, -163],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_1,
                offset: [68, -189],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_1,
                offset: [61, -169],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_1,
                offset: [50, -154],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_1,
                offset: [51, -176],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_1,
                offset: [74, -140],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_1,
                offset: [85, -147],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_1,
                offset: [11, -157],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_1,
                offset: [1, -145],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_1,
                offset: [17, -141],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_1,
                offset: [0, -131],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_1,
                offset: [-4, -159],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_1,
                offset: [-14, -140],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_1,
                offset: [26, -160],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_1,
                offset: [29, -129],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_1,
                offset: [28, -117],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_1,
                offset: [13, -118],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_1,
                offset: [-57, -188],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_1,
                offset: [-63, -177],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_1,
                offset: [-46, -172],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_1,
                offset: [-50, -157],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_1,
                offset: [-69, -168],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_1,
                offset: [-40, -163],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_1,
                offset: [-25, -163],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_1,
                offset: [-37, -184],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_1,
                offset: [-103, -219],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_1,
                offset: [-113, -213],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_1,
                offset: [-96, -207],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_1,
                offset: [-106, -196],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_1,
                offset: [-124, -204],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_1,
                offset: [-118, -193],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_1,
                offset: [-93, -184],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_1,
                offset: [-84, -198],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_1,
                offset: [-109, -180],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_1,
                offset: [-115, -143],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_1,
                offset: [-95, -144],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_1,
                offset: [-130, -139],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_1,
                offset: [-119, -154],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_1,
                offset: [-105, -164],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_1,
                offset: [-100, -132],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_1,
                offset: [-89, -158],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_1,
                offset: [-78, -139],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_1,
                offset: [-106, -113],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_1,
                offset: [-90, -121],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_1,
                offset: [-128, -121],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_1,
                offset: [-55, -132],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_1,
                offset: [-47, -117],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_1,
                offset: [-65, -119],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_1,
                offset: [-60, -106],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_1,
                offset: [-41, -135],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_1,
                offset: [-41, -104],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_1,
                offset: [-28, -122],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_1,
                offset: [-29, -107],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_1,
                offset: [-24, -92],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_1,
                offset: [-69, -92],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_1,
                offset: [-50, -89],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_1,
                offset: [-156, -178],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_1,
                offset: [-166, -168],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_1,
                offset: [-149, -161],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_1,
                offset: [-160, -155],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_1,
                offset: [-170, -181],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_1,
                offset: [-177, -161],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_1,
                offset: [-187, -172],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_1,
                offset: [-165, -193],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_1,
                offset: [-174, -146],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_1,
                offset: [-141, -180],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_1,
                offset: [-148, -143],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_3,
                offset: [-144, -95],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_3,
                offset: [-151, -97],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_3,
                offset: [-146, -97],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_3,
                offset: [-139, -96],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_3,
                offset: [-135, -97],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_3,
                offset: [-146, -100],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_3,
                offset: [-139, -101],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_3,
                offset: [-143, -102],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_3,
                offset: [-3, -64],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_3,
                offset: [-10, -66],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_3,
                offset: [-5, -65],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_3,
                offset: [2, -65],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_3,
                offset: [7, -66],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_3,
                offset: [-5, -68],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_3,
                offset: [3, -69],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_3,
                offset: [-1, -71],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_3,
                offset: [-14, -65],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_3,
                offset: [-10, -72],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_3,
                offset: [42, -95],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_3,
                offset: [55, -95],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_3,
                offset: [39, -99],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_3,
                offset: [56, -100],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_3,
                offset: [44, -100],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_3,
                offset: [52, -100],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_3,
                offset: [47, -104],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_3,
                offset: [47, -94],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_3,
                offset: [62, -95],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_3,
                offset: [65, -100],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_3,
                offset: [56, -106],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_3,
                offset: [-69, -70],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_3,
                offset: [-76, -72],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_3,
                offset: [-72, -72],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_3,
                offset: [-64, -72],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_3,
                offset: [-60, -73],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_3,
                offset: [-72, -75],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_3,
                offset: [-64, -76],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_3,
                offset: [-68, -77],
            },
        ],
    ], apples_appleOrchard7: [
        [
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [-47, -255],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [-35, -248],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [-53, -243],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [-59, -258],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [-45, -268],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [-29, -268],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [-22, -253],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [-59, -270],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [-67, -242],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [-43, -282],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [8, -251],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [16, -236],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [-1, -238],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [3, -225],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [23, -247],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [23, -214],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [38, -223],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [38, -234],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [-8, -213],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [-8, -224],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [90, -211],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [80, -202],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [103, -191],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [86, -188],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [76, -214],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [69, -194],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [58, -179],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [59, -201],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [82, -166],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [93, -172],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [21, -189],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [11, -178],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [27, -174],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [10, -164],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [5, -192],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [-4, -173],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [35, -193],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [38, -162],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [23, -151],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [37, -150],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [-48, -219],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [-54, -208],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [-37, -203],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [-41, -188],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [-61, -199],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [-32, -194],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [-28, -215],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [-16, -194],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [-92, -248],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [-102, -242],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [-85, -236],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [-96, -226],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [-113, -233],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [-107, -223],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [-82, -213],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [-74, -227],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [-98, -209],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [-107, -168],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [-87, -169],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [-123, -164],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [-111, -179],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [-98, -189],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [-93, -158],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [-81, -183],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [-71, -164],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [-121, -147],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [-99, -138],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [-82, -147],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [-47, -157],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [-39, -142],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [-57, -144],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [-53, -131],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [-33, -160],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [-33, -129],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [-21, -147],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [-21, -132],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [-17, -117],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [-43, -114],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [-61, -117],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [-148, -203],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [-159, -194],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [-142, -186],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [-153, -180],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [-163, -206],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [-169, -186],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [-179, -197],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [-158, -218],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [-167, -171],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [-133, -205],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [-140, -168],
            },
        ],
        [
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_1,
                offset: [-46, -255],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_1,
                offset: [-34, -248],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_1,
                offset: [-52, -243],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_1,
                offset: [-58, -258],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_1,
                offset: [-44, -268],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_1,
                offset: [-21, -253],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_1,
                offset: [-28, -268],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_1,
                offset: [-42, -282],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_1,
                offset: [-66, -242],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_1,
                offset: [-58, -270],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_1,
                offset: [7, -252],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_1,
                offset: [15, -237],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_1,
                offset: [-2, -239],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_1,
                offset: [2, -226],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_1,
                offset: [22, -248],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_1,
                offset: [22, -215],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_1,
                offset: [37, -224],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_1,
                offset: [37, -238],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_1,
                offset: [-9, -214],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_1,
                offset: [-9, -228],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_1,
                offset: [91, -211],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_1,
                offset: [81, -202],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_1,
                offset: [104, -191],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_1,
                offset: [87, -188],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_1,
                offset: [77, -214],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_1,
                offset: [70, -194],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_1,
                offset: [59, -179],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_1,
                offset: [60, -201],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_1,
                offset: [83, -166],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_1,
                offset: [94, -172],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_1,
                offset: [22, -189],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_1,
                offset: [12, -178],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_1,
                offset: [28, -173],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_1,
                offset: [11, -163],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_1,
                offset: [6, -191],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_1,
                offset: [-3, -172],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_1,
                offset: [36, -192],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_1,
                offset: [39, -161],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_1,
                offset: [38, -149],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_1,
                offset: [24, -150],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_1,
                offset: [-48, -220],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_1,
                offset: [-54, -210],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_1,
                offset: [-37, -205],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_1,
                offset: [-41, -189],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_1,
                offset: [-61, -200],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_1,
                offset: [-32, -195],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_1,
                offset: [-16, -195],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_1,
                offset: [-28, -216],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_1,
                offset: [-91, -250],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_1,
                offset: [-101, -244],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_1,
                offset: [-84, -238],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_1,
                offset: [-95, -228],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_1,
                offset: [-112, -235],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_1,
                offset: [-106, -225],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_1,
                offset: [-81, -215],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_1,
                offset: [-73, -229],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_1,
                offset: [-97, -211],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_1,
                offset: [-106, -168],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_1,
                offset: [-86, -169],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_1,
                offset: [-122, -164],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_1,
                offset: [-110, -179],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_1,
                offset: [-97, -189],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_1,
                offset: [-92, -158],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_1,
                offset: [-80, -183],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_1,
                offset: [-70, -164],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_1,
                offset: [-98, -138],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_1,
                offset: [-81, -147],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_1,
                offset: [-120, -147],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_1,
                offset: [-46, -157],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_1,
                offset: [-38, -142],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_1,
                offset: [-56, -144],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_1,
                offset: [-52, -131],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_1,
                offset: [-32, -160],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_1,
                offset: [-32, -129],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_1,
                offset: [-20, -147],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_1,
                offset: [-20, -132],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_1,
                offset: [-16, -117],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_1,
                offset: [-60, -117],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_1,
                offset: [-42, -114],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_1,
                offset: [-147, -203],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_1,
                offset: [-158, -194],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_1,
                offset: [-141, -186],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_1,
                offset: [-152, -180],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_1,
                offset: [-162, -206],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_1,
                offset: [-168, -186],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_1,
                offset: [-178, -197],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_1,
                offset: [-157, -218],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_1,
                offset: [-166, -171],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_1,
                offset: [-132, -205],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_1,
                offset: [-139, -168],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_3,
                offset: [-128, -102],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_3,
                offset: [-135, -104],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_3,
                offset: [-130, -103],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_3,
                offset: [-123, -103],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_3,
                offset: [-118, -104],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_3,
                offset: [-130, -106],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_3,
                offset: [-122, -107],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_3,
                offset: [-126, -109],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_3,
                offset: [4, -71],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_3,
                offset: [-3, -73],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_3,
                offset: [2, -73],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_3,
                offset: [9, -73],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_3,
                offset: [13, -74],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_3,
                offset: [2, -76],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_3,
                offset: [9, -77],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_3,
                offset: [5, -78],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_3,
                offset: [-8, -73],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_3,
                offset: [-3, -79],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_3,
                offset: [48, -106],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_3,
                offset: [61, -106],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_3,
                offset: [45, -110],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_3,
                offset: [62, -111],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_3,
                offset: [50, -110],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_3,
                offset: [57, -111],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_3,
                offset: [53, -114],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_3,
                offset: [53, -104],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_3,
                offset: [68, -105],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_3,
                offset: [71, -111],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_3,
                offset: [62, -117],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_3,
                offset: [-62, -79],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_3,
                offset: [-69, -81],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_3,
                offset: [-64, -81],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_3,
                offset: [-57, -80],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_3,
                offset: [-52, -81],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_3,
                offset: [-64, -84],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_3,
                offset: [-56, -85],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_3,
                offset: [-60, -86],
            },
        ],
    ], apples_freeRangeAppleOrchard1: [
        [
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [-169, -167],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [-181, -186],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [-165, -204],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [-150, -188],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [-125, -185],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [-137, -210],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [-141, -227],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [-113, -207],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [-104, -180],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [-43, -122],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [-60, -138],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [-46, -156],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [-28, -139],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [-8, -130],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [-14, -153],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [-26, -167],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [6, -153],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [14, -132],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [-84, -229],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [-95, -244],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [-80, -263],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [-67, -247],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [-43, -241],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [-48, -262],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [-60, -277],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [-29, -262],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [-5, -205],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [-19, -216],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [-6, -234],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [12, -215],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [34, -204],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [29, -223],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [13, -247],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [43, -233],
            },
        ],
        [
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_1,
                offset: [-179, -186],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_3,
                offset: [-170, -168],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_1,
                offset: [-165, -204],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_3,
                offset: [-151, -189],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_1,
                offset: [-141, -228],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_3,
                offset: [-136, -210],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_1,
                offset: [-112, -208],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_3,
                offset: [-126, -186],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_1,
                offset: [-102, -180],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_1,
                offset: [-60, -139],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_3,
                offset: [-43, -122],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_1,
                offset: [-45, -157],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_3,
                offset: [-29, -138],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_1,
                offset: [-25, -168],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_3,
                offset: [-14, -154],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_1,
                offset: [7, -153],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_3,
                offset: [-7, -132],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_1,
                offset: [17, -133],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_1,
                offset: [-95, -245],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_3,
                offset: [-84, -229],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_1,
                offset: [-80, -263],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_3,
                offset: [-66, -248],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_1,
                offset: [-60, -277],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_3,
                offset: [-49, -265],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_1,
                offset: [-28, -263],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_3,
                offset: [-43, -242],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_1,
                offset: [-19, -216],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_3,
                offset: [-3, -204],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_1,
                offset: [-4, -234],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_3,
                offset: [11, -216],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_1,
                offset: [13, -248],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_3,
                offset: [29, -224],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_1,
                offset: [44, -233],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_3,
                offset: [33, -204],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_3,
                offset: [-137, -130],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_3,
                offset: [-132, -121],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_3,
                offset: [-118, -125],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_3,
                offset: [-77, -174],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_3,
                offset: [-88, -157],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_3,
                offset: [-80, -159],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_3,
                offset: [-17, -83],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_3,
                offset: [-46, -91],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_3,
                offset: [50, -103],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_3,
                offset: [56, -110],
            },
        ],
    ], apples_freeRangeAppleOrchard2: [
        [
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [-169, -167],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [-181, -186],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [-165, -204],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [-150, -188],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [-125, -185],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [-137, -210],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [-141, -227],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [-113, -207],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [-104, -180],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [-43, -122],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [-60, -138],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [-46, -156],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [-28, -139],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [-8, -130],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [-14, -153],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [-26, -167],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [6, -153],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [14, -132],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [-84, -229],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [-95, -244],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [-80, -263],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [-67, -247],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [-43, -241],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [-48, -262],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [-60, -277],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [-29, -262],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [-5, -205],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [-19, -216],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [-6, -234],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [12, -215],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [34, -204],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [29, -223],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [13, -247],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [43, -233],
            },
        ],
        [
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_1,
                offset: [-179, -186],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_3,
                offset: [-170, -168],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_1,
                offset: [-165, -204],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_3,
                offset: [-151, -189],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_1,
                offset: [-141, -228],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_3,
                offset: [-136, -210],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_1,
                offset: [-112, -208],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_3,
                offset: [-126, -186],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_1,
                offset: [-102, -180],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_1,
                offset: [-60, -139],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_3,
                offset: [-43, -122],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_1,
                offset: [-45, -157],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_3,
                offset: [-29, -138],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_1,
                offset: [-25, -168],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_3,
                offset: [-14, -154],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_1,
                offset: [7, -153],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_3,
                offset: [-7, -132],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_1,
                offset: [17, -133],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_1,
                offset: [-95, -245],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_3,
                offset: [-84, -229],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_1,
                offset: [-80, -263],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_3,
                offset: [-66, -248],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_1,
                offset: [-60, -277],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_3,
                offset: [-49, -265],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_1,
                offset: [-28, -263],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_3,
                offset: [-43, -242],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_1,
                offset: [-19, -216],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_3,
                offset: [-3, -204],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_1,
                offset: [-4, -234],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_3,
                offset: [11, -216],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_1,
                offset: [13, -248],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_3,
                offset: [29, -224],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_1,
                offset: [44, -233],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_3,
                offset: [33, -204],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_3,
                offset: [-137, -130],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_3,
                offset: [-132, -121],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_3,
                offset: [-118, -125],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_3,
                offset: [-77, -174],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_3,
                offset: [-88, -157],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_3,
                offset: [-80, -159],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_3,
                offset: [-17, -83],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_3,
                offset: [-46, -91],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_3,
                offset: [50, -103],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_3,
                offset: [56, -110],
            },
        ],
    ], apples_freeRangeAppleOrchard3: [
        [
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [-169, -167],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [-181, -186],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [-165, -204],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [-150, -188],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [-125, -185],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [-137, -210],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [-141, -227],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [-113, -207],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [-104, -180],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [-43, -122],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [-60, -138],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [-46, -156],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [-28, -139],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [-8, -130],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [-14, -153],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [-26, -167],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [6, -153],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [14, -132],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [-84, -229],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [-95, -244],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [-80, -263],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [-67, -247],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [-43, -241],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [-48, -262],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [-60, -277],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [-29, -262],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [-5, -205],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [-19, -216],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [-6, -234],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [12, -215],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [34, -204],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [29, -223],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [13, -247],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [43, -233],
            },
        ],
        [
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_1,
                offset: [-179, -186],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_3,
                offset: [-170, -168],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_1,
                offset: [-165, -204],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_3,
                offset: [-151, -189],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_1,
                offset: [-141, -228],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_3,
                offset: [-136, -210],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_1,
                offset: [-112, -208],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_3,
                offset: [-126, -186],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_1,
                offset: [-102, -180],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_1,
                offset: [-60, -139],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_3,
                offset: [-43, -122],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_1,
                offset: [-45, -157],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_3,
                offset: [-29, -138],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_1,
                offset: [-25, -168],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_3,
                offset: [-14, -154],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_1,
                offset: [7, -153],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_3,
                offset: [-7, -132],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_1,
                offset: [17, -133],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_1,
                offset: [-95, -245],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_3,
                offset: [-84, -229],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_1,
                offset: [-80, -263],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_3,
                offset: [-66, -248],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_1,
                offset: [-60, -277],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_3,
                offset: [-49, -265],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_1,
                offset: [-28, -263],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_3,
                offset: [-43, -242],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_1,
                offset: [-19, -216],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_3,
                offset: [-3, -204],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_1,
                offset: [-4, -234],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_3,
                offset: [11, -216],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_1,
                offset: [13, -248],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_3,
                offset: [29, -224],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_1,
                offset: [44, -233],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_3,
                offset: [33, -204],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_3,
                offset: [-137, -130],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_3,
                offset: [-132, -121],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_3,
                offset: [-118, -125],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_3,
                offset: [-77, -174],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_3,
                offset: [-88, -157],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_3,
                offset: [-80, -159],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_3,
                offset: [-17, -83],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_3,
                offset: [-46, -91],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_3,
                offset: [50, -103],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_3,
                offset: [56, -110],
            },
        ],
    ], apples_freeRangeAppleOrchard4: [
        [
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [-169, -167],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [-181, -186],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [-165, -204],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [-150, -188],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [-125, -185],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [-137, -210],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [-141, -227],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [-113, -207],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [-104, -180],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [-43, -122],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [-60, -138],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [-46, -156],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [-28, -139],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [-8, -130],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [-14, -153],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [-26, -167],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [6, -153],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [14, -132],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [-84, -229],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [-95, -244],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [-80, -263],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [-67, -247],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [-43, -241],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [-48, -262],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [-60, -277],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [-29, -262],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [-5, -205],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [-19, -216],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [-6, -234],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [12, -215],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [34, -204],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [29, -223],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [13, -247],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [43, -233],
            },
        ],
        [
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_1,
                offset: [-179, -186],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_3,
                offset: [-170, -168],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_1,
                offset: [-165, -204],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_3,
                offset: [-151, -189],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_1,
                offset: [-141, -228],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_3,
                offset: [-136, -210],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_1,
                offset: [-112, -208],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_3,
                offset: [-126, -186],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_1,
                offset: [-102, -180],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_1,
                offset: [-60, -139],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_3,
                offset: [-43, -122],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_1,
                offset: [-45, -157],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_3,
                offset: [-29, -138],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_1,
                offset: [-25, -168],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_3,
                offset: [-14, -154],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_1,
                offset: [7, -153],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_3,
                offset: [-7, -132],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_1,
                offset: [17, -133],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_1,
                offset: [-95, -245],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_3,
                offset: [-84, -229],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_1,
                offset: [-80, -263],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_3,
                offset: [-66, -248],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_1,
                offset: [-60, -277],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_3,
                offset: [-49, -265],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_1,
                offset: [-28, -263],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_3,
                offset: [-43, -242],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_1,
                offset: [-19, -216],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_3,
                offset: [-3, -204],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_1,
                offset: [-4, -234],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_3,
                offset: [11, -216],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_1,
                offset: [13, -248],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_3,
                offset: [29, -224],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_1,
                offset: [44, -233],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_3,
                offset: [33, -204],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_3,
                offset: [-137, -130],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_3,
                offset: [-132, -121],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_3,
                offset: [-118, -125],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_3,
                offset: [-77, -174],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_3,
                offset: [-88, -157],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_3,
                offset: [-80, -159],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_3,
                offset: [-17, -83],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_3,
                offset: [-46, -91],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_3,
                offset: [50, -103],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_3,
                offset: [56, -110],
            },
        ],
    ], apples_freeRangeAppleOrchard5: [
        [
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [-169, -167],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [-181, -186],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [-165, -204],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [-150, -188],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [-125, -185],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [-137, -210],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [-141, -227],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [-113, -207],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [-104, -180],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [-43, -122],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [-60, -138],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [-46, -156],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [-28, -139],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [-8, -130],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [-14, -153],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [-26, -167],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [6, -153],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [14, -132],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [-84, -229],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [-95, -244],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [-80, -263],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [-67, -247],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [-43, -241],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [-48, -262],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [-60, -277],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [-29, -262],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [-5, -205],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [-19, -216],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [-6, -234],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [12, -215],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [34, -204],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [29, -223],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [13, -247],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [43, -233],
            },
        ],
        [
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_1,
                offset: [-179, -186],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_3,
                offset: [-170, -168],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_1,
                offset: [-165, -204],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_3,
                offset: [-151, -189],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_1,
                offset: [-141, -228],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_3,
                offset: [-136, -210],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_1,
                offset: [-112, -208],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_3,
                offset: [-126, -186],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_1,
                offset: [-102, -180],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_1,
                offset: [-60, -139],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_3,
                offset: [-43, -122],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_1,
                offset: [-45, -157],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_3,
                offset: [-29, -138],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_1,
                offset: [-25, -168],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_3,
                offset: [-14, -154],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_1,
                offset: [7, -153],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_3,
                offset: [-7, -132],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_1,
                offset: [17, -133],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_1,
                offset: [-95, -245],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_3,
                offset: [-84, -229],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_1,
                offset: [-80, -263],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_3,
                offset: [-66, -248],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_1,
                offset: [-60, -277],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_3,
                offset: [-49, -265],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_1,
                offset: [-28, -263],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_3,
                offset: [-43, -242],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_1,
                offset: [-19, -216],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_3,
                offset: [-3, -204],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_1,
                offset: [-4, -234],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_3,
                offset: [11, -216],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_1,
                offset: [13, -248],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_3,
                offset: [29, -224],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_1,
                offset: [44, -233],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_3,
                offset: [33, -204],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_3,
                offset: [-137, -130],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_3,
                offset: [-132, -121],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_3,
                offset: [-118, -125],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_3,
                offset: [-77, -174],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_3,
                offset: [-88, -157],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_3,
                offset: [-80, -159],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_3,
                offset: [-17, -83],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_3,
                offset: [-46, -91],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_3,
                offset: [50, -103],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_3,
                offset: [56, -110],
            },
        ],
    ], apples_freeRangeAppleOrchard6: [
        [
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [-169, -167],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [-181, -186],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [-165, -204],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [-150, -188],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [-125, -185],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [-137, -210],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [-141, -227],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [-113, -207],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [-104, -180],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [-43, -122],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [-60, -138],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [-46, -156],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [-28, -139],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [-8, -130],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [-14, -153],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [-26, -167],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [6, -153],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [14, -132],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [-84, -229],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [-95, -244],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [-80, -263],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [-67, -247],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [-43, -241],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [-48, -262],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [-60, -277],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [-29, -262],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [-5, -205],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [-19, -216],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [-6, -234],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [12, -215],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [34, -204],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [29, -223],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [13, -247],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_blossom_1,
                offset: [43, -233],
            },
        ],
        [
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_1,
                offset: [-179, -186],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_3,
                offset: [-170, -168],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_1,
                offset: [-165, -204],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_3,
                offset: [-151, -189],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_1,
                offset: [-141, -228],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_3,
                offset: [-136, -210],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_1,
                offset: [-112, -208],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_3,
                offset: [-126, -186],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_1,
                offset: [-102, -180],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_1,
                offset: [-60, -139],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_3,
                offset: [-43, -122],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_1,
                offset: [-45, -157],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_3,
                offset: [-29, -138],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_1,
                offset: [-25, -168],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_3,
                offset: [-14, -154],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_1,
                offset: [7, -153],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_3,
                offset: [-7, -132],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_1,
                offset: [17, -133],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_1,
                offset: [-95, -245],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_3,
                offset: [-84, -229],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_1,
                offset: [-80, -263],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_3,
                offset: [-66, -248],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_1,
                offset: [-60, -277],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_3,
                offset: [-49, -265],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_1,
                offset: [-28, -263],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_3,
                offset: [-43, -242],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_1,
                offset: [-19, -216],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_3,
                offset: [-3, -204],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_1,
                offset: [-4, -234],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_3,
                offset: [11, -216],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_1,
                offset: [13, -248],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_3,
                offset: [29, -224],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_1,
                offset: [44, -233],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_3,
                offset: [33, -204],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_3,
                offset: [-137, -130],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_3,
                offset: [-132, -121],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_3,
                offset: [-118, -125],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_3,
                offset: [-77, -174],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_3,
                offset: [-88, -157],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_3,
                offset: [-80, -159],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_3,
                offset: [-17, -83],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_3,
                offset: [-46, -91],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_3,
                offset: [50, -103],
            },
            {
                id: IdAssetBundleBuildings.apple_orchard_apples_3,
                offset: [56, -110],
            },
        ],
    ], cherries_cherryOrchard1: [
        [
            {
                id: IdAssetBundleBuildings.bloom_cherry1,
                offset: [-21, -93],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry2,
                offset: [-33, -87],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry1,
                offset: [-25, -82],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry1,
                offset: [-30, -96],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry1,
                offset: [-20, -86],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry1,
                offset: [-65, -117],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry1,
                offset: [-70, -101],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry2,
                offset: [-62, -108],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry1,
                offset: [-74, -110],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry1,
                offset: [-115, -125],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry2,
                offset: [-100, -131],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry1,
                offset: [-102, -124],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry1,
                offset: [-109, -133],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry2,
                offset: [-104, -138],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry1,
                offset: [-51, -168],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry1,
                offset: [-53, -153],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry2,
                offset: [-47, -161],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry1,
                offset: [-60, -161],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry1,
                offset: [-13, -131],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry2,
                offset: [-20, -138],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry1,
                offset: [-8, -139],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry1,
                offset: [-12, -145],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry1,
                offset: [-19, -146],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry1,
                offset: [36, -125],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry1,
                offset: [36, -113],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry2,
                offset: [27, -124],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry1,
                offset: [24, -113],
            },
        ],
        [
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-29, -96],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-21, -93],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-34, -87],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-26, -83],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-21, -87],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-65, -117],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-74, -111],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-61, -107],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-71, -102],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-109, -133],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-99, -131],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-112, -126],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-103, -125],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-104, -138],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-50, -168],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-46, -161],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-59, -162],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-54, -153],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-8, -139],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-14, -132],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-21, -138],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-12, -145],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-20, -146],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [28, -124],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [37, -125],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [25, -114],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [35, -114],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-169, -115],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-171, -117],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-164, -116],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-171, -120],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-164, -121],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-168, -122],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry3,
                offset: [-183, -105],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-154, -99],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry2,
                offset: [-164, -102],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry3,
                offset: [-154, -109],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry3,
                offset: [59, -99],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [66, -97],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry2,
                offset: [77, -110],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry3,
                offset: [70, -102],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [62, -114],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [58, -115],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [67, -114],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [59, -118],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [67, -119],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [63, -120],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [69, -117],
            },
        ],
    ], cherries_cherryOrchard2: [
        [
            {
                id: IdAssetBundleBuildings.bloom_cherry1,
                offset: [45, -132],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry1,
                offset: [40, -120],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry2,
                offset: [32, -133],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry1,
                offset: [29, -123],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry2,
                offset: [22, -130],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry1,
                offset: [31, -141],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry1,
                offset: [-11, -143],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry2,
                offset: [-18, -150],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry1,
                offset: [-2, -152],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry1,
                offset: [-6, -161],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry1,
                offset: [-16, -158],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry1,
                offset: [0, -143],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry1,
                offset: [-47, -182],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry1,
                offset: [-48, -163],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry2,
                offset: [-43, -171],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry1,
                offset: [-56, -170],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry2,
                offset: [-58, -180],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry1,
                offset: [-36, -174],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry1,
                offset: [-97, -140],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry2,
                offset: [-114, -131],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry1,
                offset: [-98, -131],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry1,
                offset: [-107, -143],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry2,
                offset: [-101, -152],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry1,
                offset: [-117, -145],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry1,
                offset: [-63, -128],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry1,
                offset: [-69, -111],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry2,
                offset: [-54, -119],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry1,
                offset: [-67, -120],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry2,
                offset: [-80, -116],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry1,
                offset: [-71, -130],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry1,
                offset: [-24, -107],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry2,
                offset: [-35, -102],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry1,
                offset: [-23, -90],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry1,
                offset: [-16, -109],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry1,
                offset: [-13, -98],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry1,
                offset: [-26, -98],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry1,
                offset: [-31, -91],
            },
        ],
        [
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [63, -115],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [59, -116],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [68, -115],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [60, -118],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [68, -119],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [64, -121],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [70, -117],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry3,
                offset: [61, -100],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [68, -97],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry2,
                offset: [78, -111],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry3,
                offset: [71, -103],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry3,
                offset: [-182, -106],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-153, -100],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry2,
                offset: [-163, -103],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry3,
                offset: [-153, -110],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-169, -116],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-171, -117],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-164, -117],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-171, -120],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-164, -121],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-167, -123],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [31, -141],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [45, -132],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [22, -130],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [32, -133],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [29, -123],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [40, -121],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-1, -152],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [0, -143],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-10, -143],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-6, -160],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-17, -150],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-16, -158],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-46, -182],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-37, -174],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-58, -180],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-43, -171],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-48, -163],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-55, -169],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-107, -144],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-97, -142],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-113, -131],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-99, -133],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-101, -153],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-116, -146],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-64, -128],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-79, -117],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-54, -120],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-69, -110],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-72, -130],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-67, -120],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-24, -107],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-16, -109],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-34, -102],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-25, -98],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-13, -97],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-31, -91],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-22, -89],
            },
        ],
    ], cherries_cherryOrchard3: [
        [
            {
                id: IdAssetBundleBuildings.bloom_cherry1,
                offset: [51, -131],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry1,
                offset: [46, -119],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry2,
                offset: [38, -132],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry1,
                offset: [35, -122],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry2,
                offset: [28, -129],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry1,
                offset: [37, -140],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry1,
                offset: [-14, -147],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry2,
                offset: [-21, -154],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry1,
                offset: [-6, -156],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry1,
                offset: [-10, -164],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry1,
                offset: [-20, -161],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry1,
                offset: [-3, -146],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry1,
                offset: [-58, -184],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry1,
                offset: [-59, -165],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry2,
                offset: [-54, -174],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry1,
                offset: [-67, -172],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry2,
                offset: [-69, -182],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry1,
                offset: [-46, -177],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry1,
                offset: [-105, -146],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry2,
                offset: [-122, -136],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry1,
                offset: [-106, -137],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry1,
                offset: [-115, -148],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry2,
                offset: [-109, -157],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry1,
                offset: [-126, -151],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry1,
                offset: [-60, -134],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry1,
                offset: [-66, -116],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry2,
                offset: [-51, -125],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry1,
                offset: [-64, -126],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry2,
                offset: [-77, -122],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry1,
                offset: [-68, -136],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry1,
                offset: [-18, -111],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry2,
                offset: [-29, -106],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry1,
                offset: [-17, -94],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry1,
                offset: [-10, -113],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry1,
                offset: [-7, -102],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry1,
                offset: [-20, -102],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry1,
                offset: [-25, -95],
            },
        ],
        [
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [66, -113],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [61, -113],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [70, -113],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [63, -116],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [70, -117],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [66, -118],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [73, -115],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry3,
                offset: [63, -98],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [70, -95],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry2,
                offset: [80, -108],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry3,
                offset: [73, -100],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry3,
                offset: [-180, -103],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-151, -97],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry2,
                offset: [-161, -100],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry3,
                offset: [-151, -107],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-167, -113],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-169, -114],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-162, -114],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-169, -117],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-161, -118],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-165, -120],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [37, -140],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [51, -131],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [28, -130],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [38, -133],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [35, -122],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [46, -120],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-6, -156],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-5, -146],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-14, -146],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-10, -164],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-21, -153],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-21, -161],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-57, -184],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-47, -177],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-69, -182],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-54, -173],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-59, -165],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-66, -172],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-115, -149],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-106, -147],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-121, -136],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-108, -138],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-109, -158],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-125, -152],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-60, -134],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-76, -122],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-51, -125],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-65, -116],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-69, -135],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-63, -125],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-18, -111],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-11, -113],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-28, -106],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-20, -101],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-8, -101],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-25, -94],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-17, -93],
            },
        ],
    ], cherries_cherryOrchard4: [
        [
            {
                id: IdAssetBundleBuildings.bloom_cherry1,
                offset: [-138, -147],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry1,
                offset: [-143, -130],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry2,
                offset: [-152, -148],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry1,
                offset: [-158, -135],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry2,
                offset: [-163, -145],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry1,
                offset: [-152, -159],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry1,
                offset: [-44, -89],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry2,
                offset: [-56, -89],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry1,
                offset: [-32, -94],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry1,
                offset: [-35, -103],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry1,
                offset: [-49, -100],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry1,
                offset: [-32, -85],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry1,
                offset: [-94, -127],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry1,
                offset: [-95, -108],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry2,
                offset: [-90, -117],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry1,
                offset: [-103, -115],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry2,
                offset: [-105, -125],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry1,
                offset: [-83, -120],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry1,
                offset: [20, -130],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry2,
                offset: [12, -121],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry1,
                offset: [27, -105],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry1,
                offset: [30, -128],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry1,
                offset: [33, -116],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry1,
                offset: [20, -117],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry1,
                offset: [15, -109],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry1,
                offset: [-29, -161],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry1,
                offset: [-39, -140],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry2,
                offset: [-24, -148],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry1,
                offset: [-37, -149],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry2,
                offset: [-50, -145],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry1,
                offset: [-41, -159],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry1,
                offset: [-81, -176],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry2,
                offset: [-98, -166],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry1,
                offset: [-82, -167],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry1,
                offset: [-91, -178],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry2,
                offset: [-85, -188],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry1,
                offset: [-102, -181],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry1,
                offset: [-35, -214],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry1,
                offset: [-36, -195],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry2,
                offset: [-31, -204],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry1,
                offset: [-44, -202],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry2,
                offset: [-46, -212],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry1,
                offset: [-24, -207],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry1,
                offset: [14, -169],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry2,
                offset: [7, -176],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry1,
                offset: [23, -177],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry1,
                offset: [18, -186],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry1,
                offset: [8, -183],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry1,
                offset: [25, -168],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry1,
                offset: [81, -157],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry1,
                offset: [76, -145],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry2,
                offset: [68, -158],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry1,
                offset: [65, -148],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry2,
                offset: [58, -155],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry1,
                offset: [67, -166],
            },
        ],
        [
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-152, -158],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-138, -147],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-162, -145],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-152, -148],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-158, -135],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-143, -130],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-32, -94],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-34, -85],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-43, -89],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-36, -103],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-57, -90],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-50, -100],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-94, -128],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-84, -121],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-105, -126],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-90, -117],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-96, -109],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-103, -115],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [20, -130],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [29, -127],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [11, -120],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [20, -116],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [32, -115],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [15, -109],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [27, -105],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-29, -161],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-49, -145],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-24, -148],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-38, -139],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-42, -158],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-37, -148],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-91, -178],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-82, -176],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-97, -165],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-84, -167],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-85, -187],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-101, -181],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-34, -215],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-24, -208],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-46, -213],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-31, -204],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-36, -196],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-43, -202],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [23, -177],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [24, -168],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [14, -168],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [18, -185],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [7, -175],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [8, -183],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [67, -166],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [81, -157],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [57, -155],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [68, -158],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [65, -148],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [76, -146],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-126, -98],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-129, -99],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-121, -99],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-129, -102],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-121, -103],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-125, -105],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry3,
                offset: [-139, -88],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-111, -82],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry2,
                offset: [-121, -85],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry3,
                offset: [-110, -92],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry3,
                offset: [-18, -65],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-11, -63],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry2,
                offset: [0, -76],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry3,
                offset: [-7, -68],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-15, -80],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-20, -81],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-11, -80],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-18, -84],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-10, -85],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-14, -86],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-8, -83],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [66, -96],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [64, -98],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [71, -98],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [64, -101],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [71, -102],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [67, -103],
            },
        ],
    ], cherries_cherryOrchard5: [
        [
            {
                id: IdAssetBundleBuildings.bloom_cherry1,
                offset: [85, -156],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry1,
                offset: [80, -144],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry2,
                offset: [72, -157],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry1,
                offset: [66, -143],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry2,
                offset: [61, -154],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry1,
                offset: [71, -165],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry1,
                offset: [83, -171],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry1,
                offset: [95, -149],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry1,
                offset: [91, -162],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry1,
                offset: [6, -174],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry2,
                offset: [5, -187],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry1,
                offset: [29, -194],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry1,
                offset: [18, -202],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry1,
                offset: [8, -197],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry1,
                offset: [23, -181],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry1,
                offset: [34, -172],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry1,
                offset: [16, -190],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry1,
                offset: [-32, -233],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry1,
                offset: [-32, -211],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry2,
                offset: [-17, -211],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry1,
                offset: [-43, -215],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry2,
                offset: [-42, -228],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry1,
                offset: [-20, -223],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry1,
                offset: [-56, -215],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry1,
                offset: [-47, -200],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry1,
                offset: [-87, -194],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry2,
                offset: [-104, -184],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry1,
                offset: [-88, -185],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry1,
                offset: [-97, -197],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry2,
                offset: [-92, -206],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry1,
                offset: [-108, -199],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry1,
                offset: [-78, -200],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry1,
                offset: [-70, -190],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry1,
                offset: [-78, -179],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry1,
                offset: [-30, -167],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry1,
                offset: [-40, -145],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry2,
                offset: [-25, -154],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry1,
                offset: [-38, -155],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry2,
                offset: [-51, -151],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry1,
                offset: [-43, -165],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry1,
                offset: [-29, -142],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry1,
                offset: [-16, -146],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry1,
                offset: [13, -144],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry2,
                offset: [5, -135],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry1,
                offset: [21, -119],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry1,
                offset: [23, -142],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry1,
                offset: [28, -125],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry1,
                offset: [18, -133],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry1,
                offset: [9, -124],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry1,
                offset: [34, -135],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry1,
                offset: [38, -116],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry1,
                offset: [-92, -131],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry1,
                offset: [-93, -111],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry2,
                offset: [-88, -120],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry1,
                offset: [-101, -119],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry2,
                offset: [-103, -129],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry1,
                offset: [-81, -123],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry1,
                offset: [-87, -141],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry1,
                offset: [-77, -134],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry1,
                offset: [-74, -113],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry1,
                offset: [-38, -101],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry2,
                offset: [-50, -101],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry1,
                offset: [-27, -106],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry1,
                offset: [-29, -115],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry1,
                offset: [-43, -112],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry1,
                offset: [-23, -94],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry1,
                offset: [-50, -90],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry1,
                offset: [-36, -90],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry1,
                offset: [-138, -159],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry1,
                offset: [-143, -142],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry2,
                offset: [-152, -160],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry1,
                offset: [-158, -146],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry2,
                offset: [-163, -157],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry1,
                offset: [-152, -170],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry1,
                offset: [-170, -143],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry1,
                offset: [-146, -151],
            },
        ],
        [
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [45, -101],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [43, -102],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [50, -102],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [43, -105],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [51, -106],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [47, -108],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [47, -104],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [53, -103],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [55, -103],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [54, -105],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [48, -102],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-1, -75],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-6, -76],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [3, -75],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-4, -78],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [4, -79],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [0, -81],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [6, -77],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [0, -78],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-8, -78],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry3,
                offset: [-5, -60],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [2, -57],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry2,
                offset: [13, -70],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry3,
                offset: [6, -62],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry3,
                offset: [-153, -96],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-124, -90],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry2,
                offset: [-134, -93],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry3,
                offset: [-124, -100],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-140, -106],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-142, -107],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-135, -107],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-142, -110],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-135, -111],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-139, -113],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-137, -109],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-140, -109],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-132, -110],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-137, -111],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [70, -165],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [84, -156],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [61, -154],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [71, -157],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [65, -143],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [80, -145],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [94, -149],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [91, -162],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [82, -172],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [29, -194],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [24, -182],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [8, -174],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [18, -202],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [4, -187],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [8, -197],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [16, -189],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [34, -172],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-31, -234],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-20, -223],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-42, -229],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-17, -211],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-32, -211],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-43, -215],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-47, -200],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-56, -215],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-97, -196],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-88, -194],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-103, -183],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-90, -185],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-91, -205],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-107, -199],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-78, -199],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-70, -190],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-78, -178],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-30, -167],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-50, -151],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-25, -154],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-40, -144],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-43, -164],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-38, -154],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-17, -146],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-29, -142],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [13, -144],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [22, -142],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [5, -135],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [17, -132],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [29, -124],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [8, -123],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [20, -119],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [34, -136],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [39, -116],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-92, -131],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-82, -124],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-104, -130],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-89, -120],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-94, -112],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-101, -119],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-87, -140],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-77, -134],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-73, -114],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-26, -106],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-23, -94],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-38, -101],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-30, -115],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-51, -102],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-44, -113],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-50, -90],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-37, -90],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-152, -170],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-138, -159],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-163, -157],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-152, -160],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-158, -146],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-143, -142],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-170, -142],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-146, -150],
            },
        ],
    ], cherries_cherryOrchard6: [
        [
            {
                id: IdAssetBundleBuildings.bloom_cherry1,
                offset: [-139, -170],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry1,
                offset: [-145, -153],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry2,
                offset: [-153, -170],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry1,
                offset: [-160, -157],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry2,
                offset: [-164, -168],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry1,
                offset: [-154, -181],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry1,
                offset: [-171, -153],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry1,
                offset: [-147, -161],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry1,
                offset: [-181, -161],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry1,
                offset: [-173, -176],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry1,
                offset: [-43, -114],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry2,
                offset: [-55, -114],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry1,
                offset: [-24, -116],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry1,
                offset: [-34, -132],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry1,
                offset: [-47, -125],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry1,
                offset: [-24, -101],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry1,
                offset: [-56, -96],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry1,
                offset: [-40, -103],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry1,
                offset: [-95, -143],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry1,
                offset: [-96, -123],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry2,
                offset: [-91, -132],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry1,
                offset: [-104, -131],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry2,
                offset: [-106, -141],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry1,
                offset: [-84, -135],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry1,
                offset: [-89, -153],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry1,
                offset: [-79, -145],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry1,
                offset: [-76, -125],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry1,
                offset: [15, -155],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry2,
                offset: [7, -146],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry1,
                offset: [23, -130],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry1,
                offset: [25, -153],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry1,
                offset: [30, -135],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry1,
                offset: [20, -144],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry1,
                offset: [11, -134],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry1,
                offset: [36, -146],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry1,
                offset: [40, -127],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry1,
                offset: [-31, -186],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry1,
                offset: [-42, -164],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry2,
                offset: [-26, -173],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry1,
                offset: [-40, -174],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry2,
                offset: [-52, -170],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry1,
                offset: [-44, -184],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry1,
                offset: [-31, -161],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry1,
                offset: [-18, -165],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry1,
                offset: [-52, -152],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry1,
                offset: [-17, -154],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry1,
                offset: [-96, -198],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry2,
                offset: [-113, -188],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry1,
                offset: [-97, -188],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry1,
                offset: [-106, -200],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry2,
                offset: [-100, -213],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry1,
                offset: [-116, -202],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry1,
                offset: [-86, -203],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry1,
                offset: [-78, -193],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry1,
                offset: [-86, -182],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry1,
                offset: [-34, -241],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry1,
                offset: [-34, -219],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry2,
                offset: [-20, -219],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry1,
                offset: [-46, -223],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry2,
                offset: [-44, -236],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry1,
                offset: [-22, -231],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry1,
                offset: [-58, -223],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry1,
                offset: [-49, -208],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry1,
                offset: [6, -183],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry2,
                offset: [4, -196],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry1,
                offset: [28, -202],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry1,
                offset: [17, -210],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry1,
                offset: [8, -206],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry1,
                offset: [22, -190],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry1,
                offset: [34, -181],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry1,
                offset: [16, -198],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry1,
                offset: [80, -167],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry1,
                offset: [75, -155],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry2,
                offset: [67, -168],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry1,
                offset: [62, -154],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry2,
                offset: [57, -165],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry1,
                offset: [66, -176],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry1,
                offset: [78, -182],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry1,
                offset: [90, -160],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry1,
                offset: [86, -173],
            },
        ],
        [
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-154, -181],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-140, -169],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-164, -168],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-153, -171],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-159, -157],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-145, -153],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-172, -153],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-147, -161],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-173, -176],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-181, -160],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-23, -116],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-25, -102],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-42, -114],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-34, -131],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-55, -115],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-48, -126],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-56, -96],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-39, -103],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-95, -143],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-85, -136],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-106, -141],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-91, -132],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-97, -124],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-104, -131],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-89, -152],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-80, -146],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-76, -126],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [15, -155],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [24, -152],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [7, -145],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [19, -142],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [31, -135],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [10, -134],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [22, -130],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [36, -147],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [41, -126],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-31, -186],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-52, -170],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-27, -173],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-41, -164],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-45, -183],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-39, -173],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-18, -165],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-31, -162],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-52, -152],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-18, -153],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-106, -200],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-96, -198],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-112, -187],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-99, -189],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-100, -214],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-116, -202],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-86, -202],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-78, -193],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-86, -182],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-33, -242],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-23, -231],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-44, -237],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-19, -219],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-34, -219],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-46, -223],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-49, -208],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-58, -223],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [29, -203],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [24, -191],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [7, -182],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [18, -211],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [3, -196],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [8, -205],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [15, -198],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [34, -181],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [66, -176],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [80, -167],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [56, -165],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [67, -168],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [61, -154],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [75, -156],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [90, -160],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [87, -173],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [78, -183],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-129, -113],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-131, -115],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-125, -112],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-134, -117],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-124, -122],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-129, -120],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-125, -116],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-129, -117],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-123, -118],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-122, -111],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-126, -119],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-120, -112],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-121, -114],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-120, -115],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-126, -115],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry3,
                offset: [-134, -96],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-106, -90],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry2,
                offset: [-120, -94],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry3,
                offset: [-102, -102],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry3,
                offset: [-70, -49],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-63, -46],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry2,
                offset: [-53, -59],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry3,
                offset: [-60, -51],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-71, -71],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-63, -75],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-55, -72],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-69, -76],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-59, -72],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-60, -69],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-63, -68],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-65, -65],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-72, -74],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-68, -73],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-75, -73],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-70, -66],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-79, -71],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-73, -67],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-75, -70],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-66, -70],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-63, -70],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-64, -72],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-71, -69],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [80, -106],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [74, -109],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [83, -104],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [78, -110],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [85, -111],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [81, -113],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [78, -108],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [87, -108],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [90, -108],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [89, -110],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [82, -107],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [88, -104],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [90, -106],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [93, -108],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [95, -111],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [86, -114],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [96, -109],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [90, -113],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [82, -110],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry2,
                offset: [63, -103],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [100, -90],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-6, -68],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-12, -71],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-3, -66],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-9, -73],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-1, -73],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-5, -75],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-7, -71],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [1, -70],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [2, -69],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [4, -73],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-4, -69],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [0, -66],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [4, -67],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [7, -70],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [8, -74],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-2, -77],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [11, -71],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [4, -75],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-4, -72],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry3,
                offset: [-16, -54],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry3,
                offset: [11, -50],
            },
        ],
    ], cherries_cherryOrchard7: [
        [
            {
                id: IdAssetBundleBuildings.bloom_cherry1,
                offset: [-135, -184],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry1,
                offset: [-140, -167],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry2,
                offset: [-149, -185],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry1,
                offset: [-155, -172],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry2,
                offset: [-159, -182],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry1,
                offset: [-149, -196],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry1,
                offset: [-167, -168],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry1,
                offset: [-143, -176],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry1,
                offset: [-176, -176],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry1,
                offset: [-168, -190],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry1,
                offset: [-33, -128],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry2,
                offset: [-45, -128],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry1,
                offset: [-15, -130],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry1,
                offset: [-25, -145],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry1,
                offset: [-38, -139],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry1,
                offset: [-14, -115],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry1,
                offset: [-47, -109],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry1,
                offset: [-30, -117],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry1,
                offset: [-95, -157],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry1,
                offset: [-96, -138],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry2,
                offset: [-91, -147],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry1,
                offset: [-104, -145],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry2,
                offset: [-106, -155],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry1,
                offset: [-84, -150],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry1,
                offset: [-89, -167],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry1,
                offset: [-79, -160],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry1,
                offset: [-76, -140],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry1,
                offset: [17, -164],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry2,
                offset: [9, -155],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry1,
                offset: [25, -139],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry1,
                offset: [27, -162],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry1,
                offset: [32, -144],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry1,
                offset: [22, -153],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry1,
                offset: [13, -143],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry1,
                offset: [38, -155],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry1,
                offset: [42, -135],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry1,
                offset: [-25, -201],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry1,
                offset: [-35, -180],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry2,
                offset: [-20, -189],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry1,
                offset: [-33, -189],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry2,
                offset: [-46, -186],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry1,
                offset: [-37, -200],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry1,
                offset: [-24, -177],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry1,
                offset: [-11, -181],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry1,
                offset: [-45, -168],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry1,
                offset: [-11, -170],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry1,
                offset: [-92, -213],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry2,
                offset: [-109, -203],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry1,
                offset: [-93, -204],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry1,
                offset: [-102, -216],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry2,
                offset: [-97, -229],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry1,
                offset: [-113, -218],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry1,
                offset: [-83, -219],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry1,
                offset: [-75, -208],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry1,
                offset: [-83, -198],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry1,
                offset: [-33, -255],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry1,
                offset: [-33, -232],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry2,
                offset: [-19, -233],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry1,
                offset: [-45, -237],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry2,
                offset: [-43, -250],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry1,
                offset: [-21, -244],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry1,
                offset: [-57, -237],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry1,
                offset: [-48, -221],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry1,
                offset: [9, -197],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry2,
                offset: [7, -211],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry1,
                offset: [31, -217],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry1,
                offset: [20, -225],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry1,
                offset: [11, -220],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry1,
                offset: [25, -205],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry1,
                offset: [36, -196],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry1,
                offset: [19, -213],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry1,
                offset: [89, -179],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry1,
                offset: [84, -167],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry2,
                offset: [76, -180],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry1,
                offset: [70, -166],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry2,
                offset: [66, -177],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry1,
                offset: [75, -188],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry1,
                offset: [87, -194],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry1,
                offset: [99, -172],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry1,
                offset: [95, -185],
            },
        ],
        [
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-149, -196],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-135, -185],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-159, -183],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-148, -186],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-155, -173],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-140, -168],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-167, -168],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-143, -177],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-168, -191],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-176, -176],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-13, -129],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-14, -116],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-31, -128],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-24, -145],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-45, -129],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-38, -139],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-46, -109],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-29, -117],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-94, -158],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-84, -151],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-106, -156],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-91, -147],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-96, -139],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-103, -145],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-89, -167],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-79, -160],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-75, -140],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [17, -165],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [26, -162],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [9, -155],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [21, -152],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [33, -145],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [12, -144],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [24, -140],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [38, -156],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [42, -136],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-25, -202],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-45, -187],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-20, -189],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-34, -180],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-38, -200],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-33, -190],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-11, -182],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-24, -178],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-45, -169],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-11, -170],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-101, -215],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-92, -213],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-107, -202],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-94, -204],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-95, -230],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-111, -218],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-81, -218],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-74, -208],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-81, -197],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-32, -256],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-22, -246],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-43, -251],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-18, -234],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-33, -234],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-45, -237],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-48, -223],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-58, -238],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [31, -219],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [26, -206],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [10, -198],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [20, -226],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [6, -212],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [10, -221],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [18, -214],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [36, -197],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [76, -188],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [90, -179],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [66, -177],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [77, -180],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [71, -166],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [85, -167],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [100, -172],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [97, -185],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [88, -195],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-129, -104],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-132, -105],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-126, -103],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-134, -107],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-124, -112],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-129, -111],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-126, -106],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-130, -108],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-123, -109],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-123, -101],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-126, -109],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-120, -102],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-122, -104],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-120, -105],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-127, -105],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-120, -105],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-123, -107],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-117, -104],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-128, -109],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-113, -107],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-111, -107],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-113, -106],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-119, -112],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-122, -109],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-121, -101],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-124, -109],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-116, -105],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-118, -107],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-116, -108],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-123, -108],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-60, -82],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-52, -86],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-44, -82],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-57, -87],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-48, -83],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-49, -80],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-51, -79],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-54, -76],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-61, -85],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-56, -83],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-64, -83],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-58, -76],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-68, -82],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-62, -78],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-63, -80],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-54, -80],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-52, -80],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-53, -82],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-59, -80],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-7, -80],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-10, -82],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-4, -79],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-12, -84],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-2, -89],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-7, -87],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-4, -83],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-8, -84],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-2, -85],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-1, -78],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-4, -86],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [2, -79],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [0, -81],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [1, -82],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-5, -82],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [2, -82],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-1, -84],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [5, -81],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-6, -86],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [9, -84],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [11, -84],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [9, -82],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [3, -88],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [0, -85],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [1, -77],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-2, -85],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [6, -82],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [4, -84],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [5, -84],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-1, -85],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [61, -101],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [59, -102],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [65, -100],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [56, -104],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [66, -109],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [61, -108],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [65, -103],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [61, -105],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [67, -106],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [67, -98],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [64, -106],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [70, -99],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [68, -101],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [70, -102],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [64, -102],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [67, -113],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [67, -104],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [73, -101],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [58, -107],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [76, -107],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [73, -107],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [77, -103],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [71, -109],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [69, -106],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [65, -112],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [66, -106],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [74, -102],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [72, -104],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [74, -105],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [67, -105],
            },
        ],
    ], cherries_freeRangeCherryOrchard1: [
        [
            {
                id: IdAssetBundleBuildings.bloom_cherry1,
                offset: [-34, -276],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry2,
                offset: [-81, -269],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry1,
                offset: [-46, -260],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry1,
                offset: [-61, -281],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry1,
                offset: [-20, -257],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry1,
                offset: [-13, -241],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry2,
                offset: [-81, -249],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry2,
                offset: [-103, -261],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry2,
                offset: [-76, -223],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry2,
                offset: [-49, -220],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry2,
                offset: [-32, -245],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry2,
                offset: [-27, -243],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry2,
                offset: [-57, -280],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry2,
                offset: [-102, -225],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry2,
                offset: [-115, -238],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry1,
                offset: [67, -217],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry2,
                offset: [20, -210],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry1,
                offset: [49, -196],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry1,
                offset: [32, -217],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry1,
                offset: [81, -198],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry1,
                offset: [88, -165],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry2,
                offset: [4, -190],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry2,
                offset: [0, -190],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry2,
                offset: [31, -169],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry2,
                offset: [52, -162],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry2,
                offset: [85, -167],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry2,
                offset: [74, -185],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry2,
                offset: [33, -221],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry1,
                offset: [-122, -218],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry2,
                offset: [-173, -208],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry1,
                offset: [-147, -201],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry1,
                offset: [-141, -222],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry1,
                offset: [-101, -187],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry2,
                offset: [-185, -171],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry2,
                offset: [-189, -173],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry2,
                offset: [-153, -174],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry2,
                offset: [-137, -167],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry2,
                offset: [-104, -184],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry2,
                offset: [-116, -190],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry2,
                offset: [-156, -226],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry1,
                offset: [-16, -158],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry2,
                offset: [-67, -161],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry1,
                offset: [-34, -147],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry1,
                offset: [-28, -176],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry1,
                offset: [5, -129],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry2,
                offset: [-88, -129],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry2,
                offset: [-86, -132],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry2,
                offset: [-52, -113],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry2,
                offset: [-31, -108],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry2,
                offset: [-7, -124],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry2,
                offset: [-9, -127],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry2,
                offset: [-30, -172],
            },
        ],
        [
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-62, -281],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-57, -278],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-34, -276],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-80, -269],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-20, -257],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-13, -241],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-101, -261],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-46, -259],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-30, -246],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-28, -242],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-81, -246],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-48, -221],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-114, -238],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-78, -224],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-101, -223],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [32, -218],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [34, -222],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [67, -217],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [19, -209],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [81, -197],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [49, -196],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [75, -185],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [86, -167],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [88, -165],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [52, -163],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [32, -168],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [4, -191],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [1, -191],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-189, -172],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-185, -172],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-175, -208],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-156, -227],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-139, -223],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-122, -218],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-102, -187],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-105, -183],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-146, -201],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-155, -175],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-115, -191],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-137, -167],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-27, -177],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-32, -172],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-15, -159],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-66, -162],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-87, -131],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-88, -127],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-33, -147],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [4, -129],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-8, -127],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-7, -123],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-53, -113],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-31, -109],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-122, -113],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-122, -108],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-167, -107],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-149, -100],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-70, -64],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-27, -59],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-70, -60],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [44, -106],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [18, -105],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-78, -48],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [12, -102],
            },
        ],
    ], cherries_freeRangeCherryOrchard2: [
        [
            {
                id: IdAssetBundleBuildings.bloom_cherry1,
                offset: [-34, -276],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry2,
                offset: [-81, -269],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry1,
                offset: [-46, -260],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry1,
                offset: [-61, -281],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry1,
                offset: [-20, -257],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry1,
                offset: [-13, -241],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry2,
                offset: [-81, -249],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry2,
                offset: [-103, -261],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry2,
                offset: [-76, -223],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry2,
                offset: [-49, -220],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry2,
                offset: [-32, -245],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry2,
                offset: [-27, -243],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry2,
                offset: [-57, -280],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry2,
                offset: [-102, -225],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry2,
                offset: [-115, -238],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry1,
                offset: [67, -217],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry2,
                offset: [20, -210],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry1,
                offset: [49, -196],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry1,
                offset: [32, -217],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry1,
                offset: [81, -198],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry1,
                offset: [88, -165],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry2,
                offset: [4, -190],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry2,
                offset: [0, -190],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry2,
                offset: [31, -169],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry2,
                offset: [52, -162],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry2,
                offset: [85, -167],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry2,
                offset: [74, -185],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry2,
                offset: [33, -221],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry1,
                offset: [-122, -218],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry2,
                offset: [-173, -208],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry1,
                offset: [-147, -201],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry1,
                offset: [-141, -222],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry1,
                offset: [-101, -187],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry2,
                offset: [-185, -171],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry2,
                offset: [-189, -173],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry2,
                offset: [-153, -174],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry2,
                offset: [-137, -167],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry2,
                offset: [-104, -184],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry2,
                offset: [-116, -190],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry2,
                offset: [-156, -226],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry1,
                offset: [-16, -158],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry2,
                offset: [-67, -161],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry1,
                offset: [-34, -147],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry1,
                offset: [-28, -176],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry1,
                offset: [5, -129],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry2,
                offset: [-88, -129],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry2,
                offset: [-86, -132],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry2,
                offset: [-52, -113],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry2,
                offset: [-31, -108],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry2,
                offset: [-7, -124],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry2,
                offset: [-9, -127],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry2,
                offset: [-30, -172],
            },
        ],
        [
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-62, -281],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-57, -278],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-34, -276],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-80, -269],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-20, -257],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-13, -241],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-101, -261],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-46, -259],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-30, -246],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-28, -242],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-81, -246],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-48, -221],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-114, -238],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-78, -224],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-101, -223],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [32, -218],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [34, -222],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [67, -217],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [19, -209],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [81, -197],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [49, -196],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [75, -185],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [86, -167],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [88, -165],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [52, -163],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [32, -168],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [4, -191],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [1, -191],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-189, -172],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-185, -172],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-175, -208],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-156, -227],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-139, -223],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-122, -218],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-102, -187],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-105, -183],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-146, -201],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-155, -175],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-115, -191],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-137, -167],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-27, -177],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-32, -172],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-15, -159],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-66, -162],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-87, -131],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-88, -127],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-33, -147],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [4, -129],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-8, -127],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-7, -123],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-53, -113],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-31, -109],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-122, -113],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-122, -108],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-167, -107],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-149, -100],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-70, -64],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-27, -59],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-70, -60],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [44, -106],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [18, -105],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-78, -48],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [12, -102],
            },
        ],
    ], cherries_freeRangeCherryOrchard3: [
        [
            {
                id: IdAssetBundleBuildings.bloom_cherry1,
                offset: [-34, -276],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry2,
                offset: [-81, -269],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry1,
                offset: [-46, -260],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry1,
                offset: [-61, -281],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry1,
                offset: [-20, -257],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry1,
                offset: [-13, -241],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry2,
                offset: [-81, -249],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry2,
                offset: [-103, -261],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry2,
                offset: [-76, -223],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry2,
                offset: [-49, -220],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry2,
                offset: [-32, -245],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry2,
                offset: [-27, -243],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry2,
                offset: [-57, -280],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry2,
                offset: [-102, -225],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry2,
                offset: [-115, -238],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry1,
                offset: [67, -217],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry2,
                offset: [20, -210],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry1,
                offset: [49, -196],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry1,
                offset: [32, -217],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry1,
                offset: [81, -198],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry1,
                offset: [88, -165],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry2,
                offset: [4, -190],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry2,
                offset: [0, -190],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry2,
                offset: [31, -169],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry2,
                offset: [52, -162],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry2,
                offset: [85, -167],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry2,
                offset: [74, -185],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry2,
                offset: [33, -221],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry1,
                offset: [-122, -218],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry2,
                offset: [-173, -208],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry1,
                offset: [-147, -201],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry1,
                offset: [-141, -222],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry1,
                offset: [-101, -187],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry2,
                offset: [-185, -171],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry2,
                offset: [-189, -173],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry2,
                offset: [-153, -174],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry2,
                offset: [-137, -167],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry2,
                offset: [-104, -184],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry2,
                offset: [-116, -190],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry2,
                offset: [-156, -226],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry1,
                offset: [-16, -158],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry2,
                offset: [-67, -161],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry1,
                offset: [-34, -147],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry1,
                offset: [-28, -176],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry1,
                offset: [5, -129],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry2,
                offset: [-88, -129],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry2,
                offset: [-86, -132],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry2,
                offset: [-52, -113],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry2,
                offset: [-31, -108],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry2,
                offset: [-7, -124],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry2,
                offset: [-9, -127],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry2,
                offset: [-30, -172],
            },
        ],
        [
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-62, -281],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-57, -278],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-34, -276],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-80, -269],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-20, -257],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-13, -241],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-101, -261],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-46, -259],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-30, -246],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-28, -242],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-81, -246],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-48, -221],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-114, -238],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-78, -224],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-101, -223],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [32, -218],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [34, -222],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [67, -217],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [19, -209],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [81, -197],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [49, -196],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [75, -185],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [86, -167],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [88, -165],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [52, -163],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [32, -168],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [4, -191],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [1, -191],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-189, -172],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-185, -172],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-175, -208],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-156, -227],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-139, -223],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-122, -218],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-102, -187],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-105, -183],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-146, -201],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-155, -175],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-115, -191],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-137, -167],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-27, -177],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-32, -172],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-15, -159],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-66, -162],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-87, -131],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-88, -127],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-33, -147],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [4, -129],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-8, -127],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-7, -123],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-53, -113],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-31, -109],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-122, -113],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-122, -108],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-167, -107],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-149, -100],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-70, -64],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-27, -59],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-70, -60],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [44, -106],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [18, -105],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-78, -48],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [12, -102],
            },
        ],
    ], cherries_freeRangeCherryOrchard4: [
        [
            {
                id: IdAssetBundleBuildings.bloom_cherry1,
                offset: [-34, -276],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry2,
                offset: [-81, -269],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry1,
                offset: [-46, -260],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry1,
                offset: [-61, -281],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry1,
                offset: [-20, -257],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry1,
                offset: [-13, -241],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry2,
                offset: [-81, -249],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry2,
                offset: [-103, -261],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry2,
                offset: [-76, -223],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry2,
                offset: [-49, -220],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry2,
                offset: [-32, -245],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry2,
                offset: [-27, -243],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry2,
                offset: [-57, -280],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry2,
                offset: [-102, -225],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry2,
                offset: [-115, -238],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry1,
                offset: [67, -217],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry2,
                offset: [20, -210],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry1,
                offset: [49, -196],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry1,
                offset: [32, -217],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry1,
                offset: [81, -198],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry1,
                offset: [88, -165],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry2,
                offset: [4, -190],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry2,
                offset: [0, -190],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry2,
                offset: [31, -169],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry2,
                offset: [52, -162],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry2,
                offset: [85, -167],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry2,
                offset: [74, -185],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry2,
                offset: [33, -221],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry1,
                offset: [-122, -218],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry2,
                offset: [-173, -208],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry1,
                offset: [-147, -201],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry1,
                offset: [-141, -222],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry1,
                offset: [-101, -187],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry2,
                offset: [-185, -171],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry2,
                offset: [-189, -173],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry2,
                offset: [-153, -174],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry2,
                offset: [-137, -167],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry2,
                offset: [-104, -184],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry2,
                offset: [-116, -190],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry2,
                offset: [-156, -226],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry1,
                offset: [-16, -158],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry2,
                offset: [-67, -161],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry1,
                offset: [-34, -147],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry1,
                offset: [-28, -176],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry1,
                offset: [5, -129],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry2,
                offset: [-88, -129],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry2,
                offset: [-86, -132],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry2,
                offset: [-52, -113],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry2,
                offset: [-31, -108],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry2,
                offset: [-7, -124],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry2,
                offset: [-9, -127],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry2,
                offset: [-30, -172],
            },
        ],
        [
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-62, -281],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-57, -278],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-34, -276],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-80, -269],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-20, -257],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-13, -241],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-101, -261],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-46, -259],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-30, -246],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-28, -242],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-81, -246],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-48, -221],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-114, -238],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-78, -224],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-101, -223],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [32, -218],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [34, -222],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [67, -217],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [19, -209],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [81, -197],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [49, -196],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [75, -185],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [86, -167],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [88, -165],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [52, -163],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [32, -168],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [4, -191],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [1, -191],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-189, -172],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-185, -172],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-175, -208],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-156, -227],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-139, -223],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-122, -218],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-102, -187],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-105, -183],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-146, -201],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-155, -175],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-115, -191],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-137, -167],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-27, -177],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-32, -172],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-15, -159],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-66, -162],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-87, -131],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-88, -127],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-33, -147],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [4, -129],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-8, -127],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-7, -123],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-53, -113],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-31, -109],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-122, -113],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-122, -108],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-167, -107],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-149, -100],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-70, -64],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-27, -59],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-70, -60],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [44, -106],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [18, -105],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-78, -48],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [12, -102],
            },
        ],
    ], cherries_freeRangeCherryOrchard5: [
        [
            {
                id: IdAssetBundleBuildings.bloom_cherry1,
                offset: [-34, -276],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry2,
                offset: [-81, -269],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry1,
                offset: [-46, -260],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry1,
                offset: [-61, -281],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry1,
                offset: [-20, -257],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry1,
                offset: [-13, -241],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry2,
                offset: [-81, -249],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry2,
                offset: [-103, -261],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry2,
                offset: [-76, -223],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry2,
                offset: [-49, -220],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry2,
                offset: [-32, -245],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry2,
                offset: [-27, -243],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry2,
                offset: [-57, -280],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry2,
                offset: [-102, -225],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry2,
                offset: [-115, -238],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry1,
                offset: [67, -217],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry2,
                offset: [20, -210],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry1,
                offset: [49, -196],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry1,
                offset: [32, -217],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry1,
                offset: [81, -198],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry1,
                offset: [88, -165],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry2,
                offset: [4, -190],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry2,
                offset: [0, -190],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry2,
                offset: [31, -169],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry2,
                offset: [52, -162],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry2,
                offset: [85, -167],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry2,
                offset: [74, -185],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry2,
                offset: [33, -221],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry1,
                offset: [-122, -218],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry2,
                offset: [-173, -208],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry1,
                offset: [-147, -201],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry1,
                offset: [-141, -222],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry1,
                offset: [-101, -187],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry2,
                offset: [-185, -171],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry2,
                offset: [-189, -173],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry2,
                offset: [-153, -174],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry2,
                offset: [-137, -167],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry2,
                offset: [-104, -184],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry2,
                offset: [-116, -190],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry2,
                offset: [-156, -226],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry1,
                offset: [-16, -158],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry2,
                offset: [-67, -161],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry1,
                offset: [-34, -147],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry1,
                offset: [-28, -176],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry1,
                offset: [5, -129],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry2,
                offset: [-88, -129],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry2,
                offset: [-86, -132],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry2,
                offset: [-52, -113],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry2,
                offset: [-31, -108],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry2,
                offset: [-7, -124],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry2,
                offset: [-9, -127],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry2,
                offset: [-30, -172],
            },
        ],
        [
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-62, -281],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-57, -278],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-34, -276],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-80, -269],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-20, -257],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-13, -241],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-101, -261],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-46, -259],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-30, -246],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-28, -242],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-81, -246],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-48, -221],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-114, -238],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-78, -224],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-101, -223],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [32, -218],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [34, -222],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [67, -217],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [19, -209],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [81, -197],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [49, -196],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [75, -185],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [86, -167],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [88, -165],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [52, -163],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [32, -168],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [4, -191],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [1, -191],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-189, -172],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-185, -172],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-175, -208],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-156, -227],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-139, -223],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-122, -218],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-102, -187],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-105, -183],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-146, -201],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-155, -175],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-115, -191],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-137, -167],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-27, -177],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-32, -172],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-15, -159],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-66, -162],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-87, -131],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-88, -127],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-33, -147],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [4, -129],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-8, -127],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-7, -123],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-53, -113],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-31, -109],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-122, -113],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-122, -108],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-167, -107],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-149, -100],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-70, -64],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-27, -59],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-70, -60],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [44, -106],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [18, -105],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-78, -48],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [12, -102],
            },
        ],
    ], cherries_freeRangeCherryOrchard6: [
        [
            {
                id: IdAssetBundleBuildings.bloom_cherry1,
                offset: [-34, -276],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry2,
                offset: [-81, -269],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry1,
                offset: [-46, -260],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry1,
                offset: [-61, -281],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry1,
                offset: [-20, -257],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry1,
                offset: [-13, -241],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry2,
                offset: [-81, -249],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry2,
                offset: [-103, -261],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry2,
                offset: [-76, -223],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry2,
                offset: [-49, -220],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry2,
                offset: [-32, -245],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry2,
                offset: [-27, -243],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry2,
                offset: [-57, -280],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry2,
                offset: [-102, -225],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry2,
                offset: [-115, -238],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry1,
                offset: [67, -217],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry2,
                offset: [20, -210],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry1,
                offset: [49, -196],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry1,
                offset: [32, -217],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry1,
                offset: [81, -198],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry1,
                offset: [88, -165],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry2,
                offset: [4, -190],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry2,
                offset: [0, -190],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry2,
                offset: [31, -169],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry2,
                offset: [52, -162],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry2,
                offset: [85, -167],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry2,
                offset: [74, -185],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry2,
                offset: [33, -221],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry1,
                offset: [-122, -218],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry2,
                offset: [-173, -208],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry1,
                offset: [-147, -201],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry1,
                offset: [-141, -222],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry1,
                offset: [-101, -187],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry2,
                offset: [-185, -171],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry2,
                offset: [-189, -173],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry2,
                offset: [-153, -174],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry2,
                offset: [-137, -167],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry2,
                offset: [-104, -184],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry2,
                offset: [-116, -190],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry2,
                offset: [-156, -226],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry1,
                offset: [-16, -158],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry2,
                offset: [-67, -161],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry1,
                offset: [-34, -147],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry1,
                offset: [-28, -176],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry1,
                offset: [5, -129],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry2,
                offset: [-88, -129],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry2,
                offset: [-86, -132],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry2,
                offset: [-52, -113],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry2,
                offset: [-31, -108],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry2,
                offset: [-7, -124],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry2,
                offset: [-9, -127],
            },
            {
                id: IdAssetBundleBuildings.bloom_cherry2,
                offset: [-30, -172],
            },
        ],
        [
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-62, -281],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-57, -278],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-34, -276],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-80, -269],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-20, -257],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-13, -241],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-101, -261],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-46, -259],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-30, -246],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-28, -242],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-81, -246],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-48, -221],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-114, -238],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-78, -224],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-101, -223],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [32, -218],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [34, -222],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [67, -217],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [19, -209],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [81, -197],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [49, -196],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [75, -185],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [86, -167],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [88, -165],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [52, -163],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [32, -168],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [4, -191],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [1, -191],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-189, -172],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-185, -172],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-175, -208],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-156, -227],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-139, -223],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-122, -218],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-102, -187],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-105, -183],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-146, -201],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-155, -175],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-115, -191],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-137, -167],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-27, -177],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-32, -172],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-15, -159],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-66, -162],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-87, -131],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-88, -127],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-33, -147],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [4, -129],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-8, -127],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-7, -123],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-53, -113],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-31, -109],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-122, -113],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-122, -108],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-167, -107],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-149, -100],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-70, -64],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-27, -59],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-70, -60],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [44, -106],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [18, -105],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [-78, -48],
            },
            {
                id: IdAssetBundleBuildings.fruits_cherry1,
                offset: [12, -102],
            },
        ],
    ], peaches_peachOrchard1: [
        [
            {
                id: IdAssetBundleBuildings.peachOrchard_blosssom_1,
                offset: [-66, -174],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_blosssom_1,
                offset: [-51, -169],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_blosssom_1,
                offset: [-8, -151],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_blosssom_1,
                offset: [-23, -146],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_blosssom_1,
                offset: [21, -129],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_blosssom_1,
                offset: [36, -124],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_blosssom_1,
                offset: [-113, -142],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_blosssom_1,
                offset: [-128, -137],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_blosssom_1,
                offset: [-85, -121],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_blosssom_1,
                offset: [-69, -116],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_blosssom_1,
                offset: [-25, -99],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_blosssom_1,
                offset: [-41, -94],
            },
        ],
        [
            {
                id: IdAssetBundleBuildings.peachOrchard_peach_1,
                offset: [-67, -174],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_peach_1,
                offset: [-52, -170],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_peach_1,
                offset: [-7, -153],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_peach_1,
                offset: [-22, -150],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_peach_1,
                offset: [20, -130],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_peach_1,
                offset: [36, -126],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_peach_1,
                offset: [-113, -144],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_peach_1,
                offset: [-128, -141],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_peach_1,
                offset: [-83, -122],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_peach_1,
                offset: [-68, -119],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_peach_1,
                offset: [-25, -101],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_peach_1,
                offset: [-41, -98],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_peach_1,
                offset: [-139, -102],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_peach_1,
                offset: [-126, -99],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_peach_1,
                offset: [-133, -97],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_peach_1,
                offset: [64, -120],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_peach_1,
                offset: [77, -117],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_peach_1,
                offset: [70, -116],
            },
        ],
    ], peaches_peachOrchard2: [
        [
            {
                id: IdAssetBundleBuildings.peachOrchard_blosssom_1,
                offset: [-69, -177],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_blosssom_1,
                offset: [-57, -188],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_blosssom_1,
                offset: [-44, -180],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_blosssom_1,
                offset: [-5, -156],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_blosssom_1,
                offset: [-17, -167],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_blosssom_1,
                offset: [-30, -159],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_blosssom_1,
                offset: [20, -131],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_blosssom_1,
                offset: [32, -142],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_blosssom_1,
                offset: [45, -134],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_blosssom_1,
                offset: [-105, -147],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_blosssom_1,
                offset: [-117, -158],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_blosssom_1,
                offset: [-130, -150],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_blosssom_1,
                offset: [-84, -127],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_blosssom_1,
                offset: [-72, -138],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_blosssom_1,
                offset: [-59, -130],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_blosssom_1,
                offset: [-17, -102],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_blosssom_1,
                offset: [-29, -113],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_blosssom_1,
                offset: [-42, -105],
            },
        ],
        [
            {
                id: IdAssetBundleBuildings.peachOrchard_peach_1,
                offset: [-69, -177],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_peach_1,
                offset: [-57, -188],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_peach_1,
                offset: [-44, -180],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_peach_1,
                offset: [-6, -155],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_peach_1,
                offset: [-18, -166],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_peach_1,
                offset: [-31, -158],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_peach_1,
                offset: [18, -131],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_peach_1,
                offset: [30, -142],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_peach_1,
                offset: [43, -134],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_peach_1,
                offset: [-104, -148],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_peach_1,
                offset: [-116, -159],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_peach_1,
                offset: [-129, -151],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_peach_1,
                offset: [-86, -127],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_peach_1,
                offset: [-74, -138],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_peach_1,
                offset: [-61, -130],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_peach_1,
                offset: [-16, -103],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_peach_1,
                offset: [-28, -114],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_peach_1,
                offset: [-41, -106],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_peach_1,
                offset: [-137, -100],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_peach_1,
                offset: [-127, -104],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_peach_1,
                offset: [-124, -99],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_peach_1,
                offset: [-131, -97],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_peach_1,
                offset: [69, -119],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_peach_1,
                offset: [79, -123],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_peach_1,
                offset: [82, -118],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_peach_1,
                offset: [75, -116],
            },
        ],
    ], peaches_peachOrchard3: [
        [
            {
                id: IdAssetBundleBuildings.peachOrchard_blosssom_1,
                offset: [-83, -188],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_blosssom_1,
                offset: [-53, -196],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_blosssom_1,
                offset: [-69, -201],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_blosssom_1,
                offset: [-59, -184],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_blosssom_1,
                offset: [-6, -165],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_blosssom_1,
                offset: [-35, -172],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_blosssom_1,
                offset: [-20, -178],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_blosssom_1,
                offset: [-29, -161],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_blosssom_1,
                offset: [19, -140],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_blosssom_1,
                offset: [48, -148],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_blosssom_1,
                offset: [33, -153],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_blosssom_1,
                offset: [42, -136],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_blosssom_1,
                offset: [-115, -159],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_blosssom_1,
                offset: [-144, -167],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_blosssom_1,
                offset: [-129, -172],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_blosssom_1,
                offset: [-138, -155],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_blosssom_1,
                offset: [-91, -136],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_blosssom_1,
                offset: [-62, -144],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_blosssom_1,
                offset: [-78, -150],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_blosssom_1,
                offset: [-68, -132],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_blosssom_1,
                offset: [-11, -111],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_blosssom_1,
                offset: [-41, -118],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_blosssom_1,
                offset: [-25, -124],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_blosssom_1,
                offset: [-35, -107],
            },
        ],
        [
            {
                id: IdAssetBundleBuildings.peachOrchard_peach_1,
                offset: [-83, -188],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_peach_1,
                offset: [-53, -196],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_peach_1,
                offset: [-69, -201],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_peach_1,
                offset: [-59, -184],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_peach_1,
                offset: [-6, -164],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_peach_1,
                offset: [-35, -171],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_peach_1,
                offset: [-20, -177],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_peach_1,
                offset: [-29, -160],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_peach_1,
                offset: [19, -140],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_peach_1,
                offset: [48, -148],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_peach_1,
                offset: [33, -153],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_peach_1,
                offset: [42, -136],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_peach_1,
                offset: [-114, -158],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_peach_1,
                offset: [-143, -166],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_peach_1,
                offset: [-127, -171],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_peach_1,
                offset: [-137, -154],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_peach_1,
                offset: [-92, -136],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_peach_1,
                offset: [-63, -144],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_peach_1,
                offset: [-78, -149],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_peach_1,
                offset: [-69, -132],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_peach_1,
                offset: [-10, -110],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_peach_1,
                offset: [-40, -118],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_peach_1,
                offset: [-24, -123],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_peach_1,
                offset: [-34, -106],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_peach_1,
                offset: [-120, -99],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_peach_1,
                offset: [-131, -98],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_peach_1,
                offset: [-118, -105],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_peach_1,
                offset: [-128, -105],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_peach_1,
                offset: [-46, -60],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_peach_1,
                offset: [-57, -59],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_peach_1,
                offset: [-44, -65],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_peach_1,
                offset: [-54, -65],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_peach_1,
                offset: [80, -117],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_peach_1,
                offset: [69, -116],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_peach_1,
                offset: [81, -123],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_peach_1,
                offset: [72, -123],
            },
        ],
    ], peaches_peachOrchard4: [
        [
            {
                id: IdAssetBundleBuildings.peachOrchard_blosssom_1,
                offset: [-52, -228],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_blosssom_1,
                offset: [-32, -222],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_blosssom_1,
                offset: [-68, -213],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_blosssom_1,
                offset: [-36, -212],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_blosssom_1,
                offset: [-52, -208],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_blosssom_1,
                offset: [16, -200],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_blosssom_1,
                offset: [-5, -194],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_blosssom_1,
                offset: [32, -185],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_blosssom_1,
                offset: [-1, -184],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_blosssom_1,
                offset: [16, -180],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_blosssom_1,
                offset: [64, -170],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_blosssom_1,
                offset: [85, -164],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_blosssom_1,
                offset: [48, -156],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_blosssom_1,
                offset: [81, -155],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_blosssom_1,
                offset: [65, -150],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_blosssom_1,
                offset: [-98, -197],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_blosssom_1,
                offset: [-119, -191],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_blosssom_1,
                offset: [-82, -182],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_blosssom_1,
                offset: [-115, -181],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_blosssom_1,
                offset: [-98, -177],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_blosssom_1,
                offset: [-48, -167],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_blosssom_1,
                offset: [-27, -161],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_blosssom_1,
                offset: [-64, -152],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_blosssom_1,
                offset: [-31, -151],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_blosssom_1,
                offset: [-48, -147],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_blosssom_1,
                offset: [18, -139],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_blosssom_1,
                offset: [-3, -133],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_blosssom_1,
                offset: [34, -125],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_blosssom_1,
                offset: [1, -124],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_blosssom_1,
                offset: [17, -119],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_blosssom_1,
                offset: [-168, -167],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_blosssom_1,
                offset: [-147, -161],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_blosssom_1,
                offset: [-184, -152],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_blosssom_1,
                offset: [-151, -151],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_blosssom_1,
                offset: [-167, -147],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_blosssom_1,
                offset: [-101, -137],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_blosssom_1,
                offset: [-122, -131],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_blosssom_1,
                offset: [-85, -122],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_blosssom_1,
                offset: [-118, -121],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_blosssom_1,
                offset: [-101, -117],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_blosssom_1,
                offset: [-44, -110],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_blosssom_1,
                offset: [-23, -104],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_blosssom_1,
                offset: [-60, -95],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_blosssom_1,
                offset: [-27, -94],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_blosssom_1,
                offset: [-43, -90],
            },
        ],
        [
            {
                id: IdAssetBundleBuildings.peachOrchard_peach_1,
                offset: [-52, -228],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_peach_1,
                offset: [-32, -222],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_peach_1,
                offset: [-68, -213],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_peach_1,
                offset: [-36, -212],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_peach_1,
                offset: [-52, -208],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_peach_1,
                offset: [14, -200],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_peach_1,
                offset: [-6, -194],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_peach_1,
                offset: [30, -186],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_peach_1,
                offset: [-2, -185],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_peach_1,
                offset: [14, -180],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_peach_1,
                offset: [62, -170],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_peach_1,
                offset: [83, -164],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_peach_1,
                offset: [46, -155],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_peach_1,
                offset: [79, -154],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_peach_1,
                offset: [63, -150],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_peach_1,
                offset: [-97, -198],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_peach_1,
                offset: [-118, -192],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_peach_1,
                offset: [-81, -183],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_peach_1,
                offset: [-114, -182],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_peach_1,
                offset: [-98, -178],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_peach_1,
                offset: [-48, -167],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_peach_1,
                offset: [-27, -162],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_peach_1,
                offset: [-64, -153],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_peach_1,
                offset: [-31, -152],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_peach_1,
                offset: [-47, -148],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_peach_1,
                offset: [19, -140],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_peach_1,
                offset: [-2, -134],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_peach_1,
                offset: [35, -125],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_peach_1,
                offset: [2, -124],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_peach_1,
                offset: [18, -120],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_peach_1,
                offset: [-166, -166],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_peach_1,
                offset: [-145, -160],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_peach_1,
                offset: [-182, -151],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_peach_1,
                offset: [-149, -150],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_peach_1,
                offset: [-166, -146],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_peach_1,
                offset: [-101, -138],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_peach_1,
                offset: [-121, -132],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_peach_1,
                offset: [-85, -123],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_peach_1,
                offset: [-117, -122],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_peach_1,
                offset: [-101, -118],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_peach_1,
                offset: [-43, -111],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_peach_1,
                offset: [-23, -105],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_peach_1,
                offset: [-59, -96],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_peach_1,
                offset: [-27, -95],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_peach_1,
                offset: [-43, -91],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_peach_1,
                offset: [-142, -107],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_peach_1,
                offset: [-134, -105],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_peach_1,
                offset: [-146, -102],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_peach_1,
                offset: [-134, -101],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_peach_1,
                offset: [-140, -100],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_peach_1,
                offset: [-10, -91],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_peach_1,
                offset: [-2, -89],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_peach_1,
                offset: [-14, -86],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_peach_1,
                offset: [-2, -86],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_peach_1,
                offset: [-8, -84],
            },
        ],
    ], peaches_peachOrchard5: [
        [
            {
                id: IdAssetBundleBuildings.peachOrchard_blosssom_1,
                offset: [-69, -231],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_blosssom_1,
                offset: [-37, -236],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_blosssom_1,
                offset: [-79, -215],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_blosssom_1,
                offset: [-54, -220],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_blosssom_1,
                offset: [-35, -215],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_blosssom_1,
                offset: [26, -206],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_blosssom_1,
                offset: [-6, -211],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_blosssom_1,
                offset: [36, -190],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_blosssom_1,
                offset: [11, -195],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_blosssom_1,
                offset: [-8, -190],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_blosssom_1,
                offset: [51, -173],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_blosssom_1,
                offset: [83, -177],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_blosssom_1,
                offset: [41, -157],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_blosssom_1,
                offset: [67, -162],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_blosssom_1,
                offset: [86, -157],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_blosssom_1,
                offset: [-99, -197],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_blosssom_1,
                offset: [-131, -202],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_blosssom_1,
                offset: [-89, -181],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_blosssom_1,
                offset: [-114, -186],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_blosssom_1,
                offset: [-133, -181],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_blosssom_1,
                offset: [-62, -169],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_blosssom_1,
                offset: [-30, -173],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_blosssom_1,
                offset: [-72, -153],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_blosssom_1,
                offset: [-47, -158],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_blosssom_1,
                offset: [-28, -153],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_blosssom_1,
                offset: [36, -140],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_blosssom_1,
                offset: [4, -145],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_blosssom_1,
                offset: [46, -124],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_blosssom_1,
                offset: [21, -129],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_blosssom_1,
                offset: [2, -124],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_blosssom_1,
                offset: [-184, -166],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_blosssom_1,
                offset: [-152, -171],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_blosssom_1,
                offset: [-194, -150],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_blosssom_1,
                offset: [-169, -155],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_blosssom_1,
                offset: [-150, -150],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_blosssom_1,
                offset: [-88, -136],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_blosssom_1,
                offset: [-120, -140],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_blosssom_1,
                offset: [-78, -120],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_blosssom_1,
                offset: [-103, -124],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_blosssom_1,
                offset: [-122, -119],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_blosssom_1,
                offset: [-59, -108],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_blosssom_1,
                offset: [-27, -113],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_blosssom_1,
                offset: [-69, -92],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_blosssom_1,
                offset: [-43, -97],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_blosssom_1,
                offset: [-24, -92],
            },
        ],
        [
            {
                id: IdAssetBundleBuildings.peachOrchard_peach_1,
                offset: [-69, -231],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_peach_1,
                offset: [-37, -236],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_peach_1,
                offset: [-79, -215],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_peach_1,
                offset: [-54, -220],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_peach_1,
                offset: [-35, -215],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_peach_1,
                offset: [26, -207],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_peach_1,
                offset: [-6, -212],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_peach_1,
                offset: [36, -191],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_peach_1,
                offset: [11, -196],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_peach_1,
                offset: [-8, -191],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_peach_1,
                offset: [52, -173],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_peach_1,
                offset: [84, -178],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_peach_1,
                offset: [42, -158],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_peach_1,
                offset: [67, -162],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_peach_1,
                offset: [86, -157],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_peach_1,
                offset: [-99, -197],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_peach_1,
                offset: [-131, -201],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_peach_1,
                offset: [-89, -181],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_peach_1,
                offset: [-114, -185],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_peach_1,
                offset: [-133, -180],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_peach_1,
                offset: [-62, -169],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_peach_1,
                offset: [-30, -174],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_peach_1,
                offset: [-72, -153],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_peach_1,
                offset: [-47, -158],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_peach_1,
                offset: [-28, -153],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_peach_1,
                offset: [34, -140],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_peach_1,
                offset: [2, -145],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_peach_1,
                offset: [44, -124],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_peach_1,
                offset: [19, -129],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_peach_1,
                offset: [0, -124],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_peach_1,
                offset: [-184, -169],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_peach_1,
                offset: [-152, -174],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_peach_1,
                offset: [-194, -153],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_peach_1,
                offset: [-168, -158],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_peach_1,
                offset: [-150, -153],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_peach_1,
                offset: [-89, -136],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_peach_1,
                offset: [-121, -140],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_peach_1,
                offset: [-79, -120],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_peach_1,
                offset: [-105, -124],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_peach_1,
                offset: [-124, -119],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_peach_1,
                offset: [-60, -107],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_peach_1,
                offset: [-28, -112],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_peach_1,
                offset: [-70, -91],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_peach_1,
                offset: [-44, -96],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_peach_1,
                offset: [-25, -91],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_peach_1,
                offset: [-144, -107],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_peach_1,
                offset: [-136, -107],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_peach_1,
                offset: [-150, -102],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_peach_1,
                offset: [-142, -100],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_peach_1,
                offset: [-134, -102],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_peach_1,
                offset: [-12, -75],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_peach_1,
                offset: [-4, -75],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_peach_1,
                offset: [-17, -70],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_peach_1,
                offset: [-9, -68],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_peach_1,
                offset: [-1, -69],
            },
        ],
    ], peaches_peachOrchard6: [
        [
            {
                id: IdAssetBundleBuildings.peachOrchard_blosssom_1,
                offset: [-80, -246],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_blosssom_1,
                offset: [-68, -230],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_blosssom_1,
                offset: [-62, -244],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_blosssom_1,
                offset: [-52, -259],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_blosssom_1,
                offset: [-31, -252],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_blosssom_1,
                offset: [-44, -232],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_blosssom_1,
                offset: [-27, -236],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_blosssom_1,
                offset: [40, -219],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_blosssom_1,
                offset: [28, -203],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_blosssom_1,
                offset: [22, -217],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_blosssom_1,
                offset: [12, -232],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_blosssom_1,
                offset: [-9, -225],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_blosssom_1,
                offset: [4, -205],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_blosssom_1,
                offset: [-13, -209],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_blosssom_1,
                offset: [44, -193],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_blosssom_1,
                offset: [56, -177],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_blosssom_1,
                offset: [62, -191],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_blosssom_1,
                offset: [72, -206],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_blosssom_1,
                offset: [93, -199],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_blosssom_1,
                offset: [80, -179],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_blosssom_1,
                offset: [97, -183],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_blosssom_1,
                offset: [-82, -215],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_blosssom_1,
                offset: [-94, -199],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_blosssom_1,
                offset: [-100, -214],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_blosssom_1,
                offset: [-110, -229],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_blosssom_1,
                offset: [-131, -222],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_blosssom_1,
                offset: [-118, -201],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_blosssom_1,
                offset: [-135, -206],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_blosssom_1,
                offset: [-68, -190],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_blosssom_1,
                offset: [-56, -173],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_blosssom_1,
                offset: [-50, -188],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_blosssom_1,
                offset: [-40, -203],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_blosssom_1,
                offset: [-19, -196],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_blosssom_1,
                offset: [-32, -176],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_blosssom_1,
                offset: [-15, -180],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_blosssom_1,
                offset: [39, -160],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_blosssom_1,
                offset: [27, -144],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_blosssom_1,
                offset: [22, -158],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_blosssom_1,
                offset: [12, -173],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_blosssom_1,
                offset: [-9, -166],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_blosssom_1,
                offset: [3, -146],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_blosssom_1,
                offset: [-14, -150],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_blosssom_1,
                offset: [-195, -188],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_blosssom_1,
                offset: [-183, -171],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_blosssom_1,
                offset: [-177, -186],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_blosssom_1,
                offset: [-167, -201],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_blosssom_1,
                offset: [-146, -194],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_blosssom_1,
                offset: [-159, -174],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_blosssom_1,
                offset: [-142, -178],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_blosssom_1,
                offset: [-79, -159],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_blosssom_1,
                offset: [-91, -143],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_blosssom_1,
                offset: [-97, -158],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_blosssom_1,
                offset: [-107, -172],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_blosssom_1,
                offset: [-128, -166],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_blosssom_1,
                offset: [-115, -145],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_blosssom_1,
                offset: [-132, -150],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_blosssom_1,
                offset: [-78, -133],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_blosssom_1,
                offset: [-66, -117],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_blosssom_1,
                offset: [-61, -131],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_blosssom_1,
                offset: [-51, -146],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_blosssom_1,
                offset: [-30, -139],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_blosssom_1,
                offset: [-42, -119],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_blosssom_1,
                offset: [-25, -123],
            },
        ],
        [
            {
                id: IdAssetBundleBuildings.peachOrchard_peach_1,
                offset: [-81, -245],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_peach_1,
                offset: [-69, -230],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_peach_1,
                offset: [-63, -245],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_peach_1,
                offset: [-53, -260],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_peach_1,
                offset: [-32, -253],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_peach_1,
                offset: [-45, -232],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_peach_1,
                offset: [-28, -237],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_peach_1,
                offset: [42, -219],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_peach_1,
                offset: [30, -204],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_peach_1,
                offset: [24, -218],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_peach_1,
                offset: [14, -233],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_peach_1,
                offset: [-7, -226],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_peach_1,
                offset: [6, -206],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_peach_1,
                offset: [-11, -210],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_peach_1,
                offset: [42, -190],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_peach_1,
                offset: [54, -175],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_peach_1,
                offset: [60, -190],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_peach_1,
                offset: [70, -205],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_peach_1,
                offset: [91, -198],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_peach_1,
                offset: [78, -178],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_peach_1,
                offset: [95, -182],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_peach_1,
                offset: [-81, -214],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_peach_1,
                offset: [-93, -199],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_peach_1,
                offset: [-99, -213],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_peach_1,
                offset: [-109, -228],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_peach_1,
                offset: [-130, -221],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_peach_1,
                offset: [-117, -201],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_peach_1,
                offset: [-134, -205],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_peach_1,
                offset: [-70, -187],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_peach_1,
                offset: [-58, -172],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_peach_1,
                offset: [-52, -186],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_peach_1,
                offset: [-42, -201],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_peach_1,
                offset: [-21, -194],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_peach_1,
                offset: [-34, -174],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_peach_1,
                offset: [-17, -178],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_peach_1,
                offset: [40, -156],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_peach_1,
                offset: [28, -141],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_peach_1,
                offset: [23, -156],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_peach_1,
                offset: [13, -171],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_peach_1,
                offset: [-8, -164],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_peach_1,
                offset: [4, -144],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_peach_1,
                offset: [-13, -148],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_peach_1,
                offset: [-197, -183],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_peach_1,
                offset: [-185, -168],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_peach_1,
                offset: [-180, -183],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_peach_1,
                offset: [-170, -198],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_peach_1,
                offset: [-149, -191],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_peach_1,
                offset: [-162, -170],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_peach_1,
                offset: [-145, -175],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_peach_1,
                offset: [-79, -154],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_peach_1,
                offset: [-91, -139],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_peach_1,
                offset: [-97, -154],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_peach_1,
                offset: [-107, -169],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_peach_1,
                offset: [-128, -162],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_peach_1,
                offset: [-115, -142],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_peach_1,
                offset: [-132, -146],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_peach_1,
                offset: [-80, -128],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_peach_1,
                offset: [-68, -113],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_peach_1,
                offset: [-63, -128],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_peach_1,
                offset: [-53, -143],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_peach_1,
                offset: [-32, -136],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_peach_1,
                offset: [-44, -116],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_peach_1,
                offset: [-27, -120],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_peach_1,
                offset: [-144, -105],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_peach_1,
                offset: [-150, -100],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_peach_1,
                offset: [-153, -104],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_peach_1,
                offset: [-143, -98],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_peach_1,
                offset: [-139, -107],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_peach_1,
                offset: [-136, -101],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_peach_1,
                offset: [-82, -68],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_peach_1,
                offset: [-88, -64],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_peach_1,
                offset: [-90, -68],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_peach_1,
                offset: [-80, -62],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_peach_1,
                offset: [-76, -71],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_peach_1,
                offset: [-74, -65],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_peach_1,
                offset: [-12, -75],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_peach_1,
                offset: [-18, -71],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_peach_1,
                offset: [-21, -75],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_peach_1,
                offset: [-11, -69],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_peach_1,
                offset: [-6, -78],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_peach_1,
                offset: [-4, -72],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_peach_1,
                offset: [98, -116],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_peach_1,
                offset: [92, -111],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_peach_1,
                offset: [90, -116],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_peach_1,
                offset: [100, -109],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_peach_1,
                offset: [104, -118],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_peach_1,
                offset: [106, -113],
            },
        ],
    ], peaches_peachOrchard7: [
        [
            {
                id: IdAssetBundleBuildings.peachOrchard_blosssom_1,
                offset: [-67, -260],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_blosssom_1,
                offset: [-55, -243],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_blosssom_1,
                offset: [-49, -258],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_blosssom_1,
                offset: [-39, -273],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_blosssom_1,
                offset: [-18, -266],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_blosssom_1,
                offset: [-31, -246],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_blosssom_1,
                offset: [-14, -250],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_blosssom_1,
                offset: [52, -233],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_blosssom_1,
                offset: [40, -216],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_blosssom_1,
                offset: [35, -231],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_blosssom_1,
                offset: [25, -246],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_blosssom_1,
                offset: [4, -239],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_blosssom_1,
                offset: [16, -219],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_blosssom_1,
                offset: [-1, -223],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_blosssom_1,
                offset: [57, -207],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_blosssom_1,
                offset: [69, -190],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_blosssom_1,
                offset: [75, -205],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_blosssom_1,
                offset: [85, -220],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_blosssom_1,
                offset: [106, -213],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_blosssom_1,
                offset: [93, -193],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_blosssom_1,
                offset: [110, -197],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_blosssom_1,
                offset: [-70, -229],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_blosssom_1,
                offset: [-82, -213],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_blosssom_1,
                offset: [-87, -227],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_blosssom_1,
                offset: [-97, -242],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_blosssom_1,
                offset: [-118, -235],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_blosssom_1,
                offset: [-106, -215],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_blosssom_1,
                offset: [-123, -219],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_blosssom_1,
                offset: [-55, -203],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_blosssom_1,
                offset: [-43, -187],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_blosssom_1,
                offset: [-38, -202],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_blosssom_1,
                offset: [-28, -217],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_blosssom_1,
                offset: [-7, -210],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_blosssom_1,
                offset: [-19, -189],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_blosssom_1,
                offset: [-2, -194],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_blosssom_1,
                offset: [52, -173],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_blosssom_1,
                offset: [40, -157],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_blosssom_1,
                offset: [34, -172],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_blosssom_1,
                offset: [24, -187],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_blosssom_1,
                offset: [3, -180],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_blosssom_1,
                offset: [16, -160],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_blosssom_1,
                offset: [-1, -164],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_blosssom_1,
                offset: [-182, -201],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_blosssom_1,
                offset: [-170, -185],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_blosssom_1,
                offset: [-165, -200],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_blosssom_1,
                offset: [-155, -215],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_blosssom_1,
                offset: [-134, -208],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_blosssom_1,
                offset: [-146, -187],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_blosssom_1,
                offset: [-129, -192],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_blosssom_1,
                offset: [-67, -173],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_blosssom_1,
                offset: [-79, -157],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_blosssom_1,
                offset: [-84, -171],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_blosssom_1,
                offset: [-94, -186],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_blosssom_1,
                offset: [-115, -179],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_blosssom_1,
                offset: [-103, -159],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_blosssom_1,
                offset: [-120, -163],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_blosssom_1,
                offset: [-66, -147],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_blosssom_1,
                offset: [-54, -130],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_blosssom_1,
                offset: [-48, -145],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_blosssom_1,
                offset: [-38, -160],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_blosssom_1,
                offset: [-17, -153],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_blosssom_1,
                offset: [-30, -133],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_blosssom_1,
                offset: [-13, -137],
            },
        ],
        [
            {
                id: IdAssetBundleBuildings.peachOrchard_peach_1,
                offset: [-66, -259],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_peach_1,
                offset: [-54, -244],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_peach_1,
                offset: [-49, -258],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_peach_1,
                offset: [-39, -273],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_peach_1,
                offset: [-18, -266],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_peach_1,
                offset: [-30, -246],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_peach_1,
                offset: [-13, -250],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_peach_1,
                offset: [56, -232],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_peach_1,
                offset: [44, -217],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_peach_1,
                offset: [39, -232],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_peach_1,
                offset: [29, -247],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_peach_1,
                offset: [8, -240],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_peach_1,
                offset: [20, -220],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_peach_1,
                offset: [3, -224],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_peach_1,
                offset: [57, -204],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_peach_1,
                offset: [69, -189],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_peach_1,
                offset: [74, -204],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_peach_1,
                offset: [84, -219],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_peach_1,
                offset: [105, -212],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_peach_1,
                offset: [93, -191],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_peach_1,
                offset: [110, -196],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_peach_1,
                offset: [-67, -227],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_peach_1,
                offset: [-79, -212],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_peach_1,
                offset: [-84, -227],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_peach_1,
                offset: [-94, -242],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_peach_1,
                offset: [-115, -235],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_peach_1,
                offset: [-103, -215],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_peach_1,
                offset: [-120, -219],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_peach_1,
                offset: [-55, -200],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_peach_1,
                offset: [-43, -185],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_peach_1,
                offset: [-37, -200],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_peach_1,
                offset: [-27, -215],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_peach_1,
                offset: [-6, -208],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_peach_1,
                offset: [-19, -188],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_peach_1,
                offset: [-2, -192],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_peach_1,
                offset: [55, -170],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_peach_1,
                offset: [43, -155],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_peach_1,
                offset: [37, -169],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_peach_1,
                offset: [27, -184],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_peach_1,
                offset: [6, -177],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_peach_1,
                offset: [19, -157],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_peach_1,
                offset: [2, -162],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_peach_1,
                offset: [-183, -197],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_peach_1,
                offset: [-171, -182],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_peach_1,
                offset: [-165, -196],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_peach_1,
                offset: [-155, -211],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_peach_1,
                offset: [-134, -204],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_peach_1,
                offset: [-147, -184],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_peach_1,
                offset: [-130, -188],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_peach_1,
                offset: [-64, -168],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_peach_1,
                offset: [-76, -153],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_peach_1,
                offset: [-82, -167],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_peach_1,
                offset: [-92, -182],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_peach_1,
                offset: [-113, -175],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_peach_1,
                offset: [-100, -155],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_peach_1,
                offset: [-117, -160],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_peach_1,
                offset: [-66, -142],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_peach_1,
                offset: [-54, -127],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_peach_1,
                offset: [-48, -142],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_peach_1,
                offset: [-38, -157],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_peach_1,
                offset: [-17, -150],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_peach_1,
                offset: [-30, -129],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_peach_1,
                offset: [-13, -134],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_peach_1,
                offset: [-130, -117],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_peach_1,
                offset: [-136, -113],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_peach_1,
                offset: [-138, -117],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_peach_1,
                offset: [-128, -111],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_peach_1,
                offset: [-124, -120],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_peach_1,
                offset: [-122, -114],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_peach_1,
                offset: [-68, -84],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_peach_1,
                offset: [-74, -79],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_peach_1,
                offset: [-77, -84],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_peach_1,
                offset: [-67, -77],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_peach_1,
                offset: [-62, -86],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_peach_1,
                offset: [-60, -81],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_peach_1,
                offset: [8, -89],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_peach_1,
                offset: [2, -84],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_peach_1,
                offset: [-1, -89],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_peach_1,
                offset: [9, -82],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_peach_1,
                offset: [13, -91],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_peach_1,
                offset: [16, -86],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_peach_1,
                offset: [74, -128],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_peach_1,
                offset: [68, -123],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_peach_1,
                offset: [65, -127],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_peach_1,
                offset: [75, -121],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_peach_1,
                offset: [80, -130],
            },
            {
                id: IdAssetBundleBuildings.peachOrchard_peach_1,
                offset: [82, -124],
            },
        ],
    ], barleys_acre1: [
        [
            {
                id: IdAssetBundleBuildings.acre_seeds_barley_1,
                offset: [-49, -102],
            },
        ],
        [
            {
                id: IdAssetBundleBuildings.acre_seeds_barley_2,
                offset: [-52, -114],
            },
        ],
        [
            {
                id: IdAssetBundleBuildings.acre_seeds_barley_3,
                offset: [-54, -122],
            },
        ],
    ], barleys_acre2: [
        [
            {
                id: IdAssetBundleBuildings.acre_seeds_barley_1,
                offset: [-49, -99],
            },
        ],
        [
            {
                id: IdAssetBundleBuildings.acre_seeds_barley_2,
                offset: [-52, -111],
            },
        ],
        [
            {
                id: IdAssetBundleBuildings.acre_seeds_barley_3,
                offset: [-54, -118],
            },
        ],
    ], barleys_acre3: [
        [
            {
                id: IdAssetBundleBuildings.acre_seeds_barley_1,
                offset: [-47, -106],
            },
        ],
        [
            {
                id: IdAssetBundleBuildings.acre_seeds_barley_2,
                offset: [-48, -115],
            },
        ],
        [
            {
                id: IdAssetBundleBuildings.acre_seeds_barley_3,
                offset: [-47, -124],
            },
        ],
    ], barleys_acre4: [
        [
            {
                id: IdAssetBundleBuildings.acre_seeds_barley_1,
                offset: [-47, -104],
            },
        ],
        [
            {
                id: IdAssetBundleBuildings.acre_seeds_barley_2,
                offset: [-48, -117],
            },
        ],
        [
            {
                id: IdAssetBundleBuildings.acre_seeds_barley_3,
                offset: [-49, -125],
            },
        ],
    ], barleys_acre5: [
        [
            {
                id: IdAssetBundleBuildings.acre_seeds_barley_1,
                offset: [-51, -101],
            },
        ],
        [
            {
                id: IdAssetBundleBuildings.acre_seeds_barley_2,
                offset: [-49, -116],
            },
        ],
        [
            {
                id: IdAssetBundleBuildings.acre_seeds_barley_3,
                offset: [-51, -124],
            },
        ],
    ], barleys_acre6: [
        [
            {
                id: IdAssetBundleBuildings.acre_seeds_barley_1,
                offset: [-49, -96],
            },
        ],
        [
            {
                id: IdAssetBundleBuildings.acre_seeds_barley_2,
                offset: [-52, -108],
            },
        ],
        [
            {
                id: IdAssetBundleBuildings.acre_seeds_barley_3,
                offset: [-51, -119],
            },
        ],
    ], barleys_acre7: [
        [
            {
                id: IdAssetBundleBuildings.acre_seeds_barley_1,
                offset: [-49, -96],
            },
        ],
        [
            {
                id: IdAssetBundleBuildings.acre_seeds_barley_2,
                offset: [-52, -108],
            },
        ],
        [
            {
                id: IdAssetBundleBuildings.acre_seeds_barley_3,
                offset: [-51, -119],
            },
        ],
    ], barleys_acre8: [
        [
            {
                id: IdAssetBundleBuildings.acre_seeds_barley_1,
                offset: [-49, -96],
            },
        ],
        [
            {
                id: IdAssetBundleBuildings.acre_seeds_barley_2,
                offset: [-52, -108],
            },
        ],
        [
            {
                id: IdAssetBundleBuildings.acre_seeds_barley_3,
                offset: [-51, -119],
            },
        ],
    ], cabbage_acre1: [
        [
            {
                id: IdAssetBundleBuildings.acre_seeds_cabbage_1,
                offset: [-49, -106],
            },
        ],
        [
            {
                id: IdAssetBundleBuildings.acre_seeds_cabbage_2,
                offset: [-51, -105],
            },
        ],
        [
            {
                id: IdAssetBundleBuildings.acre_seeds_cabbage_3,
                offset: [-50, -106],
            },
        ],
    ], cabbage_acre2: [
        [
            {
                id: IdAssetBundleBuildings.acre_seeds_cabbage_1,
                offset: [-48, -99],
            },
        ],
        [
            {
                id: IdAssetBundleBuildings.acre_seeds_cabbage_2,
                offset: [-50, -100],
            },
        ],
        [
            {
                id: IdAssetBundleBuildings.acre_seeds_cabbage_3,
                offset: [-47, -101],
            },
        ],
    ], cabbage_acre3: [
        [
            {
                id: IdAssetBundleBuildings.acre_seeds_cabbage_1,
                offset: [-47, -103],
            },
        ],
        [
            {
                id: IdAssetBundleBuildings.acre_seeds_cabbage_2,
                offset: [-51, -103],
            },
        ],
        [
            {
                id: IdAssetBundleBuildings.acre_seeds_cabbage_3,
                offset: [-51, -106],
            },
        ],
    ], cabbage_acre4: [
        [
            {
                id: IdAssetBundleBuildings.acre_seeds_cabbage_1,
                offset: [-50, -104],
            },
        ],
        [
            {
                id: IdAssetBundleBuildings.acre_seeds_cabbage_2,
                offset: [-56, -104],
            },
        ],
        [
            {
                id: IdAssetBundleBuildings.acre_seeds_cabbage_3,
                offset: [-56, -105],
            },
        ],
    ], cabbage_acre5: [
        [
            {
                id: IdAssetBundleBuildings.acre_seeds_cabbage_1,
                offset: [-53, -106],
            },
        ],
        [
            {
                id: IdAssetBundleBuildings.acre_seeds_cabbage_2,
                offset: [-47, -105],
            },
        ],
        [
            {
                id: IdAssetBundleBuildings.acre_seeds_cabbage_3,
                offset: [-47, -106],
            },
        ],
    ], cabbage_acre6: [
        [
            {
                id: IdAssetBundleBuildings.acre_seeds_cabbage_1,
                offset: [-54, -105],
            },
        ],
        [
            {
                id: IdAssetBundleBuildings.acre_seeds_cabbage_2,
                offset: [-54, -102],
            },
        ],
        [
            {
                id: IdAssetBundleBuildings.acre_seeds_cabbage_3,
                offset: [-53, -105],
            },
        ],
    ], cabbage_acre7: [
        [
            {
                id: IdAssetBundleBuildings.acre_seeds_cabbage_1,
                offset: [-52, -99],
            },
        ],
        [
            {
                id: IdAssetBundleBuildings.acre_seeds_cabbage_2,
                offset: [-54, -99],
            },
        ],
        [
            {
                id: IdAssetBundleBuildings.acre_seeds_cabbage_3,
                offset: [-51, -102],
            },
        ],
    ], cabbage_acre8: [
        [
            {
                id: IdAssetBundleBuildings.acre_seeds_cabbage_1,
                offset: [-52, -99],
            },
        ],
        [
            {
                id: IdAssetBundleBuildings.acre_seeds_cabbage_2,
                offset: [-54, -99],
            },
        ],
        [
            {
                id: IdAssetBundleBuildings.acre_seeds_cabbage_3,
                offset: [-51, -102],
            },
        ],
    ], citrusFruits_meadow1: [
        [
            {
                id: IdAssetBundleBuildings.meadow_seeds_citrusFruits_1,
                offset: [-49, -133],
            },
        ],
        [
            {
                id: IdAssetBundleBuildings.meadow_seeds_citrusFruits_2,
                offset: [-45, -139],
            },
        ],
        [
            {
                id: IdAssetBundleBuildings.meadow_seeds_citrusFruits_3,
                offset: [-44, -148],
            },
        ],
    ], citrusFruits_meadow2: [
        [
            {
                id: IdAssetBundleBuildings.meadow_seeds_citrusFruits_1,
                offset: [-41, -129],
            },
        ],
        [
            {
                id: IdAssetBundleBuildings.meadow_seeds_citrusFruits_2,
                offset: [-40, -133],
            },
        ],
        [
            {
                id: IdAssetBundleBuildings.meadow_seeds_citrusFruits_3,
                offset: [-37, -137],
            },
        ],
    ], citrusFruits_meadow3: [
        [
            {
                id: IdAssetBundleBuildings.meadow_seeds_citrusFruits_1,
                offset: [-50, -128],
            },
        ],
        [
            {
                id: IdAssetBundleBuildings.meadow_seeds_citrusFruits_2,
                offset: [-48, -136],
            },
        ],
        [
            {
                id: IdAssetBundleBuildings.meadow_seeds_citrusFruits_3,
                offset: [-49, -144],
            },
        ],
    ], citrusFruits_meadow4: [
        [
            {
                id: IdAssetBundleBuildings.meadow_seeds_citrusFruits_1,
                offset: [-51, -128],
            },
        ],
        [
            {
                id: IdAssetBundleBuildings.meadow_seeds_citrusFruits_2,
                offset: [-50, -138],
            },
        ],
        [
            {
                id: IdAssetBundleBuildings.meadow_seeds_citrusFruits_3,
                offset: [-49, -142],
            },
        ],
    ], citrusFruits_meadow5: [
        [
            {
                id: IdAssetBundleBuildings.meadow_seeds_citrusFruits_1,
                offset: [-45, -133],
            },
        ],
        [
            {
                id: IdAssetBundleBuildings.meadow_seeds_citrusFruits_2,
                offset: [-42, -141],
            },
        ],
        [
            {
                id: IdAssetBundleBuildings.meadow_seeds_citrusFruits_3,
                offset: [-43, -148],
            },
        ],
    ], citrusFruits_meadow6: [
        [
            {
                id: IdAssetBundleBuildings.meadow_seeds_citrusFruits_1,
                offset: [-50, -126],
            },
        ],
        [
            {
                id: IdAssetBundleBuildings.meadow_seeds_citrusFruits_2,
                offset: [-45, -133],
            },
        ],
        [
            {
                id: IdAssetBundleBuildings.meadow_seeds_citrusFruits_3,
                offset: [-45, -140],
            },
        ],
    ], citrusFruits_meadow7: [
        [
            {
                id: IdAssetBundleBuildings.meadow_seeds_citrusFruits_1,
                offset: [-56, -127],
            },
        ],
        [
            {
                id: IdAssetBundleBuildings.meadow_seeds_citrusFruits_2,
                offset: [-53, -136],
            },
        ],
        [
            {
                id: IdAssetBundleBuildings.meadow_seeds_citrusFruits_3,
                offset: [-53, -145],
            },
        ],
    ], cocoa_meadow1: [
        [
            {
                id: IdAssetBundleBuildings.meadow_seeds_cocoa_1,
                offset: [-49, -133],
            },
        ],
        [
            {
                id: IdAssetBundleBuildings.meadow_seeds_cocoa_2,
                offset: [-45, -139],
            },
        ],
        [
            {
                id: IdAssetBundleBuildings.meadow_seeds_cocoa_3,
                offset: [-44, -148],
            },
        ],
    ], cocoa_meadow2: [
        [
            {
                id: IdAssetBundleBuildings.meadow_seeds_cocoa_1,
                offset: [-41, -129],
            },
        ],
        [
            {
                id: IdAssetBundleBuildings.meadow_seeds_cocoa_2,
                offset: [-40, -133],
            },
        ],
        [
            {
                id: IdAssetBundleBuildings.meadow_seeds_cocoa_3,
                offset: [-37, -137],
            },
        ],
    ], cocoa_meadow3: [
        [
            {
                id: IdAssetBundleBuildings.meadow_seeds_cocoa_1,
                offset: [-50, -128],
            },
        ],
        [
            {
                id: IdAssetBundleBuildings.meadow_seeds_cocoa_2,
                offset: [-48, -136],
            },
        ],
        [
            {
                id: IdAssetBundleBuildings.meadow_seeds_cocoa_3,
                offset: [-49, -144],
            },
        ],
    ], cocoa_meadow4: [
        [
            {
                id: IdAssetBundleBuildings.meadow_seeds_cocoa_1,
                offset: [-51, -128],
            },
        ],
        [
            {
                id: IdAssetBundleBuildings.meadow_seeds_cocoa_2,
                offset: [-50, -138],
            },
        ],
        [
            {
                id: IdAssetBundleBuildings.meadow_seeds_cocoa_3,
                offset: [-49, -142],
            },
        ],
    ], cocoa_meadow5: [
        [
            {
                id: IdAssetBundleBuildings.meadow_seeds_cocoa_1,
                offset: [-45, -133],
            },
        ],
        [
            {
                id: IdAssetBundleBuildings.meadow_seeds_cocoa_2,
                offset: [-42, -141],
            },
        ],
        [
            {
                id: IdAssetBundleBuildings.meadow_seeds_cocoa_3,
                offset: [-43, -148],
            },
        ],
    ], cocoa_meadow6: [
        [
            {
                id: IdAssetBundleBuildings.meadow_seeds_cocoa_1,
                offset: [-50, -126],
            },
        ],
        [
            {
                id: IdAssetBundleBuildings.meadow_seeds_cocoa_2,
                offset: [-45, -133],
            },
        ],
        [
            {
                id: IdAssetBundleBuildings.meadow_seeds_cocoa_3,
                offset: [-45, -140],
            },
        ],
    ], cocoa_meadow7: [
        [
            {
                id: IdAssetBundleBuildings.meadow_seeds_cocoa_1,
                offset: [-56, -127],
            },
        ],
        [
            {
                id: IdAssetBundleBuildings.meadow_seeds_cocoa_2,
                offset: [-53, -136],
            },
        ],
        [
            {
                id: IdAssetBundleBuildings.meadow_seeds_cocoa_3,
                offset: [-53, -145],
            },
        ],
    ], corn_acre1: [
        [
            {
                id: IdAssetBundleBuildingsInitial.acre_seeds_corn_1,
                offset: [-49, -113],
            },
        ],
        [
            {
                id: IdAssetBundleBuildingsInitial.acre_seeds_corn_2,
                offset: [-56, -125],
            },
        ],
        [
            {
                id: IdAssetBundleBuildingsInitial.acre_seeds_corn_3,
                offset: [-54, -127],
            },
        ],
    ], corn_acre2: [
        [
            {
                id: IdAssetBundleBuildingsInitial.acre_seeds_corn_1,
                offset: [-49, -110],
            },
        ],
        [
            {
                id: IdAssetBundleBuildingsInitial.acre_seeds_corn_2,
                offset: [-57, -124],
            },
        ],
        [
            {
                id: IdAssetBundleBuildingsInitial.acre_seeds_corn_3,
                offset: [-56, -125],
            },
        ],
    ], corn_acre3: [
        [
            {
                id: IdAssetBundleBuildingsInitial.acre_seeds_corn_1,
                offset: [-49, -111],
            },
        ],
        [
            {
                id: IdAssetBundleBuildingsInitial.acre_seeds_corn_2,
                offset: [-56, -124],
            },
        ],
        [
            {
                id: IdAssetBundleBuildingsInitial.acre_seeds_corn_3,
                offset: [-55, -125],
            },
        ],
    ], corn_acre4: [
        [
            {
                id: IdAssetBundleBuildingsInitial.acre_seeds_corn_1,
                offset: [-57, -116],
            },
        ],
        [
            {
                id: IdAssetBundleBuildingsInitial.acre_seeds_corn_2,
                offset: [-55, -126],
            },
        ],
        [
            {
                id: IdAssetBundleBuildingsInitial.acre_seeds_corn_3,
                offset: [-51, -125],
            },
        ],
    ], corn_acre5: [
        [
            {
                id: IdAssetBundleBuildingsInitial.acre_seeds_corn_1,
                offset: [-45, -116],
            },
        ],
        [
            {
                id: IdAssetBundleBuildingsInitial.acre_seeds_corn_2,
                offset: [-58, -127],
            },
        ],
        [
            {
                id: IdAssetBundleBuildingsInitial.acre_seeds_corn_3,
                offset: [-54, -124],
            },
        ],
    ], corn_acre6: [
        [
            {
                id: IdAssetBundleBuildingsInitial.acre_seeds_corn_1,
                offset: [-59, -115],
            },
        ],
        [
            {
                id: IdAssetBundleBuildingsInitial.acre_seeds_corn_2,
                offset: [-55, -124],
            },
        ],
        [
            {
                id: IdAssetBundleBuildingsInitial.acre_seeds_corn_3,
                offset: [-60, -124],
            },
        ],
    ], corn_acre7: [
        [
            {
                id: IdAssetBundleBuildingsInitial.acre_seeds_corn_1,
                offset: [-48, -97],
            },
        ],
        [
            {
                id: IdAssetBundleBuildingsInitial.acre_seeds_corn_2,
                offset: [-52, -112],
            },
        ],
        [
            {
                id: IdAssetBundleBuildingsInitial.acre_seeds_corn_3,
                offset: [-60, -124],
            },
        ],
    ], corn_acre8: [
        [
            {
                id: IdAssetBundleBuildingsInitial.acre_seeds_corn_1,
                offset: [-48, -103],
            },
        ],
        [
            {
                id: IdAssetBundleBuildingsInitial.acre_seeds_corn_2,
                offset: [-52, -112],
            },
        ],
        [
            {
                id: IdAssetBundleBuildingsInitial.acre_seeds_corn_3,
                offset: [-55, -119],
            },
        ],
    ], daisies_acre1: [
        [
            {
                id: IdAssetBundleBuildings.acre_seeds_daisies_1,
                offset: [-55, -106],
            },
        ],
        [
            {
                id: IdAssetBundleBuildings.acre_seeds_daisies_2,
                offset: [-57, -106],
            },
        ],
        [
            {
                id: IdAssetBundleBuildings.acre_seeds_daisies_3,
                offset: [-55, -113],
            },
        ],
    ], daisies_acre2: [
        [
            {
                id: IdAssetBundleBuildings.acre_seeds_daisies_1,
                offset: [-48, -104],
            },
        ],
        [
            {
                id: IdAssetBundleBuildings.acre_seeds_daisies_2,
                offset: [-51, -107],
            },
        ],
        [
            {
                id: IdAssetBundleBuildings.acre_seeds_wildflowers_3,
                offset: [-52, -106],
            },
        ],
    ], daisies_acre3: [
        [
            {
                id: IdAssetBundleBuildings.acre_seeds_daisies_1,
                offset: [-51, -104],
            },
        ],
        [
            {
                id: IdAssetBundleBuildings.acre_seeds_daisies_2,
                offset: [-51, -106],
            },
        ],
        [
            {
                id: IdAssetBundleBuildings.acre_seeds_daisies_3,
                offset: [-51, -108],
            },
        ],
    ], daisies_acre4: [
        [
            {
                id: IdAssetBundleBuildings.acre_seeds_daisies_1,
                offset: [-46, -109],
            },
        ],
        [
            {
                id: IdAssetBundleBuildings.acre_seeds_daisies_2,
                offset: [-44, -111],
            },
        ],
        [
            {
                id: IdAssetBundleBuildings.acre_seeds_daisies_3,
                offset: [-52, -110],
            },
        ],
    ], daisies_acre5: [
        [
            {
                id: IdAssetBundleBuildings.acre_seeds_daisies_1,
                offset: [-51, -111],
            },
        ],
        [
            {
                id: IdAssetBundleBuildings.acre_seeds_daisies_2,
                offset: [-50, -107],
            },
        ],
        [
            {
                id: IdAssetBundleBuildings.acre_seeds_daisies_3,
                offset: [-50, -108],
            },
        ],
    ], daisies_acre6: [
        [
            {
                id: IdAssetBundleBuildings.acre_seeds_daisies_1,
                offset: [-50, -109],
            },
        ],
        [
            {
                id: IdAssetBundleBuildings.acre_seeds_daisies_2,
                offset: [-55, -111],
            },
        ],
        [
            {
                id: IdAssetBundleBuildings.acre_seeds_daisies_3,
                offset: [-54, -109],
            },
        ],
    ], daisies_acre7: [
        [
            {
                id: IdAssetBundleBuildings.acre_seeds_daisies_1,
                offset: [-50, -97],
            },
        ],
        [
            {
                id: IdAssetBundleBuildings.acre_seeds_daisies_2,
                offset: [-52, -104],
            },
        ],
        [
            {
                id: IdAssetBundleBuildings.acre_seeds_daisies_3,
                offset: [-52, -104],
            },
        ],
    ], daisies_acre8: [
        [
            {
                id: IdAssetBundleBuildings.acre_seeds_daisies_1,
                offset: [-47, -103],
            },
        ],
        [
            {
                id: IdAssetBundleBuildings.acre_seeds_daisies_2,
                offset: [-47, -100],
            },
        ],
        [
            {
                id: IdAssetBundleBuildings.acre_seeds_daisies_3,
                offset: [-52, -104],
            },
        ],
    ], dandelion_acre1: [
        [
            {
                id: IdAssetBundleBuildings.acre_seeds_dandelion_1,
                offset: [-52, -107],
            },
        ],
        [
            {
                id: IdAssetBundleBuildings.acre_seeds_dandelion_2,
                offset: [-50, -107],
            },
        ],
        [
            {
                id: IdAssetBundleBuildings.acre_seeds_dandelion_3,
                offset: [-52, -116],
            },
        ],
    ], dandelion_acre2: [
        [
            {
                id: IdAssetBundleBuildings.acre_seeds_dandelion_1,
                offset: [-52, -107],
            },
        ],
        [
            {
                id: IdAssetBundleBuildings.acre_seeds_dandelion_2,
                offset: [-50, -107],
            },
        ],
        [
            {
                id: IdAssetBundleBuildings.acre_seeds_dandelion_3,
                offset: [-52, -116],
            },
        ],
    ], dandelion_acre3: [
        [
            {
                id: IdAssetBundleBuildings.acre_seeds_dandelion_1,
                offset: [-52, -108],
            },
        ],
        [
            {
                id: IdAssetBundleBuildings.acre_seeds_dandelion_2,
                offset: [-50, -108],
            },
        ],
        [
            {
                id: IdAssetBundleBuildings.acre_seeds_dandelion_3,
                offset: [-51, -109],
            },
        ],
    ], dandelion_acre4: [
        [
            {
                id: IdAssetBundleBuildings.acre_seeds_dandelion_1,
                offset: [-51, -109],
            },
        ],
        [
            {
                id: IdAssetBundleBuildings.acre_seeds_dandelion_2,
                offset: [-49, -109],
            },
        ],
        [
            {
                id: IdAssetBundleBuildings.acre_seeds_dandelion_3,
                offset: [-53, -109],
            },
        ],
    ], dandelion_acre5: [
        [
            {
                id: IdAssetBundleBuildings.acre_seeds_dandelion_1,
                offset: [-50, -107],
            },
        ],
        [
            {
                id: IdAssetBundleBuildings.acre_seeds_dandelion_2,
                offset: [-48, -107],
            },
        ],
        [
            {
                id: IdAssetBundleBuildings.acre_seeds_dandelion_3,
                offset: [-51, -109],
            },
        ],
    ], dandelion_acre6: [
        [
            {
                id: IdAssetBundleBuildings.acre_seeds_dandelion_1,
                offset: [-53, -102],
            },
        ],
        [
            {
                id: IdAssetBundleBuildings.acre_seeds_dandelion_2,
                offset: [-51, -102],
            },
        ],
        [
            {
                id: IdAssetBundleBuildings.acre_seeds_dandelion_3,
                offset: [-54, -108],
            },
        ],
    ], dandelion_acre7: [
        [
            {
                id: IdAssetBundleBuildings.acre_seeds_dandelion_1,
                offset: [-53, -102],
            },
        ],
        [
            {
                id: IdAssetBundleBuildings.acre_seeds_dandelion_2,
                offset: [-51, -102],
            },
        ],
        [
            {
                id: IdAssetBundleBuildings.acre_seeds_dandelion_3,
                offset: [-54, -108],
            },
        ],
    ], dandelion_acre8: [
        [
            {
                id: IdAssetBundleBuildings.acre_seeds_dandelion_1,
                offset: [-53, -102],
            },
        ],
        [
            {
                id: IdAssetBundleBuildings.acre_seeds_dandelion_2,
                offset: [-51, -102],
            },
        ],
        [
            {
                id: IdAssetBundleBuildings.acre_seeds_dandelion_3,
                offset: [-54, -108],
            },
        ],
    ], duckFeathers_duckCoop1: [
        [
            {
                id: "duck",
                offset: [-90, -127],
                anims: [[], ["idle", "idle2", "walk_loop"], ["idle", "idle2"]],
                scale: 0.0499,
            },
            {
                id: "duck",
                offset: [47, -68],
                anims: [[], ["swim_idle", "swim_walk", "swim_idle"], ["swim_idle"]],
                scale: -0.0499,
            },
        ],
    ], duckFeathers_duckCoop2: [
        [
            {
                id: "duck",
                offset: [-114, -87],
                anims: [[], ["idle", "walk_loop"], ["idle2"]],
                scale: 0.0499,
            },
            {
                id: "duck",
                offset: [-54, -118],
                anims: [[], ["idle", "idle2"], ["idle2"]],
                scale: 0.0499,
            },
            {
                id: "duck",
                offset: [2, -77],
                anims: [[], ["swim_walk", "swim_idle"], ["swim_idle"]],
                scale: 0.0499,
            },
        ],
    ], duckFeathers_duckCoop3: [
        [
            {
                id: "duck",
                offset: [-81, -114],
                anims: [[], ["idle", "idle2", "walk_loop"], ["idle2"]],
                scale: 0.0499,
            },
            {
                id: "duck",
                offset: [-144, -116],
                anims: [[], ["idle", "idle2", "idle2"], ["idle2", "idle"]],
                scale: 0.0499,
            },
            {
                id: "duck",
                offset: [38, -99],
                anims: [[], ["idle"], ["idle2"]],
                scale: -0.0499,
            },
        ],
    ], duckFeathers_duckCoop4: [
        [
            {
                id: "duck",
                offset: [-100, -120],
                anims: [[], ["idle", "walk_loop"], ["idle2"]],
                scale: 0.0499,
            },
            {
                id: "duck",
                offset: [-107, -93],
                anims: [[], ["swim_idle"], ["swim_idle"]],
                scale: -0.0499,
            },
            {
                id: "duck",
                offset: [4, -78],
                anims: [[], ["swim_walk", "swim_idle"], ["swim_idle"]],
                scale: 0.0499,
            },
            {
                id: "duck",
                offset: [34, -64],
                anims: [[], ["swim_idle", "swim_walk"], ["swim_idle"]],
                scale: -0.0499,
            },
        ],
    ], duckFeathers_duckCoop5: [
        [
            {
                id: "duck",
                offset: [-76, -151],
                anims: [[], ["idle", "idle2"], ["idle2"]],
                scale: -0.045,
            },
            {
                id: "duck",
                offset: [37, -97],
                anims: [[], ["idle", "idle2"], ["idle", "idle2"]],
                scale: 0.0499,
            },
            {
                id: "duck",
                offset: [-98, -88],
                anims: [[], ["swim_idle", "swim_idle", "swim_walk"], ["swim_idle"]],
                scale: 0.0499,
            },
            {
                id: "duck",
                offset: [16, -76],
                anims: [[], ["swim_walk", "swim_walk", "swim_idle"], ["swim_idle"]],
                scale: -0.0499,
            },
            {
                id: "duck",
                offset: [-41, -76],
                anims: [[], ["swim_walk", "swim_idle"], ["swim_idle"]],
                scale: 0.0499,
            },
        ],
    ], duckFeathers_duckCoop6: [
        [
            {
                id: "duck",
                offset: [-54, -110],
                anims: [[], ["idle"], ["idle", "idle2"]],
                scale: 0.0499,
            },
            {
                id: "duck",
                offset: [-117, -91],
                anims: [[], ["swim_idle"], ["swim_idle"]],
                scale: -0.0499,
            },
            {
                id: "duck",
                offset: [-69, -69],
                anims: [[], ["swim_idle", "swim_walk"], ["swim_idle"]],
                scale: 0.0499,
            },
            {
                id: "duck",
                offset: [30, -88],
                anims: [[], ["swim_idle"], ["swim_idle"]],
                scale: 0.0499,
            },
            {
                id: "duck",
                offset: [55, -80],
                anims: [[], ["swim_idle", "swim_walk"], ["swim_idle"]],
                scale: -0.0499,
            },
            {
                id: "duck",
                offset: [3, -127],
                anims: [[], ["idle", "idle2", "idle"], ["idle", "idle2"]],
                scale: -0.0499,
            },
        ],
    ], duckFeathers_duckCoop7: [
        [
            {
                id: "duck",
                offset: [-54, -110],
                anims: [[], ["idle", "idle2"], ["idle", "idle2"]],
                scale: -0.0499,
            },
            {
                id: "duck",
                offset: [-91, -97],
                anims: [[], ["swim_idle", "swim_walk"], ["swim_idle"]],
                scale: 0.0499,
            },
            {
                id: "duck",
                offset: [-56, -69],
                anims: [[], ["swim_idle", "swim_walk"], ["idle2"]],
                scale: 0.0499,
            },
            {
                id: "duck",
                offset: [30, -88],
                anims: [[], ["swim_idle", "swim_walk"], ["swim_idle"]],
                scale: 0.0499,
            },
            {
                id: "duck",
                offset: [55, -80],
                anims: [[], ["swim_idle"], ["swim_idle"]],
                scale: 0.0499,
            },
            {
                id: "duck",
                offset: [3, -127],
                anims: [[], ["idle", "walk_loop"], ["idle2"]],
                scale: -0.0499,
            },
        ],
    ], duckFeathers_freeRangeDuckCoop1: [
        [
            {
                id: "duck",
                offset: [-80, -114],
                anims: [[], ["idle", "walk_loop"], ["idle", "idle2"]],
                scale: 0.0499,
            },
        ],
    ], duckFeathers_freeRangeDuckCoop2: [
        [
            {
                id: "duck",
                offset: [-77, -113],
                anims: [[], ["idle", "walk_loop"], ["idle", "idle2"]],
                scale: 0.0499,
            },
            {
                id: "duck",
                offset: [2, -77],
                anims: [[], ["swim_idle", "swim_walk"], ["swim_idle"]],
                scale: 0.0499,
            },
        ],
    ], duckFeathers_freeRangeDuckCoop3: [
        [
            {
                id: "duck",
                offset: [-81, -114],
                anims: [[], ["idle", "walk_loop"], ["idle2"]],
                scale: 0.0499,
            },
            {
                id: "duck",
                offset: [-107, -93],
                anims: [[], ["swim_idle"], ["swim_idle"]],
                scale: 0.0499,
            },
            {
                id: "duck",
                offset: [2, -77],
                anims: [[], ["swim_idle"], ["swim_idle"]],
                scale: -0.0499,
            },
        ],
    ], duckFeathers_freeRangeDuckCoop4: [
        [
            {
                id: "duck",
                offset: [-77, -115],
                anims: [[], ["idle", "walk_loop"], ["idle", "idle2"]],
                scale: 0.0499,
            },
            {
                id: "duck",
                offset: [-107, -93],
                anims: [[], ["swim_idle"], ["swim_idle"]],
                scale: 0.0499,
            },
            {
                id: "duck",
                offset: [4, -78],
                anims: [[], ["swim_idle", "swim_walk"], ["swim_idle"]],
                scale: 0.0499,
            },
            {
                id: "duck",
                offset: [34, -64],
                anims: [[], ["swim_idle", "swim_walk"], ["swim_idle"]],
                scale: -0.0499,
            },
        ],
    ], duckFeathers_freeRangeDuckCoop5: [
        [
            {
                id: "duck",
                offset: [-80, -154],
                anims: [[], ["idle"], ["idle", "idle2"]],
                scale: 0.045,
            },
            {
                id: "duck",
                offset: [-77, -115],
                anims: [[], ["idle", "walk_loop"], ["idle2"]],
                scale: 0.0499,
            },
            {
                id: "duck",
                offset: [-98, -88],
                anims: [[], ["swim_idle", "swim_walk"], ["swim_idle"]],
                scale: 0.0499,
            },
            {
                id: "duck",
                offset: [31, -59],
                anims: [[], ["swim_idle", "swim_walk"], ["swim_idle"]],
                scale: -0.0499,
            },
            {
                id: "duck",
                offset: [-43, -73],
                anims: [[], ["swim_idle", "swim_walk"], ["swim_idle"]],
                scale: 0.0499,
            },
        ],
    ], duckFeathers_freeRangeDuckCoop6: [
        [
            {
                id: "duck",
                offset: [-80, -154],
                anims: [[], ["idle", "idle2"], ["idle", "idle2"]],
                scale: -0.045,
            },
            {
                id: "duck",
                offset: [-77, -115],
                anims: [[], ["idle", "idle2", "idle"], ["idle", "idle2"]],
                scale: 0.0499,
            },
            {
                id: "duck",
                offset: [-98, -88],
                anims: [[], ["swim_idle"], ["swim_idle"]],
                scale: -0.0499,
            },
            {
                id: "duck",
                offset: [31, -59],
                anims: [[], ["swim_idle", "swim_walk"], ["swim_idle"]],
                scale: -0.0499,
            },
            {
                id: "duck",
                offset: [-43, -73],
                anims: [[], ["swim_idle", "swim_walk"], ["swim_idle"]],
                scale: -0.0499,
            },
            {
                id: "duck",
                offset: [60, -94],
                anims: [[], ["idle", "idle"], ["idle", "idle2"]],
                scale: -0.045,
            },
        ],
    ], duckFeathers_freeRangeDuckCoop7: [
        [
            {
                id: "duck",
                offset: [-80, -154],
                anims: [[], ["idle"], ["idle2"]],
                scale: -0.045,
            },
            {
                id: "duck",
                offset: [-77, -115],
                anims: [[], ["idle", "walk_loop", "idle"], ["idle", "idle2"]],
                scale: 0.0499,
            },
            {
                id: "duck",
                offset: [-98, -88],
                anims: [[], ["swim_idle"], ["swim_idle"]],
                scale: 0.0499,
            },
            {
                id: "duck",
                offset: [31, -59],
                anims: [[], ["swim_idle", "swim_walk"], ["swim_idle"]],
                scale: -0.0499,
            },
            {
                id: "duck",
                offset: [-43, -73],
                anims: [[], ["swim_idle", "swim_walk"], ["swim_idle"]],
                scale: -0.0499,
            },
            {
                id: "duck",
                offset: [60, -94],
                anims: [[], ["idle", "idle2"], ["idle", "idle2"]],
                scale: 0.045,
            },
        ],
    ], eggs_candyChickenCoop1: [
        [
            {
                id: "chicken",
                offset: [12, -54],
                anims: [[], ["idle", "chicken_full_1", "peck"], ["idle", "idle", "flap"]],
                scale: 0.0832,
            },
            {
                id: "chicken",
                offset: [-55, -67],
                anims: [[], ["chicken_full_1", "idle", "peck"], ["idle", "peck", "idle"]],
                scale: 0.0832,
            },
        ],
    ], eggs_candyChickenCoop2: [
        [
            {
                id: "chicken",
                offset: [-38, -64],
                anims: [[], ["chicken_full_2", "idle", "idle", "peck"], ["flap", "flap", "idle"]],
                scale: 0.0832,
            },
            {
                id: "chicken",
                offset: [23, -68],
                anims: [[], ["chicken_full_1", "jump", "peck"], ["idle", "peck", "flap"]],
                scale: 0.0832,
            },
        ],
    ], eggs_candyChickenCoop3: [
        [
            {
                id: "chicken",
                offset: [48, -64],
                anims: [[], ["idle", "idle", "jump"], ["idle", "idle", "flap"]],
                scale: 0.0832,
            },
            {
                id: "chicken",
                offset: [-61, -69],
                anims: [[], ["jump", "chicken_full_2", "idle", "idle"], ["idle", "flap"]],
                scale: 0.0832,
            },
        ],
    ], eggs_candyChickenCoop4: [
        [
            {
                id: "chicken",
                offset: [-14, -53],
                anims: [[], ["idle", "peck"], ["idle", "peck", "flap", "idle"]],
                scale: 0.0832,
            },
            {
                id: "chicken",
                offset: [51, -51],
                anims: [
                    [],
                    ["chicken_full_2", "flap", "chicken_full_3", "idle"],
                    ["flap", "idle", "idle", "flap"],
                ],
                scale: 0.0832,
            },
            {
                id: "chicken",
                offset: [41, -78],
                anims: [[], ["chicken_full_3", "idle"], ["flap", "idle", "flap"]],
                scale: 0.0832,
            },
        ],
    ], eggs_candyChickenCoop5: [
        [
            {
                id: "chicken",
                offset: [-24, -53],
                anims: [
                    [],
                    ["idle", "chicken_full_3", "chicken_full_1", "idle"],
                    ["idle", "flap", "idle"],
                ],
                scale: 0.0832,
            },
            {
                id: "chicken",
                offset: [56, -65],
                anims: [[], ["chicken_full_2", "chicken_full_1", "jump"], ["idle", "flap", "jump"]],
                scale: 0.0832,
            },
            {
                id: "chicken",
                offset: [32, -78],
                anims: [[], ["idle", "chicken_full_2", "flap", "peck", "idle"], ["idle", "flap"]],
                scale: 0.0832,
            },
        ],
    ], eggs_candyChickenCoop6: [
        [
            {
                id: "chicken",
                offset: [-9, -36],
                anims: [[], ["chicken_full_1", "chicken_full_3", "idle", "idle"], ["flap", "idle"]],
                scale: 0.0832,
            },
            {
                id: "chicken",
                offset: [46, -68],
                anims: [[], ["chicken_full_1", "idle", "jump"], ["flap", "idle", "idle", "jump"]],
                scale: 0.0832,
            },
        ],
    ], eggs_candyChickenCoop7: [
        [
            {
                id: "chicken",
                offset: [-4, -45],
                anims: [[], ["idle", "chicken_full_1", "peck"], ["flap", "idle", "idle"]],
                scale: 0.0832,
            },
            {
                id: "chicken",
                offset: [41, -79],
                anims: [[], ["idle", "chicken_full_3", "idle", "peck"], ["idle", "flap", "idle"]],
                scale: -0.0832,
            },
        ],
    ], eggs_chickenCoop1: [
        [
            {
                id: "chicken",
                offset: [12, -54],
                anims: [[], ["idle", "chicken_full_1", "peck"], ["idle", "idle", "flap"]],
                scale: 0.0832,
            },
            {
                id: "chicken",
                offset: [-55, -67],
                anims: [[], ["chicken_full_1", "idle", "peck"], ["idle", "peck", "idle"]],
                scale: 0.0832,
            },
        ],
    ], eggs_chickenCoop2: [
        [
            {
                id: "chicken",
                offset: [-13, -54],
                anims: [[], ["chicken_full_2", "idle", "idle", "peck"], ["flap", "flap", "idle"]],
                scale: 0.0832,
            },
            {
                id: "chicken",
                offset: [23, -68],
                anims: [[], ["chicken_full_1", "jump", "peck"], ["idle", "peck", "flap"]],
                scale: 0.0832,
            },
        ],
    ], eggs_chickenCoop3: [
        [
            {
                id: "chicken",
                offset: [3, -145],
                anims: [
                    [],
                    ["chicken_full_1", "chicken_full_2", "chicken_full_3"],
                    ["chicken_full_2", "flap", "flap"],
                ],
                scale: 0.0832,
            },
            {
                id: "chicken",
                offset: [48, -64],
                anims: [[], ["idle", "idle", "jump"], ["idle", "idle", "flap"]],
                scale: 0.0832,
            },
            {
                id: "chicken",
                offset: [-61, -69],
                anims: [[], ["jump", "chicken_full_2", "idle", "idle"], ["idle", "flap"]],
                scale: 0.0832,
            },
        ],
    ], eggs_chickenCoop4: [
        [
            {
                id: "chicken",
                offset: [-68, -57],
                anims: [[], ["idle", "flap", "peck"], ["idle", "flap", "idle", "idle"]],
                scale: 0.0832,
            },
            {
                id: "chicken",
                offset: [-28, -38],
                anims: [[], ["idle", "peck"], ["idle", "peck", "flap", "idle"]],
                scale: 0.0832,
            },
            {
                id: "chicken",
                offset: [51, -45],
                anims: [
                    [],
                    ["chicken_full_2", "flap", "chicken_full_3", "idle"],
                    ["flap", "idle", "idle", "flap"],
                ],
                scale: 0.0832,
            },
            {
                id: "chicken",
                offset: [47, -68],
                anims: [[], ["chicken_full_3", "idle"], ["flap", "idle", "flap"]],
                scale: 0.0832,
            },
        ],
    ], eggs_chickenCoop5: [
        [
            {
                id: "chicken",
                offset: [-24, -44],
                anims: [
                    [],
                    ["idle", "chicken_full_3", "chicken_full_1", "idle"],
                    ["idle", "flap", "idle"],
                ],
                scale: 0.0832,
            },
            {
                id: "chicken",
                offset: [68, -65],
                anims: [[], ["chicken_full_2", "chicken_full_1", "jump"], ["idle", "flap", "jump"]],
                scale: 0.0832,
            },
            {
                id: "chicken",
                offset: [6, -162],
                anims: [[], ["idle", "chicken_full_2", "flap", "peck", "idle"], ["idle", "flap"]],
                scale: 0.0832,
            },
            {
                id: "chicken",
                offset: [-88, -116],
                anims: [
                    [],
                    ["idle", "idle", "jump", "idle", "idle"],
                    ["flap", "idle", "jump", "idle"],
                ],
                scale: 0.0832,
            },
        ],
    ], eggs_chickenCoop6: [
        [
            {
                id: "chicken",
                offset: [-9, -31],
                anims: [[], ["chicken_full_1", "chicken_full_3", "idle", "idle"], ["flap", "idle"]],
                scale: 0.0832,
            },
            {
                id: "chicken",
                offset: [72, -56],
                anims: [[], ["chicken_full_1", "idle", "jump"], ["flap", "idle", "idle", "jump"]],
                scale: 0.0832,
            },
            {
                id: "chicken",
                offset: [-34, -85],
                anims: [[], ["idle", "jump", "idle"], ["flap", "flap", "idle"]],
                scale: 0.0832,
            },
        ],
    ], eggs_chickenCoop7: [
        [
            {
                id: "chicken",
                offset: [-8, -39],
                anims: [[], ["idle", "chicken_full_1", "peck"], ["flap", "idle", "idle"]],
                scale: 0.0832,
            },
            {
                id: "chicken",
                offset: [-42, -99],
                anims: [[], ["idle", "jump", "peck"], ["flap", "idle", "jump"]],
                scale: 0.0832,
            },
            {
                id: "chicken",
                offset: [58, -61],
                anims: [[], ["idle", "chicken_full_3", "idle", "peck"], ["idle", "flap", "idle"]],
                scale: -0.0832,
            },
            {
                id: "chicken",
                offset: [-22, -199],
                anims: [[], ["idle", "chicken_full_2"], ["idle", "idle", "flap"]],
                scale: -0.0832,
            },
        ],
    ], eggs_freeRangeChickenCoop1: [
        [
            {
                id: "chicken",
                offset: [39, -69],
                anims: [[], ["chicken_full_1", "idle", "peck", "idle"], ["idle", "flap", "idle"]],
                scale: 0.0832,
            },
            {
                id: "chicken",
                offset: [-53, -65],
                anims: [[], ["chicken_full_2", "idle", "jump"], ["idle", "flap", "jump", "idle"]],
                scale: -0.0832,
            },
        ],
    ], eggs_freeRangeChickenCoop2: [
        [
            {
                id: "chicken",
                offset: [10, -23],
                anims: [[], ["idle", "chicken_full_3", "peck", "idle"], ["flap", "idle", "idle"]],
                scale: 0.0832,
            },
            {
                id: "chicken",
                offset: [-38, -72],
                anims: [
                    [],
                    ["chicken_full_2", "chicken_full_1", "chicken_full_3", "idle", "jump", "peck"],
                    ["idle", "jump", "flap"],
                ],
                scale: 0.0832,
            },
            {
                id: "chicken",
                offset: [43, -60],
                anims: [[], ["chicken_full_3", "chicken_full_2", "idle"], ["idle", "jump", "peck"]],
                scale: -0.0832,
            },
        ],
    ], eggs_freeRangeChickenCoop3: [
        [
            {
                id: "chicken",
                offset: [47, -62],
                anims: [
                    [],
                    ["chicken_full_1", "idle", "chicken_full_3", "jump"],
                    ["jump", "flap", "flap", "idle"],
                ],
                scale: -0.0832,
            },
            {
                id: "chicken",
                offset: [-60, -66],
                anims: [[], ["chicken_full_1", "idle", "idle", "peck"], ["flap", "idle"]],
                scale: 0.0832,
            },
            {
                id: "chicken",
                offset: [14, -157],
                anims: [[], ["chicken_full_2", "idle", "jump"], ["idle", "flap", "idle"]],
                scale: 0.0832,
            },
            {
                id: "chicken",
                offset: [29, -99],
                anims: [
                    [],
                    ["idle", "chicken_full_2", "chicken_full_1", "jump"],
                    ["peck", "flap", "idle"],
                ],
                scale: -0.0832,
            },
        ],
    ], eggs_freeRangeChickenCoop4: [
        [
            {
                id: "chicken",
                offset: [74, -47],
                anims: [
                    [],
                    ["chicken_full_1", "chicken_full_3", "chicken_full_3", "chicken_full_2"],
                    ["idle", "flap", "jump"],
                ],
                scale: 0.0832,
            },
            {
                id: "chicken",
                offset: [-101, -65],
                anims: [[], ["chicken_full_2", "idle", "jump"], ["idle", "flap", "idle"]],
                scale: -0.0832,
            },
            {
                id: "chicken",
                offset: [69, -74],
                anims: [
                    [],
                    ["chicken_full_2", "idle", "chicken_full_3", "jump"],
                    ["flap", "idle", "jump"],
                ],
                scale: -0.0832,
            },
            {
                id: "chicken",
                offset: [-25, -39],
                anims: [[], ["chicken_full_1", "idle", "peck", "idle"], ["peck", "flap", "idle"]],
                scale: 0.0832,
            },
        ],
    ], eggs_freeRangeChickenCoop5: [
        [
            {
                id: "chicken",
                offset: [48, -46],
                anims: [
                    [],
                    ["chicken_full_1", "chicken_full_3", "chicken_full_2", "idle"],
                    ["idle", "jump", "flap"],
                ],
                scale: 0.0832,
            },
            {
                id: "chicken",
                offset: [-87, -69],
                anims: [
                    [],
                    ["chicken_full_1", "chicken_full_3", "idle", "idle"],
                    ["flap", "idle", "peck"],
                ],
                scale: 0.0832,
            },
            {
                id: "chicken",
                offset: [34, -76],
                anims: [
                    [],
                    ["chicken_full_2", "chicken_full_1", "chicken_full_3", "idle"],
                    ["flap", "idle", "idle"],
                ],
                scale: 0.0832,
            },
            {
                id: "chicken",
                offset: [-32, -109],
                anims: [[], ["chicken_full_2", "idle", "jump"], ["idle", "flap", "peck"]],
                scale: 0.0832,
            },
            {
                id: "chicken",
                offset: [12, -155],
                anims: [[], ["idle", "flap", "idle", "idle"], ["flap", "idle"]],
                scale: 0.0832,
            },
        ],
    ], eggs_freeRangeChickenCoop6: [
        [
            {
                id: "chicken",
                offset: [13, -46],
                anims: [
                    [],
                    ["chicken_full_2", "chicken_full_1", "idle", "jump"],
                    ["flap", "idle", "idle"],
                ],
                scale: 0.0832,
            },
            {
                id: "chicken",
                offset: [87, -67],
                anims: [
                    [],
                    ["idle", "flap", "chicken_full_1", "chicken_full_3"],
                    ["flap", "peck", "idle", "idle"],
                ],
                scale: -0.0832,
            },
            {
                id: "chicken",
                offset: [-49, -107],
                anims: [
                    [],
                    ["chicken_full_1", "chicken_full_3", "jump"],
                    ["idle", "chicken_full_2", "chicken_full_1"],
                ],
                scale: 0.0832,
            },
            {
                id: "chicken",
                offset: [14, -157],
                anims: [[], ["idle", "flap", "jump"], ["idle", "flap", "idle"]],
                scale: 0.0832,
            },
            {
                id: "chicken",
                offset: [42, -79],
                anims: [
                    [],
                    ["chicken_full_2", "chicken_full_3", "jump", "peck", "idle"],
                    ["jump", "flap"],
                ],
                scale: -0.0832,
            },
            {
                id: "chicken",
                offset: [-87, -67],
                anims: [
                    [],
                    ["chicken_full_3", "chicken_full_3", "idle", "idle"],
                    ["idle", "jump", "idle"],
                ],
                scale: -0.0832,
            },
        ],
    ], eggs_freeRangeChickenCoop7: [
        [
            {
                id: "chicken",
                offset: [19, -11],
                anims: [[], ["chicken_full_1", "idle", "peck", "idle"], ["idle", "flap", "idle"]],
                scale: 0.0832,
            },
            {
                id: "chicken",
                offset: [-86, -68],
                anims: [[], ["chicken_full_3", "idle", "peck", "flap"], ["flap", "idle", "jump"]],
                scale: -0.0832,
            },
            {
                id: "chicken",
                offset: [16, -158],
                anims: [[], ["chicken_full_2", "idle", "peck"], ["idle", "flap"]],
                scale: 0.0832,
            },
            {
                id: "chicken",
                offset: [44, -81],
                anims: [
                    [],
                    ["chicken_full_1", "flap", "idle", "peck"],
                    ["flap", "idle", "jump", "peck"],
                ],
                scale: 0.0832,
            },
            {
                id: "chicken",
                offset: [86, -67],
                anims: [
                    [],
                    ["chicken_full_2", "chicken_full_1", "chicken_full_3"],
                    ["flap", "flap", "idle"],
                ],
                scale: 0.0832,
            },
            {
                id: "chicken",
                offset: [14, -44],
                anims: [[], ["chicken_full_1", "flap", "idle", "peck"], ["flap", "idle", "peck"]],
                scale: -0.0832,
            },
            {
                id: "chicken",
                offset: [-49, -106],
                anims: [[], ["flap", "chicken_full_2", "idle"], ["flap", "idle", "jump"]],
                scale: 0.0832,
            },
        ],
    ], ginger_acre1: [
        [
            {
                id: IdAssetBundleBuildings.acre_seeds_ginger_1,
                offset: [-51, -101],
            },
        ],
        [
            {
                id: IdAssetBundleBuildings.acre_seeds_ginger_2,
                offset: [-53, -112],
            },
        ],
        [
            {
                id: IdAssetBundleBuildings.acre_seeds_ginger_3,
                offset: [-53, -121],
            },
        ],
    ], ginger_acre2: [
        [
            {
                id: IdAssetBundleBuildings.acre_seeds_ginger_1,
                offset: [-51, -101],
            },
        ],
        [
            {
                id: IdAssetBundleBuildings.acre_seeds_ginger_2,
                offset: [-53, -112],
            },
        ],
        [
            {
                id: IdAssetBundleBuildings.acre_seeds_ginger_3,
                offset: [-53, -121],
            },
        ],
    ], ginger_acre3: [
        [
            {
                id: IdAssetBundleBuildings.acre_seeds_ginger_1,
                offset: [-51, -101],
            },
        ],
        [
            {
                id: IdAssetBundleBuildings.acre_seeds_ginger_2,
                offset: [-53, -112],
            },
        ],
        [
            {
                id: IdAssetBundleBuildings.acre_seeds_ginger_3,
                offset: [-53, -121],
            },
        ],
    ], ginger_acre4: [
        [
            {
                id: IdAssetBundleBuildings.acre_seeds_ginger_1,
                offset: [-51, -101],
            },
        ],
        [
            {
                id: IdAssetBundleBuildings.acre_seeds_ginger_2,
                offset: [-53, -112],
            },
        ],
        [
            {
                id: IdAssetBundleBuildings.acre_seeds_ginger_3,
                offset: [-53, -121],
            },
        ],
    ], ginger_acre5: [
        [
            {
                id: IdAssetBundleBuildings.acre_seeds_ginger_1,
                offset: [-51, -101],
            },
        ],
        [
            {
                id: IdAssetBundleBuildings.acre_seeds_ginger_2,
                offset: [-53, -112],
            },
        ],
        [
            {
                id: IdAssetBundleBuildings.acre_seeds_ginger_3,
                offset: [-53, -121],
            },
        ],
    ], ginger_acre6: [
        [
            {
                id: IdAssetBundleBuildings.acre_seeds_ginger_1,
                offset: [-51, -101],
            },
        ],
        [
            {
                id: IdAssetBundleBuildings.acre_seeds_ginger_2,
                offset: [-53, -112],
            },
        ],
        [
            {
                id: IdAssetBundleBuildings.acre_seeds_ginger_3,
                offset: [-53, -121],
            },
        ],
    ], ginger_acre7: [
        [
            {
                id: IdAssetBundleBuildings.acre_seeds_ginger_1,
                offset: [-51, -101],
            },
        ],
        [
            {
                id: IdAssetBundleBuildings.acre_seeds_ginger_2,
                offset: [-53, -112],
            },
        ],
        [
            {
                id: IdAssetBundleBuildings.acre_seeds_ginger_3,
                offset: [-53, -121],
            },
        ],
    ], ginger_acre8: [
        [
            {
                id: IdAssetBundleBuildings.acre_seeds_ginger_1,
                offset: [-51, -101],
            },
        ],
        [
            {
                id: IdAssetBundleBuildings.acre_seeds_ginger_2,
                offset: [-53, -112],
            },
        ],
        [
            {
                id: IdAssetBundleBuildings.acre_seeds_ginger_3,
                offset: [-53, -121],
            },
        ],
    ], goatCheese_freeRangeGoatStable1: [
        [
            {
                id: "Goat_big",
                offset: [-33, -55],
                anims: [[], ["eat", "idle1"], ["idle1"]],
                scale: 0.1665,
            },
        ],
    ], goatCheese_freeRangeGoatStable2: [
        [
            {
                id: "Goat_big",
                offset: [-32, -54],
                anims: [[], ["eat", "idle1"], ["idle1"]],
                scale: 0.1665,
            },
            {
                id: "Goaty",
                offset: [-37, -49],
                anims: [[], ["idle1"], ["idle1"]],
                scale: 0.1665,
            },
        ],
    ], goatCheese_freeRangeGoatStable3: [
        [
            {
                id: "Goat_big",
                offset: [-33, -55],
                anims: [[], ["eat", "idle1"], ["idle1"]],
                scale: 0.1665,
            },
            {
                id: "Goaty",
                offset: [-27, -52],
                anims: [[], ["idle1"], ["idle1"]],
                scale: 0.1665,
            },
            {
                id: "Goaty",
                offset: [-43, -128],
                anims: [[], ["idle1"], ["idle1"]],
                scale: 0.1665,
            },
        ],
    ], goatCheese_freeRangeGoatStable4: [
        [
            {
                id: "Goat_big",
                offset: [12, -79],
                anims: [[], ["eat", "idle1"], ["idle1"]],
                scale: 0.1665,
            },
            {
                id: "Goaty",
                offset: [7, -74],
                anims: [[], ["idle1"], ["idle1"]],
                scale: 0.1665,
            },
            {
                id: "Goat_big",
                offset: [23, -27],
                anims: [[], ["idle1", "eat"], ["idle1"]],
                scale: 0.1665,
            },
            {
                id: "Goaty",
                offset: [-145, -60],
                anims: [[], ["idle1"], ["idle1"]],
                scale: 0.1665,
            },
        ],
    ], goatCheese_freeRangeGoatStable5: [
        [
            {
                id: "Goat_big",
                offset: [-55, -95],
                anims: [[], ["idle1", "eat"], ["idle1"]],
                scale: 0.1665,
            },
            {
                id: "Goaty",
                offset: [-53, -91],
                anims: [[], ["idle1"], ["idle1"]],
                scale: 0.1665,
            },
            {
                id: "Goaty",
                offset: [-23, -81],
                anims: [[], ["idle1"], ["idle1"]],
                scale: 0.1665,
            },
            {
                id: "Goat_big",
                offset: [7, -47],
                anims: [[], ["eat", "idle1"], ["idle1"]],
                scale: 0.1665,
            },
            {
                id: "Goaty",
                offset: [2, -42],
                anims: [[], ["idle1"], ["idle1"]],
                scale: 0.1665,
            },
        ],
    ], goatCheese_freeRangeGoatStable6: [
        [
            {
                id: "Goat_big",
                offset: [-43, -92],
                anims: [[], ["eat", "idle1"], ["idle1"]],
                scale: 0.1665,
            },
            {
                id: "Goaty",
                offset: [-48, -88],
                anims: [[], ["idle1"], ["idle1"]],
                scale: 0.1665,
            },
            {
                id: "Goat_big",
                offset: [-4, -33],
                anims: [[], ["eat", "idle1"], ["idle1"]],
                scale: 0.1665,
            },
            {
                id: "Goaty",
                offset: [-126, -58],
                anims: [[], ["idle1"], ["idle1"]],
                scale: 0.1665,
            },
            {
                id: "Goat_big",
                offset: [51, -49],
                anims: [[], ["eat", "idle1"], ["idle1"]],
                scale: 0.1665,
            },
            {
                id: "Goaty",
                offset: [53, -45],
                anims: [[], ["idle1"], ["idle1"]],
                scale: 0.1665,
            },
        ],
    ], goatCheese_freeRangeGoatStable7: [
        [
            {
                id: "Goat_big",
                offset: [-4, -82],
                anims: [[], ["idle1", "eat"], ["idle1"]],
                scale: 0.1665,
            },
            {
                id: "Goaty",
                offset: [-9, -77],
                anims: [[], ["idle1"], ["idle1"]],
                scale: 0.1665,
            },
            {
                id: "Goat_big",
                offset: [-72, -38],
                anims: [[], ["eat", "idle1"], ["idle1"]],
                scale: 0.1665,
            },
            {
                id: "Goaty",
                offset: [-110, -65],
                anims: [[], ["idle1"], ["idle1"]],
                scale: 0.1665,
            },
            {
                id: "Goaty",
                offset: [53, -45],
                anims: [[], ["idle1"], ["idle1"]],
                scale: 0.1665,
            },
            {
                id: "Goaty",
                offset: [53, -45],
                anims: [[], ["idle1"], ["idle1"]],
                scale: 0.1665,
            },
            {
                id: "Goaty",
                offset: [-25, -124],
                anims: [[], ["idle1"], ["idle1"]],
                scale: 0.1665,
            },
        ],
    ], goatCheese_goatStable1: [
        [
            {
                id: "Goat_big",
                offset: [28, -69],
                anims: [[], ["idle1", "eat"], ["idle1"]],
                scale: 0.1665,
            },
        ],
    ], goatCheese_goatStable2: [
        [
            {
                id: "Goat_big",
                offset: [49, -66],
                anims: [[], ["idle1", "eat"], ["idle1"]],
                scale: 0.1665,
            },
            {
                id: "Goaty",
                offset: [39, -62],
                anims: [[], ["idle1"], ["idle1"]],
                scale: 0.1665,
            },
        ],
    ], goatCheese_goatStable3: [
        [
            {
                id: "Goat_big",
                offset: [67, -77],
                anims: [[], ["idle1", "eat"], ["idle1"]],
                scale: 0.1665,
            },
            {
                id: "Goaty",
                offset: [58, -73],
                anims: [[], ["idle1"], ["idle1"]],
                scale: 0.1665,
            },
            {
                id: "Goaty",
                offset: [-61, -75],
                anims: [[], ["idle1"], ["idle1"]],
                scale: -0.1665,
            },
        ],
    ], goatCheese_goatStable4: [
        [
            {
                id: "Goat_big",
                offset: [-11, -46],
                anims: [[], ["eat", "idle1"], ["idle1"]],
                scale: 0.1665,
            },
            {
                id: "Goaty",
                offset: [-7, -45],
                anims: [[], ["idle1"], ["idle1"]],
                scale: 0.1665,
            },
            {
                id: "Goaty",
                offset: [-26, -91],
                anims: [[], ["idle1"], ["idle1"]],
                scale: 0.1665,
            },
            {
                id: "Goat_big",
                offset: [110, -77],
                anims: [[], ["eat", "idle1"], ["idle1"]],
                scale: 0.1665,
            },
        ],
    ], goatCheese_goatStable5: [
        [
            {
                id: "Goat_big",
                offset: [-66, -64],
                anims: [[], ["idle1", "eat"], ["idle1"]],
                scale: 0.1665,
            },
            {
                id: "Goaty",
                offset: [-62, -62],
                anims: [[], ["idle1"], ["idle1"]],
                scale: 0.1665,
            },
            {
                id: "Goaty",
                offset: [13, -90],
                anims: [[], ["idle1"], ["idle1"]],
                scale: 0.1665,
            },
            {
                id: "Goat_big",
                offset: [66, -62],
                anims: [[], ["idle1", "eat"], ["idle1"]],
                scale: 0.1665,
            },
            {
                id: "Goaty",
                offset: [56, -57],
                anims: [[], ["idle1"], ["idle1"]],
                scale: 0.1665,
            },
        ],
    ], goatCheese_goatStable6: [
        [
            {
                id: "Goat_big",
                offset: [-33, -55],
                anims: [[], ["idle1", "eat"], ["idle1"]],
                scale: 0.1665,
            },
            {
                id: "Goaty",
                offset: [-38, -50],
                anims: [[], ["idle1"], ["idle1"]],
                scale: 0.1665,
            },
            {
                id: "Goat_big",
                offset: [1, -158],
                anims: [[], ["idle1", "eat"], ["idle1"]],
                scale: -0.1665,
            },
            {
                id: "Goaty",
                offset: [17, -203],
                anims: [[], ["idle1"], ["idle1"]],
                scale: -0.1665,
            },
            {
                id: "Goat_big",
                offset: [49, -70],
                anims: [[], ["idle1", "eat"], ["idle1"]],
                scale: 0.1665,
            },
            {
                id: "Goaty",
                offset: [51, -65],
                anims: [[], ["idle1"], ["idle1"]],
                scale: 0.1665,
            },
        ],
    ], goatCheese_goatStable7: [
        [
            {
                id: "Goat_big",
                offset: [-33, -55],
                anims: [[], ["idle1", "eat"], ["idle1"]],
                scale: 0.1665,
            },
            {
                id: "Goaty",
                offset: [-38, -50],
                anims: [[], ["idle1"], ["idle1"]],
                scale: 0.1665,
            },
            {
                id: "Goaty",
                offset: [-38, -236],
                anims: [[], ["idle1"], ["idle1"]],
                scale: 0.1665,
            },
            {
                id: "Goat_big",
                offset: [-5, -219],
                anims: [[], ["eat", "idle1"], ["idle1"]],
                scale: 0.1665,
            },
            {
                id: "Goat_big",
                offset: [49, -70],
                anims: [[], ["eat", "idle1"], ["idle1"]],
                scale: 0.1665,
            },
            {
                id: "Goaty",
                offset: [51, -65],
                anims: [[], ["idle1"], ["idle1"]],
                scale: 0.1665,
            },
            {
                id: "Goaty",
                offset: [69, -157],
                anims: [[], ["idle1"], ["idle1"]],
                scale: -0.1665,
            },
        ],
    ], goldflowers_acre1: [
        [
            {
                id: IdAssetBundleBuildings.acre_seeds_goldflowers_1,
                offset: [-52, -103],
            },
        ],
        [
            {
                id: IdAssetBundleBuildings.acre_seeds_goldflowers_2,
                offset: [-50, -113],
            },
        ],
        [
            {
                id: IdAssetBundleBuildings.acre_seeds_goldflowers_3,
                offset: [-53, -118],
            },
        ],
    ], goldflowers_acre2: [
        [
            {
                id: IdAssetBundleBuildings.acre_seeds_goldflowers_1,
                offset: [-52, -103],
            },
        ],
        [
            {
                id: IdAssetBundleBuildings.acre_seeds_goldflowers_2,
                offset: [-50, -113],
            },
        ],
        [
            {
                id: IdAssetBundleBuildings.acre_seeds_goldflowers_3,
                offset: [-53, -118],
            },
        ],
    ], goldflowers_acre3: [
        [
            {
                id: IdAssetBundleBuildings.acre_seeds_goldflowers_1,
                offset: [-49, -105],
            },
        ],
        [
            {
                id: IdAssetBundleBuildings.acre_seeds_goldflowers_2,
                offset: [-56, -114],
            },
        ],
        [
            {
                id: IdAssetBundleBuildings.acre_seeds_goldflowers_3,
                offset: [-52, -120],
            },
        ],
    ], goldflowers_acre4: [
        [
            {
                id: IdAssetBundleBuildings.acre_seeds_goldflowers_1,
                offset: [-55, -106],
            },
        ],
        [
            {
                id: IdAssetBundleBuildings.acre_seeds_goldflowers_2,
                offset: [-59, -117],
            },
        ],
        [
            {
                id: IdAssetBundleBuildings.acre_seeds_goldflowers_3,
                offset: [-55, -122],
            },
        ],
    ], goldflowers_acre5: [
        [
            {
                id: IdAssetBundleBuildings.acre_seeds_goldflowers_1,
                offset: [-56, -105],
            },
        ],
        [
            {
                id: IdAssetBundleBuildings.acre_seeds_goldflowers_2,
                offset: [-57, -114],
            },
        ],
        [
            {
                id: IdAssetBundleBuildings.acre_seeds_goldflowers_3,
                offset: [-57, -120],
            },
        ],
    ], goldflowers_acre6: [
        [
            {
                id: IdAssetBundleBuildings.acre_seeds_goldflowers_1,
                offset: [-53, -100],
            },
        ],
        [
            {
                id: IdAssetBundleBuildings.acre_seeds_goldflowers_2,
                offset: [-51, -110],
            },
        ],
        [
            {
                id: IdAssetBundleBuildings.acre_seeds_goldflowers_3,
                offset: [-54, -115],
            },
        ],
    ], goldflowers_acre7: [
        [
            {
                id: IdAssetBundleBuildings.acre_seeds_goldflowers_1,
                offset: [-53, -100],
            },
        ],
        [
            {
                id: IdAssetBundleBuildings.acre_seeds_goldflowers_2,
                offset: [-51, -110],
            },
        ],
        [
            {
                id: IdAssetBundleBuildings.acre_seeds_goldflowers_3,
                offset: [-54, -115],
            },
        ],
    ], goldflowers_acre8: [
        [
            {
                id: IdAssetBundleBuildings.acre_seeds_goldflowers_1,
                offset: [-53, -100],
            },
        ],
        [
            {
                id: IdAssetBundleBuildings.acre_seeds_goldflowers_2,
                offset: [-51, -110],
            },
        ],
        [
            {
                id: IdAssetBundleBuildings.acre_seeds_goldflowers_3,
                offset: [-54, -115],
            },
        ],
    ], honey_beehive1: [
        [
            {
                id: IdAssetBundleBuildings.beehive_active_1,
                offset: [-80, -84],
            },
        ],
    ], honey_beehive2: [
        [
            {
                id: IdAssetBundleBuildings.beehive_active_2,
                offset: [-88, -82],
            },
        ],
    ], honey_beehive3: [
        [
            {
                id: IdAssetBundleBuildings.beehive_active_3,
                offset: [-87, -83],
            },
        ],
    ], honey_beehive4: [
        [
            {
                id: IdAssetBundleBuildings.beehive_active_4,
                offset: [-105, -111],
            },
        ],
    ], humus_composter1: [
        [
            {
                id: IdAssetBundleBuildings.composter_foliage_1,
                offset: [-55, -91],
            },
        ],
    ], humus_composter2: [
        [
            {
                id: IdAssetBundleBuildings.composter_foliage_2,
                offset: [-43, -79],
            },
        ],
    ], humus_composter3: [
        [
            {
                id: IdAssetBundleBuildings.composter_foliage_3,
                offset: [-55, -76],
            },
        ],
    ], humus_composter4: [
        [
            {
                id: IdAssetBundleBuildings.composter_foliage_4,
                offset: [-57, -75],
            },
        ],
    ], jasmine_meadow1: [
        [
            {
                id: IdAssetBundleBuildings.meadow_seeds_jasmine_1,
                offset: [-47, -117],
            },
        ],
        [
            {
                id: IdAssetBundleBuildings.meadow_seeds_jasmine_2,
                offset: [-45, -125],
            },
        ],
        [
            {
                id: IdAssetBundleBuildings.meadow_seeds_jasmine_3,
                offset: [-39, -121],
            },
        ],
    ], jasmine_meadow2: [
        [
            {
                id: IdAssetBundleBuildings.meadow_seeds_jasmine_1,
                offset: [-47, -117],
            },
        ],
        [
            {
                id: IdAssetBundleBuildings.meadow_seeds_jasmine_2,
                offset: [-45, -125],
            },
        ],
        [
            {
                id: IdAssetBundleBuildings.meadow_seeds_jasmine_3,
                offset: [-39, -121],
            },
        ],
    ], jasmine_meadow3: [
        [
            {
                id: IdAssetBundleBuildings.meadow_seeds_jasmine_1,
                offset: [-47, -117],
            },
        ],
        [
            {
                id: IdAssetBundleBuildings.meadow_seeds_jasmine_2,
                offset: [-45, -125],
            },
        ],
        [
            {
                id: IdAssetBundleBuildings.meadow_seeds_jasmine_3,
                offset: [-39, -121],
            },
        ],
    ], jasmine_meadow4: [
        [
            {
                id: IdAssetBundleBuildings.meadow_seeds_jasmine_1,
                offset: [-47, -117],
            },
        ],
        [
            {
                id: IdAssetBundleBuildings.meadow_seeds_jasmine_2,
                offset: [-45, -125],
            },
        ],
        [
            {
                id: IdAssetBundleBuildings.meadow_seeds_jasmine_3,
                offset: [-39, -121],
            },
        ],
    ], jasmine_meadow5: [
        [
            {
                id: IdAssetBundleBuildings.meadow_seeds_jasmine_1,
                offset: [-47, -117],
            },
        ],
        [
            {
                id: IdAssetBundleBuildings.meadow_seeds_jasmine_2,
                offset: [-45, -125],
            },
        ],
        [
            {
                id: IdAssetBundleBuildings.meadow_seeds_jasmine_3,
                offset: [-39, -121],
            },
        ],
    ], jasmine_meadow6: [
        [
            {
                id: IdAssetBundleBuildings.meadow_seeds_jasmine_1,
                offset: [-47, -117],
            },
        ],
        [
            {
                id: IdAssetBundleBuildings.meadow_seeds_jasmine_2,
                offset: [-45, -125],
            },
        ],
        [
            {
                id: IdAssetBundleBuildings.meadow_seeds_jasmine_3,
                offset: [-39, -121],
            },
        ],
    ], jasmine_meadow7: [
        [
            {
                id: IdAssetBundleBuildings.meadow_seeds_jasmine_1,
                offset: [-47, -117],
            },
        ],
        [
            {
                id: IdAssetBundleBuildings.meadow_seeds_jasmine_2,
                offset: [-45, -125],
            },
        ],
        [
            {
                id: IdAssetBundleBuildings.meadow_seeds_jasmine_3,
                offset: [-39, -121],
            },
        ],
    ], lambsLettuce_acre1: [
        [
            {
                id: IdAssetBundleBuildings.acre_seeds_lambsLettuce_1,
                offset: [-52, -101],
            },
        ],
        [
            {
                id: IdAssetBundleBuildings.acre_seeds_lambsLettuce_2,
                offset: [-51, -105],
            },
        ],
        [
            {
                id: IdAssetBundleBuildings.acre_seeds_lambsLettuce_3,
                offset: [-48, -108],
            },
        ],
    ], lambsLettuce_acre2: [
        [
            {
                id: IdAssetBundleBuildings.acre_seeds_lambsLettuce_1,
                offset: [-53, -97],
            },
        ],
        [
            {
                id: IdAssetBundleBuildings.acre_seeds_lambsLettuce_2,
                offset: [-53, -102],
            },
        ],
        [
            {
                id: IdAssetBundleBuildings.acre_seeds_lambsLettuce_3,
                offset: [-50, -102],
            },
        ],
    ], lambsLettuce_acre3: [
        [
            {
                id: IdAssetBundleBuildings.acre_seeds_lambsLettuce_1,
                offset: [-52, -101],
            },
        ],
        [
            {
                id: IdAssetBundleBuildings.acre_seeds_lambsLettuce_2,
                offset: [-52, -101],
            },
        ],
        [
            {
                id: IdAssetBundleBuildings.acre_seeds_lambsLettuce_3,
                offset: [-50, -105],
            },
        ],
    ], lambsLettuce_acre4: [
        [
            {
                id: IdAssetBundleBuildings.acre_seeds_lambsLettuce_1,
                offset: [-49, -103],
            },
        ],
        [
            {
                id: IdAssetBundleBuildings.acre_seeds_lambsLettuce_2,
                offset: [-54, -107],
            },
        ],
        [
            {
                id: IdAssetBundleBuildings.acre_seeds_lambsLettuce_3,
                offset: [-49, -105],
            },
        ],
    ], lambsLettuce_acre5: [
        [
            {
                id: IdAssetBundleBuildings.acre_seeds_lambsLettuce_1,
                offset: [-50, -104],
            },
        ],
        [
            {
                id: IdAssetBundleBuildings.acre_seeds_lambsLettuce_2,
                offset: [-49, -106],
            },
        ],
        [
            {
                id: IdAssetBundleBuildings.acre_seeds_lambsLettuce_3,
                offset: [-51, -108],
            },
        ],
    ], lambsLettuce_acre6: [
        [
            {
                id: IdAssetBundleBuildings.acre_seeds_lambsLettuce_1,
                offset: [-50, -105],
            },
        ],
        [
            {
                id: IdAssetBundleBuildings.acre_seeds_lambsLettuce_2,
                offset: [-53, -106],
            },
        ],
        [
            {
                id: IdAssetBundleBuildings.acre_seeds_lambsLettuce_3,
                offset: [-52, -110],
            },
        ],
    ], lambsLettuce_acre7: [
        [
            {
                id: IdAssetBundleBuildings.acre_seeds_lambsLettuce_1,
                offset: [-53, -97],
            },
        ],
        [
            {
                id: IdAssetBundleBuildings.acre_seeds_lambsLettuce_2,
                offset: [-53, -97],
            },
        ],
        [
            {
                id: IdAssetBundleBuildings.acre_seeds_lambsLettuce_3,
                offset: [-54, -100],
            },
        ],
    ], lambsLettuce_acre8: [
        [
            {
                id: IdAssetBundleBuildings.acre_seeds_lambsLettuce_1,
                offset: [-53, -97],
            },
        ],
        [
            {
                id: IdAssetBundleBuildings.acre_seeds_lambsLettuce_2,
                offset: [-53, -97],
            },
        ],
        [
            {
                id: IdAssetBundleBuildings.acre_seeds_lambsLettuce_3,
                offset: [-54, -100],
            },
        ],
    ], lavender_meadow1: [
        [
            {
                id: IdAssetBundleBuildings.meadow_seeds_lavender_1,
                offset: [-47, -117],
            },
        ],
        [
            {
                id: IdAssetBundleBuildings.meadow_seeds_lavender_2,
                offset: [-46, -119],
            },
        ],
        [
            {
                id: IdAssetBundleBuildings.meadow_seeds_lavender_3,
                offset: [-53, -124],
            },
        ],
    ], lavender_meadow2: [
        [
            {
                id: IdAssetBundleBuildings.meadow_seeds_lavender_1,
                offset: [-46, -112],
            },
        ],
        [
            {
                id: IdAssetBundleBuildings.meadow_seeds_lavender_2,
                offset: [-44, -114],
            },
        ],
        [
            {
                id: IdAssetBundleBuildings.meadow_seeds_lavender_3,
                offset: [-53, -122],
            },
        ],
    ], lavender_meadow3: [
        [
            {
                id: IdAssetBundleBuildings.meadow_seeds_lavender_1,
                offset: [-44, -112],
            },
        ],
        [
            {
                id: IdAssetBundleBuildings.meadow_seeds_lavender_2,
                offset: [-44, -114],
            },
        ],
        [
            {
                id: IdAssetBundleBuildings.meadow_seeds_lavender_3,
                offset: [-52, -119],
            },
        ],
    ], lavender_meadow4: [
        [
            {
                id: IdAssetBundleBuildings.meadow_seeds_lavender_1,
                offset: [-43, -103],
            },
        ],
        [
            {
                id: IdAssetBundleBuildings.meadow_seeds_lavender_2,
                offset: [-44, -111],
            },
        ],
        [
            {
                id: IdAssetBundleBuildings.meadow_seeds_lavender_3,
                offset: [-44, -106],
            },
        ],
    ], lavender_meadow5: [
        [
            {
                id: IdAssetBundleBuildings.meadow_seeds_lavender_1,
                offset: [-41, -110],
            },
        ],
        [
            {
                id: IdAssetBundleBuildings.meadow_seeds_lavender_2,
                offset: [-39, -115],
            },
        ],
        [
            {
                id: IdAssetBundleBuildings.meadow_seeds_lavender_3,
                offset: [-42, -116],
            },
        ],
    ], lavender_meadow6: [
        [
            {
                id: IdAssetBundleBuildings.meadow_seeds_lavender_1,
                offset: [-47, -100],
            },
        ],
        [
            {
                id: IdAssetBundleBuildings.meadow_seeds_lavender_2,
                offset: [-46, -104],
            },
        ],
        [
            {
                id: IdAssetBundleBuildings.meadow_seeds_lavender_3,
                offset: [-40, -103],
            },
        ],
    ], lavender_meadow7: [
        [
            {
                id: IdAssetBundleBuildings.meadow_seeds_lavender_1,
                offset: [-52, -105],
            },
        ],
        [
            {
                id: IdAssetBundleBuildings.meadow_seeds_lavender_2,
                offset: [-56, -104],
            },
        ],
        [
            {
                id: IdAssetBundleBuildings.meadow_seeds_lavender_3,
                offset: [-52, -112],
            },
        ],
    ], milk_candyCowBarn1: [
        [
            {
                id: "cow",
                offset: [-42, -91],
                anims: [
                    [],
                    ["idle", "eating", "idle2", "idle_chew"],
                    ["idle", "idle2", "small_cow_cuddle"],
                ],
                scale: 0.1165,
            },
        ],
    ], milk_candyCowBarn2: [
        [
            {
                id: "cow",
                offset: [-93, -91],
                anims: [
                    [],
                    ["idle", "idle_chew", "eating", "eating"],
                    ["idle", "small_cow_cuddle", "idle"],
                ],
                scale: 0.1165,
            },
            {
                id: "cow",
                offset: [18, -74],
                anims: [
                    [],
                    ["idle", "eating", "idle_chew", "idle2"],
                    ["idle", "idle2", "small_cow_cuddle"],
                ],
                scale: -0.1165,
            },
        ],
    ], milk_candyCowBarn3: [
        [
            {
                id: "cow",
                offset: [-96, -79],
                anims: [
                    [],
                    ["idle", "eating", "idle_chew", "idle2"],
                    ["idle", "idle2", "small_cow_cuddle"],
                ],
                scale: 0.1165,
            },
            {
                id: "cow",
                offset: [-41, -113],
                anims: [
                    [],
                    ["eating", "idle", "idle2", "idle_chew"],
                    ["idle", "small_cow_cuddle", "idle2"],
                ],
                scale: 0.0816,
            },
            {
                id: "cow",
                offset: [10, -69],
                anims: [[], ["eating", "idle", "idle_chew"], ["small_cow_cuddle", "idle"]],
                scale: -0.1165,
            },
        ],
    ], milk_candyCowBarn4: [
        [
            {
                id: "cow",
                offset: [-69, -73],
                anims: [
                    [],
                    ["idle_chew", "eating", "idle", "idle2"],
                    ["idle", "idle2", "small_cow_cuddle", "idle"],
                ],
                scale: 0.1165,
            },
            {
                id: "cow",
                offset: [-11, -117],
                anims: [
                    [],
                    ["eating", "idle_chew", "idle", "idle2"],
                    ["idle", "idle2", "small_cow_cuddle"],
                ],
                scale: -0.0816,
            },
            {
                id: "cow",
                offset: [24, -69],
                anims: [[], ["eating", "idle", "idle_chew"], ["idle2", "small_cow_cuddle"]],
                scale: -0.1165,
            },
        ],
    ], milk_candyCowBarn5: [
        [
            {
                id: "cow",
                offset: [14, -86],
                anims: [
                    [],
                    ["eating", "idle_chew", "idle", "idle2", "idle"],
                    ["small_cow_cuddle", "idle"],
                ],
                scale: -0.1165,
            },
            {
                id: "cow",
                offset: [-76, -102],
                anims: [
                    [],
                    ["eating", "idle2", "idle_chew", "idle2"],
                    ["small_cow_cuddle", "idle", "small_cow_cuddle"],
                ],
                scale: -0.0816,
            },
            {
                id: "cow",
                offset: [-12, -49],
                anims: [[], ["idle", "eating", "idle2"], ["idle", "idle2", "small_cow_cuddle"]],
                scale: 0.0816,
            },
        ],
    ], milk_candyCowBarn6: [
        [
            {
                id: "cow",
                offset: [-96, -97],
                anims: [[], ["eating", "idle", "idle2"], ["idle", "idle_chew", "small_cow_cuddle"]],
                scale: -0.0816,
            },
            {
                id: "cow",
                offset: [-26, -63],
                anims: [
                    [],
                    ["eating", "idle", "idle2", "idle_chew"],
                    ["idle", "small_cow_cuddle", "idle"],
                ],
                scale: 0.1165,
            },
            {
                id: "cow",
                offset: [47, -83],
                anims: [[], ["eating", "idle_chew", "idle"], ["small_cow_cuddle", "idle", "idle2"]],
                scale: 0.1165,
            },
        ],
    ], milk_candyCowBarn7: [
        [
            {
                id: "cow",
                offset: [9, -77],
                anims: [[], ["idle_chew", "eating"], ["small_cow_cuddle", "idle", "idle2"]],
                scale: 0.1165,
            },
            {
                id: "cow",
                offset: [-84, -79],
                anims: [
                    [],
                    ["idle_chew", "eating", "idle2"],
                    ["idle", "idle2", "small_cow_cuddle"],
                ],
                scale: 0.0816,
            },
        ],
    ], milk_cowBarn1: [
        [
            {
                id: "cow",
                offset: [-42, -91],
                anims: [
                    [],
                    ["idle", "eating", "idle2", "idle_chew"],
                    ["idle", "idle2", "small_cow_cuddle"],
                ],
                scale: 0.1165,
            },
        ],
    ], milk_cowBarn2: [
        [
            {
                id: "cow",
                offset: [-103, -83],
                anims: [
                    [],
                    ["idle", "idle_chew", "eating", "eating"],
                    ["idle", "small_cow_cuddle", "idle"],
                ],
                scale: 0.1165,
            },
            {
                id: "cow",
                offset: [18, -66],
                anims: [
                    [],
                    ["idle", "eating", "idle_chew", "idle2"],
                    ["idle", "idle2", "small_cow_cuddle"],
                ],
                scale: -0.1165,
            },
        ],
    ], milk_cowBarn3: [
        [
            {
                id: "cow",
                offset: [-96, -73],
                anims: [
                    [],
                    ["idle", "eating", "idle_chew", "idle2"],
                    ["idle", "idle2", "small_cow_cuddle"],
                ],
                scale: 0.1165,
            },
            {
                id: "cow",
                offset: [-14, -83],
                anims: [
                    [],
                    ["eating", "idle", "idle2", "idle_chew"],
                    ["idle", "small_cow_cuddle", "idle2"],
                ],
                scale: 0.0816,
            },
            {
                id: "cow",
                offset: [54, -49],
                anims: [[], ["eating", "idle", "idle_chew"], ["small_cow_cuddle", "idle"]],
                scale: -0.1165,
            },
        ],
    ], milk_cowBarn4: [
        [
            {
                id: "cow",
                offset: [-159, -108],
                anims: [
                    [],
                    ["idle_chew", "eating", "idle", "idle2"],
                    ["idle", "idle2", "small_cow_cuddle", "idle"],
                ],
                scale: 0.1165,
            },
            {
                id: "cow",
                offset: [-28, -40],
                anims: [
                    [],
                    ["eating", "idle", "idle2", "idle_chew"],
                    ["small_cow_cuddle", "idle", "idle2"],
                ],
                scale: 0.1165,
            },
            {
                id: "cow",
                offset: [-93, -78],
                anims: [
                    [],
                    ["eating", "idle_chew", "idle", "idle2"],
                    ["idle", "idle2", "small_cow_cuddle"],
                ],
                scale: -0.0816,
            },
            {
                id: "cow",
                offset: [75, -64],
                anims: [[], ["eating", "idle", "idle_chew"], ["idle2", "small_cow_cuddle"]],
                scale: -0.1165,
            },
        ],
    ], milk_cowBarn5: [
        [
            {
                id: "cow",
                offset: [-153, -117],
                anims: [
                    [],
                    ["eating", "idle", "idle2", "idle_chew"],
                    ["idle", "idle", "small_cow_cuddle"],
                ],
                scale: 0.1165,
            },
            {
                id: "cow",
                offset: [-98, -84],
                anims: [
                    [],
                    ["eating", "idle_chew", "idle", "idle2", "idle"],
                    ["small_cow_cuddle", "idle"],
                ],
                scale: -0.1165,
            },
            {
                id: "cow",
                offset: [-11, -34],
                anims: [
                    [],
                    ["eating", "idle2", "idle_chew", "idle2"],
                    ["small_cow_cuddle", "idle", "small_cow_cuddle"],
                ],
                scale: -0.0816,
            },
            {
                id: "cow",
                offset: [-48, -61],
                anims: [[], ["idle", "eating", "idle2"], ["idle", "idle2", "small_cow_cuddle"]],
                scale: 0.0816,
            },
        ],
    ], milk_cowBarn6: [
        [
            {
                id: "cow",
                offset: [-140, -120],
                anims: [[], ["eating", "idle", "idle2"], ["idle", "idle_chew", "small_cow_cuddle"]],
                scale: -0.0816,
            },
            {
                id: "cow",
                offset: [-99, -97],
                anims: [
                    [],
                    ["eating", "idle", "idle2", "idle_chew"],
                    ["idle", "small_cow_cuddle", "idle"],
                ],
                scale: 0.1165,
            },
            {
                id: "cow",
                offset: [-18, -40],
                anims: [[], ["eating", "idle_chew", "idle"], ["small_cow_cuddle", "idle", "idle2"]],
                scale: 0.1165,
            },
        ],
    ], milk_cowBarn7: [
        [
            {
                id: "cow",
                offset: [-167, -137],
                anims: [
                    [],
                    ["idle", "idle2", "eating", "idle_chew"],
                    ["idle", "small_cow_cuddle", "idle2"],
                ],
                scale: -0.1165,
            },
            {
                id: "cow",
                offset: [-25, -56],
                anims: [[], ["idle_chew", "eating"], ["small_cow_cuddle", "idle", "idle2"]],
                scale: 0.1165,
            },
            {
                id: "cow",
                offset: [-63, -83],
                anims: [[], ["eating", "idle", "idle2"], ["idle2", "small_cow_cuddle"]],
                scale: -0.1165,
            },
            {
                id: "cow",
                offset: [-143, -113],
                anims: [
                    [],
                    ["idle_chew", "eating", "idle2"],
                    ["idle", "idle2", "small_cow_cuddle"],
                ],
                scale: 0.0816,
            },
        ],
    ], milk_freeRangeCowBarn1: [
        [
            {
                id: "cow",
                offset: [-42, -91],
                anims: [
                    [],
                    ["eating", "idle", "idle2", "idle_chew"],
                    ["idle", "idle2", "small_cow_cuddle"],
                ],
                scale: -0.1165,
            },
        ],
    ], milk_freeRangeCowBarn2: [
        [
            {
                id: "cow",
                offset: [-156, -121],
                anims: [
                    [],
                    ["eating", "idle", "idle2", "idle_chew"],
                    ["idle", "idle_chew", "idle2"],
                ],
                scale: -0.1165,
            },
            {
                id: "cow",
                offset: [13, -35],
                anims: [[], ["eating", "idle", "idle2", "idle_chew"], ["idle", "small_cow_cuddle"]],
                scale: 0.1165,
            },
        ],
    ], milk_freeRangeCowBarn3: [
        [
            {
                id: "cow",
                offset: [-66, -130],
                anims: [
                    [],
                    ["eating", "idle", "idle2", "idle_chew"],
                    ["idle", "idle2", "small_cow_cuddle"],
                ],
                scale: 0.1165,
            },
            {
                id: "cow",
                offset: [4, -83],
                anims: [
                    [],
                    ["eating", "idle_chew", "idle2"],
                    ["small_cow_cuddle", "idle2", "idle"],
                ],
                scale: -0.1165,
            },
            {
                id: "cow",
                offset: [-126, -103],
                anims: [
                    [],
                    ["eating", "idle", "idle2", "idle_chew"],
                    ["idle", "small_cow_cuddle", "idle2"],
                ],
                scale: -0.0816,
            },
        ],
    ], milk_freeRangeCowBarn4: [
        [
            {
                id: "cow",
                offset: [-62, -113],
                anims: [
                    [],
                    ["idle", "idle2", "idle_chew", "eating"],
                    ["idle2", "small_cow_cuddle", "idle"],
                ],
                scale: 0.1165,
            },
            {
                id: "cow",
                offset: [-190, -105],
                anims: [[], ["idle", "idle_chew", "eating", "idle2"], ["idle", "small_cow_cuddle"]],
                scale: -0.1165,
            },
            {
                id: "cow",
                offset: [12, -21],
                anims: [[], ["idle", "idle2", "idle_chew"], ["idle2", "idle", "small_cow_cuddle"]],
                scale: -0.0816,
            },
            {
                id: "cow",
                offset: [36, -106],
                anims: [
                    [],
                    ["eating", "idle2", "idle_chew", "small_cow_cuddle"],
                    ["idle", "idle2"],
                ],
                scale: 0.0816,
            },
        ],
    ], milk_freeRangeCowBarn5: [
        [
            {
                id: "cow",
                offset: [-8, -93],
                anims: [
                    [],
                    ["eating", "idle", "idle2", "idle_chew"],
                    ["idle2", "small_cow_cuddle", "idle"],
                ],
                scale: -0.1165,
            },
            {
                id: "cow",
                offset: [-203, -112],
                anims: [[], ["eating", "idle", "idle2"], ["small_cow_cuddle", "idle2", "idle"]],
                scale: 0.1165,
            },
            {
                id: "cow",
                offset: [24, -33],
                anims: [
                    [],
                    ["eating", "idle", "idle2", "idle_chew"],
                    ["eating", "idle2", "small_cow_cuddle"],
                ],
                scale: -0.1165,
            },
            {
                id: "cow",
                offset: [-79, -44],
                anims: [[], ["idle", "idle2", "eating", "idle"], ["small_cow_cuddle", "idle"]],
                scale: 0.0816,
            },
        ],
    ], milk_freeRangeCowBarn6: [
        [
            {
                id: "cow",
                offset: [-132, -76],
                anims: [
                    [],
                    ["eating", "idle", "idle2", "idle_chew"],
                    ["idle", "idle2", "small_cow_cuddle"],
                ],
                scale: 0.1165,
            },
            {
                id: "cow",
                offset: [5, -86],
                anims: [
                    [],
                    ["idle", "idle2", "idle_chew", "small_cow_cuddle", "eating"],
                    ["idle", "idle", "idle2", "small_cow_cuddle"],
                ],
                scale: 0.1165,
            },
            {
                id: "cow",
                offset: [-35, -37],
                anims: [[], ["idle", "idle2", "eating"], ["small_cow_cuddle", "idle"]],
                scale: -0.1165,
            },
            {
                id: "cow",
                offset: [-196, -110],
                anims: [
                    [],
                    ["eating", "idle", "idle2", "idle_chew"],
                    ["small_cow_cuddle", "idle", "idle2"],
                ],
                scale: -0.1165,
            },
        ],
    ], milk_freeRangeCowBarn7: [
        [
            {
                id: "cow",
                offset: [-35, -38],
                anims: [
                    [],
                    ["eating", "idle", "idle2", "idle_chew"],
                    ["small_cow_cuddle", "idle", "idle2"],
                ],
                scale: 0.1165,
            },
            {
                id: "cow",
                offset: [-161, -121],
                anims: [
                    [],
                    ["eating", "idle", "idle2", "idle_chew"],
                    ["idle", "idle2", "small_cow_cuddle"],
                ],
                scale: -0.1165,
            },
            {
                id: "cow",
                offset: [-94, -88],
                anims: [
                    [],
                    ["idle", "idle2", "small_cow_cuddle"],
                    ["idle", "idle2", "small_cow_cuddle"],
                ],
                scale: 0.1165,
            },
            {
                id: "cow",
                offset: [100, -92],
                anims: [
                    [],
                    ["eating", "idle", "idle2", "idle_chew"],
                    ["idle", "idle2", "small_cow_cuddle"],
                ],
                scale: -0.1165,
            },
            {
                id: "cow",
                offset: [-171, -81],
                anims: [
                    [],
                    ["eating", "idle", "idle2", "idle_chew"],
                    ["small_cow_cuddle", "idle", "idle2"],
                ],
                scale: 0.1165,
            },
        ],
    ], olives_meadow1: [
        [
            {
                id: IdAssetBundleBuildings.meadow_seeds_olives_1,
                offset: [-49, -133],
            },
        ],
        [
            {
                id: IdAssetBundleBuildings.meadow_seeds_olives_2,
                offset: [-45, -139],
            },
        ],
        [
            {
                id: IdAssetBundleBuildings.meadow_seeds_olives_3,
                offset: [-44, -148],
            },
        ],
    ], olives_meadow2: [
        [
            {
                id: IdAssetBundleBuildings.meadow_seeds_olives_1,
                offset: [-41, -129],
            },
        ],
        [
            {
                id: IdAssetBundleBuildings.meadow_seeds_olives_2,
                offset: [-40, -133],
            },
        ],
        [
            {
                id: IdAssetBundleBuildings.meadow_seeds_olives_3,
                offset: [-37, -137],
            },
        ],
    ], olives_meadow3: [
        [
            {
                id: IdAssetBundleBuildings.meadow_seeds_olives_1,
                offset: [-50, -128],
            },
        ],
        [
            {
                id: IdAssetBundleBuildings.meadow_seeds_olives_2,
                offset: [-48, -136],
            },
        ],
        [
            {
                id: IdAssetBundleBuildings.meadow_seeds_olives_3,
                offset: [-49, -144],
            },
        ],
    ], olives_meadow4: [
        [
            {
                id: IdAssetBundleBuildings.meadow_seeds_olives_1,
                offset: [-51, -128],
            },
        ],
        [
            {
                id: IdAssetBundleBuildings.meadow_seeds_olives_2,
                offset: [-50, -138],
            },
        ],
        [
            {
                id: IdAssetBundleBuildings.meadow_seeds_olives_3,
                offset: [-49, -142],
            },
        ],
    ], olives_meadow5: [
        [
            {
                id: IdAssetBundleBuildings.meadow_seeds_olives_1,
                offset: [-45, -133],
            },
        ],
        [
            {
                id: IdAssetBundleBuildings.meadow_seeds_olives_2,
                offset: [-42, -141],
            },
        ],
        [
            {
                id: IdAssetBundleBuildings.meadow_seeds_olives_3,
                offset: [-43, -148],
            },
        ],
    ], olives_meadow6: [
        [
            {
                id: IdAssetBundleBuildings.meadow_seeds_olives_1,
                offset: [-50, -126],
            },
        ],
        [
            {
                id: IdAssetBundleBuildings.meadow_seeds_olives_2,
                offset: [-45, -133],
            },
        ],
        [
            {
                id: IdAssetBundleBuildings.meadow_seeds_olives_3,
                offset: [-45, -140],
            },
        ],
    ], olives_meadow7: [
        [
            {
                id: IdAssetBundleBuildings.meadow_seeds_olives_1,
                offset: [-56, -127],
            },
        ],
        [
            {
                id: IdAssetBundleBuildings.meadow_seeds_olives_2,
                offset: [-53, -136],
            },
        ],
        [
            {
                id: IdAssetBundleBuildings.meadow_seeds_olives_3,
                offset: [-53, -145],
            },
        ],
    ], pigs_freeRangePigPen1: [
        [
            {
                id: "pig",
                offset: [-10, -22],
                anims: [[], ["pig_full_2", "pig_full_1", "eat", "idle"], ["idle", "jump", "idle"]],
                scale: 0.0999,
            },
            {
                id: "pig",
                offset: [-68, -134],
                anims: [[], ["pig_full_3", "idle", "pig_full_1", "idle"], ["idle", "jump", "idle"]],
                scale: -0.0999,
            },
        ],
    ], pigs_freeRangePigPen2: [
        [
            {
                id: "pig",
                offset: [55, -73],
                anims: [[], ["idle", "pig_full_1", "pig_full_2", "pig_full_3"], ["idle", "jump"]],
                scale: 0.0999,
            },
            {
                id: "pig",
                offset: [-129, -110],
                anims: [
                    [],
                    ["pig_full_1", "pig_full_2", "pig_full_3", "idle"],
                    ["idle", "jump", "idle"],
                ],
                scale: 0.0999,
            },
        ],
    ], pigs_freeRangePigPen3: [
        [
            {
                id: "pig",
                offset: [-152, -74],
                anims: [
                    [],
                    ["idle", "pig_full_1", "pig_full_2", "pig_full_3"],
                    ["idle", "jump", "idle"],
                ],
                scale: -0.0999,
            },
            {
                id: "pig",
                offset: [-63, -121],
                anims: [[], ["idle", "pig_full_1", "idle", "eat"], ["idle", "jump", "idle"]],
                scale: 0.0999,
            },
            {
                id: "pig",
                offset: [14, -60],
                anims: [[], ["pig_full_2", "pig_full_3", "idle", "eat"], ["jump", "idle", "jump"]],
                scale: 0.0999,
            },
        ],
    ], pigs_freeRangePigPen4: [
        [
            {
                id: "pig",
                offset: [-185, -72],
                anims: [[], ["idle", "pig_full_2", "eat", "idle"], ["jump", "idle"]],
                scale: -0.0999,
            },
            {
                id: "pig",
                offset: [4, -31],
                anims: [[], ["idle", "idle", "pig_full_2", "pig_full_3"], ["idle", "jump", "idle"]],
                scale: 0.0999,
            },
            {
                id: "pig",
                offset: [-75, -100],
                anims: [[], ["idle", "pig_full_2", "idle", "jump"], ["idle", "jump", "idle"]],
                scale: -0.0999,
            },
            {
                id: "pig",
                offset: [-78, -170],
                anims: [[], ["pig_full_2", "eat", "idle", "pig_full_2"], ["idle", "jump"]],
                scale: 0.0999,
            },
        ],
    ], pigs_freeRangePigPen5: [
        [
            {
                id: "pig",
                offset: [39, -78],
                anims: [[], ["pig_full_1", "idle", "eat"], ["idle", "jump"]],
                scale: -0.0999,
            },
            {
                id: "pig",
                offset: [-82, -162],
                anims: [[], ["pig_full_2", "idle", "eat", "idle"], ["idle", "jump", "idle"]],
                scale: 0.0999,
            },
            {
                id: "pig",
                offset: [8, -132],
                anims: [[], ["pig_full_1", "pig_full_2", "idle"], ["jump", "idle"]],
                scale: -0.0999,
            },
            {
                id: "pig",
                offset: [-207, -106],
                anims: [[], ["idle", "jump", "idle", "pig_full_2"], ["idle", "jump", "idle"]],
                scale: 0.0999,
            },
            {
                id: "pig",
                offset: [-82, -108],
                anims: [[], ["pig_full_2", "idle", "jump"], ["idle", "jump"]],
                scale: -0.0999,
            },
        ],
    ], pigs_freeRangePigPen6: [
        [
            {
                id: "pig",
                offset: [-78, -98],
                anims: [[], ["pig_full_1", "idle", "eat", "idle"], ["idle", "jump", "idle"]],
                scale: 0.0999,
            },
            {
                id: "pig",
                offset: [-181, -93],
                anims: [[], ["pig_full_2", "idle", "jump", "idle"], ["jump", "idle", "jump"]],
                scale: -0.0999,
            },
            {
                id: "pig",
                offset: [30, -82],
                anims: [[], ["idle", "idle", "pig_full_3"], ["eat", "idle", "jump"]],
                scale: 0.0999,
            },
            {
                id: "pig",
                offset: [-140, -113],
                anims: [[], ["pig_full_1", "idle", "idle", "idle"], ["idle", "jump"]],
                scale: -0.0999,
            },
            {
                id: "pig",
                offset: [-92, -31],
                anims: [[], ["eat", "idle", "pig_full_3", "pig_full_2"], ["idle", "jump", "idle"]],
                scale: 0.0999,
            },
            {
                id: "pig",
                offset: [-44, -169],
                anims: [[], ["pig_full_2", "jump", "idle", "eat"], ["idle", "jump", "idle"]],
                scale: -0.0999,
            },
        ],
    ], pigs_freeRangePigPen7: [
        [
            {
                id: "pig",
                offset: [-23, -60],
                anims: [[], ["pig_full_1", "idle", "pig_full_2", "jump"], ["jump", "idle", "jump"]],
                scale: 0.0999,
            },
            {
                id: "pig",
                offset: [-83, -167],
                anims: [
                    [],
                    ["pig_full_1", "pig_full_2", "pig_full_3", "idle", "eat"],
                    ["idle", "jump"],
                ],
                scale: 0.0999,
            },
            {
                id: "pig",
                offset: [-135, -73],
                anims: [
                    [],
                    ["eat", "idle", "jump", "pig_full_2", "pig_full_3", "idle"],
                    ["idle", "eat", "jump"],
                ],
                scale: -0.0999,
            },
            {
                id: "pig",
                offset: [84, -108],
                anims: [[], ["idle", "jump", "pig_full_1", "jump"], ["idle", "jump"]],
                scale: 0.0999,
            },
            {
                id: "pig",
                offset: [33, -28],
                anims: [[], ["pig_full_2", "pig_full_3", "idle", "idle"], ["idle", "jump"]],
                scale: -0.0999,
            },
            {
                id: "pig",
                offset: [-80, -99],
                anims: [[], ["idle", "pig_full_2", "idle"], ["idle", "jump"]],
                scale: 0.0999,
            },
            {
                id: "pig",
                offset: [30, -145],
                anims: [
                    [],
                    ["idle", "jump", "pig_full_1", "idle", "eat"],
                    ["idle", "jump", "idle"],
                ],
                scale: -0.0999,
            },
        ],
    ], pigs_pigPen1: [
        [
            {
                id: "pig",
                offset: [-8, -55],
                anims: [[], ["pig_full_1", "idle", "eat", "idle"], ["jump", "idle", "idle"]],
                scale: -0.0999,
            },
            {
                id: "pig",
                offset: [-94, -78],
                anims: [[], ["idle", "eat", "pig_full_1", "pig_full_2"], ["jump", "idle", "idle"]],
                scale: 0.0999,
            },
        ],
    ], pigs_pigPen2: [
        [
            {
                id: "pig",
                offset: [37, -77],
                anims: [
                    [],
                    ["pig_full_2", "pig_full_3", "pig_full_1", "idle", "jump"],
                    ["idle", "jump"],
                ],
                scale: -0.0999,
            },
            {
                id: "pig",
                offset: [-64, -78],
                anims: [[], ["pig_full_1", "idle", "eat", "idle"], ["idle", "jump", "idle"]],
                scale: -0.0999,
            },
        ],
    ], pigs_pigPen3: [
        [
            {
                id: "pig",
                offset: [-24, -77],
                anims: [[], ["pig_full_1", "pig_full_3", "pig_full_2"], ["idle", "jump", "idle"]],
                scale: -0.0999,
            },
            {
                id: "pig",
                offset: [-102, -112],
                anims: [[], ["pig_full_2", "pig_full_3", "idle", "jump"], ["idle", "jump", "idle"]],
                scale: -0.0999,
            },
            {
                id: "pig",
                offset: [-51, -58],
                anims: [[], ["pig_full_2", "idle", "eat", "idle"], ["jump", "idle", "idle"]],
                scale: 0.0999,
            },
        ],
    ], pigs_pigPen4: [
        [
            {
                id: "pig",
                offset: [-104, -113],
                anims: [[], ["pig_full_1", "eat", "pig_full_3", "idle"], ["idle", "jump", "idle"]],
                scale: 0.0999,
            },
            {
                id: "pig",
                offset: [-94, -78],
                anims: [[], ["pig_full_1", "pig_full_2", "idle", "eat"], ["idle", "idle", "jump"]],
                scale: 0.0999,
            },
            {
                id: "pig",
                offset: [-27, -42],
                anims: [[], ["pig_full_1", "idle", "pig_full_3", "pig_full_2"], ["idle"]],
                scale: -0.0999,
            },
        ],
    ], pigs_pigPen5: [
        [
            {
                id: "pig",
                offset: [-8, -65],
                anims: [[], ["pig_full_3", "idle", "jump", "eat"], ["idle", "jump", "idle"]],
                scale: 0.0999,
            },
            {
                id: "pig",
                offset: [-94, -78],
                anims: [
                    [],
                    ["pig_full_3", "pig_full_2", "pig_full_1", "idle"],
                    ["idle", "jump", "idle"],
                ],
                scale: -0.0999,
            },
            {
                id: "pig",
                offset: [-60, -50],
                anims: [[], ["pig_full_1", "idle", "eat", "idle"], ["idle", "jump"]],
                scale: 0.0999,
            },
            {
                id: "pig",
                offset: [-19, -31],
                anims: [[], ["pig_full_2", "idle", "eat"], ["idle", "jump"]],
                scale: -0.0999,
            },
        ],
    ], pigs_pigPen6: [
        [
            {
                id: "pig",
                offset: [-27, -49],
                anims: [
                    [],
                    ["pig_full_1", "pig_full_3", "pig_full_2", "idle"],
                    ["idle", "jump", "idle"],
                ],
                scale: -0.0999,
            },
            {
                id: "pig",
                offset: [-133, -97],
                anims: [[], ["pig_full_1", "idle", "idle"], ["idle", "jump", "idle"]],
                scale: 0.0999,
            },
            {
                id: "pig",
                offset: [-87, -117],
                anims: [[], ["idle", "pig_full_3", "idle", "eat"], ["jump", "idle"]],
                scale: -0.0999,
            },
            {
                id: "pig",
                offset: [-93, -65],
                anims: [[], ["idle", "pig_full_1", "idle"], ["idle", "jump", "eat"]],
                scale: 0.0999,
            },
        ],
    ], pigs_pigPen7: [
        [
            {
                id: "pig",
                offset: [-125, -117],
                anims: [[], ["idle", "pig_full_1"], ["idle", "jump"]],
                scale: 0.0999,
            },
            {
                id: "pig",
                offset: [-139, -101],
                anims: [[], ["pig_full_2", "idle", "eat"], ["idle", "eat", "jump", "idle"]],
                scale: -0.0999,
            },
            {
                id: "pig",
                offset: [-27, -42],
                anims: [[], ["pig_full_2", "idle", "pig_full_3"], ["jump", "idle", "jump"]],
                scale: -0.0999,
            },
            {
                id: "pig",
                offset: [-80, -77],
                anims: [[], ["pig_full_1", "pig_full_2", "pig_full_3", "idle"], ["idle", "jump"]],
                scale: 0.0999,
            },
        ],
    ], vanillaExtract_manufactory1: [
        [
            {
                id: IdAssetBundleBuildings.manufactory_active1,
                offset: [24, -72],
            },
        ],
    ], vanillaExtract_manufactory2: [
        [
            {
                id: IdAssetBundleBuildings.manufactory_active2,
                offset: [-24, -102],
            },
        ],
    ], vanillaExtract_manufactory3: [
        [
            {
                id: IdAssetBundleBuildings.manufactory_active3,
                offset: [9, -88],
            },
        ],
    ], vanillaExtract_manufactory4: [
        [
            {
                id: IdAssetBundleBuildings.manufactory_active4,
                offset: [7, -73],
            },
        ],
    ], vanillaExtract_manufactory5: [
        [
            {
                id: IdAssetBundleBuildings.manufactory_active5,
                offset: [26, -69],
            },
        ],
    ], vanillaExtract_manufactory6: [
        [
            {
                id: IdAssetBundleBuildings.manufactory_active6,
                offset: [24, -66],
            },
        ],
    ], vanillaExtract_manufactory7: [
        [
            {
                id: IdAssetBundleBuildings.manufactory_active7,
                offset: [29, -64],
            },
        ],
    ], vanillaExtract_manufactory8: [
        [
            {
                id: IdAssetBundleBuildings.manufactory_active8,
                offset: [29, -56],
            },
        ],
    ], pumpkins_acre1: [
        [
            {
                id: IdAssetBundleBuildings.acre_seeds_pumpkin_1,
                offset: [-45, -93],
            },
        ],
        [
            {
                id: IdAssetBundleBuildings.acre_seeds_pumpkin_2,
                offset: [-48, -121],
            },
        ],
        [
            {
                id: IdAssetBundleBuildings.acre_seeds_pumpkin_3,
                offset: [-36, -125],
            },
        ],
    ], pumpkins_acre2: [
        [
            {
                id: IdAssetBundleBuildings.acre_seeds_pumpkin_1,
                offset: [-46, -88],
            },
        ],
        [
            {
                id: IdAssetBundleBuildings.acre_seeds_pumpkin_2,
                offset: [-50, -119],
            },
        ],
        [
            {
                id: IdAssetBundleBuildings.acre_seeds_pumpkin_3,
                offset: [-34, -124],
            },
        ],
    ], pumpkins_acre3: [
        [
            {
                id: IdAssetBundleBuildings.acre_seeds_pumpkin_1,
                offset: [-39, -89],
            },
        ],
        [
            {
                id: IdAssetBundleBuildings.acre_seeds_pumpkin_2,
                offset: [-45, -120],
            },
        ],
        [
            {
                id: IdAssetBundleBuildings.acre_seeds_pumpkin_3,
                offset: [-37, -126],
            },
        ],
    ], pumpkins_acre4: [
        [
            {
                id: IdAssetBundleBuildings.acre_seeds_pumpkin_1,
                offset: [-42, -89],
            },
        ],
        [
            {
                id: IdAssetBundleBuildings.acre_seeds_pumpkin_2,
                offset: [-50, -118],
            },
        ],
        [
            {
                id: IdAssetBundleBuildings.acre_seeds_pumpkin_3,
                offset: [-33, -123],
            },
        ],
    ], pumpkins_acre5: [
        [
            {
                id: IdAssetBundleBuildings.acre_seeds_pumpkin_1,
                offset: [-46, -89],
            },
        ],
        [
            {
                id: IdAssetBundleBuildings.acre_seeds_pumpkin_2,
                offset: [-52, -118],
            },
        ],
        [
            {
                id: IdAssetBundleBuildings.acre_seeds_pumpkin_3,
                offset: [-31, -123],
            },
        ],
    ], pumpkins_acre6: [
        [
            {
                id: IdAssetBundleBuildings.acre_seeds_pumpkin_1,
                offset: [-48, -90],
            },
        ],
        [
            {
                id: IdAssetBundleBuildings.acre_seeds_pumpkin_2,
                offset: [-52, -120],
            },
        ],
        [
            {
                id: IdAssetBundleBuildings.acre_seeds_pumpkin_3,
                offset: [-33, -122],
            },
        ],
    ], pumpkins_acre7: [
        [
            {
                id: IdAssetBundleBuildings.acre_seeds_pumpkin_1,
                offset: [-40, -90],
            },
        ],
        [
            {
                id: IdAssetBundleBuildings.acre_seeds_pumpkin_2,
                offset: [-44, -117],
            },
        ],
        [
            {
                id: IdAssetBundleBuildings.acre_seeds_pumpkin_3,
                offset: [-28, -121],
            },
        ],
    ], pumpkins_acre8: [
        [
            {
                id: IdAssetBundleBuildings.acre_seeds_pumpkin_1,
                offset: [-42, -90],
            },
        ],
        [
            {
                id: IdAssetBundleBuildings.acre_seeds_pumpkin_2,
                offset: [-49, -117],
            },
        ],
        [
            {
                id: IdAssetBundleBuildings.acre_seeds_pumpkin_3,
                offset: [-28, -120],
            },
        ],
    ], roses_acre1: [
        [
            {
                id: IdAssetBundleBuildings.acre_seeds_roses_3,
                offset: [-51, -119],
            },
        ],
    ], roses_acre2: [
        [
            {
                id: IdAssetBundleBuildings.acre_seeds_roses_3,
                offset: [-55, -113],
            },
        ],
    ], roses_acre3: [
        [
            {
                id: IdAssetBundleBuildings.acre_seeds_roses_3,
                offset: [-57, -114],
            },
        ],
    ], roses_acre4: [
        [
            {
                id: IdAssetBundleBuildings.acre_seeds_roses_3,
                offset: [-54, -119],
            },
        ],
    ], roses_acre5: [
        [
            {
                id: IdAssetBundleBuildings.acre_seeds_roses_3,
                offset: [-52, -119],
            },
        ],
    ], roses_acre6: [
        [
            {
                id: IdAssetBundleBuildings.acre_seeds_roses_3,
                offset: [-52, -116],
            },
        ],
    ], roses_acre7: [
        [
            {
                id: IdAssetBundleBuildings.acre_seeds_roses_3,
                offset: [-55, -111],
            },
        ],
    ], roses_acre8: [
        [
            {
                id: IdAssetBundleBuildings.acre_seeds_roses_3,
                offset: [-55, -111],
            },
        ],
    ], rutabaga_acre1: [
        [
            {
                id: IdAssetBundleBuildings.acre_seeds_rutabaga_1,
                offset: [-51, -101],
            },
        ],
        [
            {
                id: IdAssetBundleBuildings.acre_seeds_rutabaga_2,
                offset: [-53, -112],
            },
        ],
        [
            {
                id: IdAssetBundleBuildings.acre_seeds_rutabaga_3,
                offset: [-45, -113],
            },
        ],
    ], rutabaga_acre2: [
        [
            {
                id: IdAssetBundleBuildings.acre_seeds_rutabaga_1,
                offset: [-49, -98],
            },
        ],
        [
            {
                id: IdAssetBundleBuildings.acre_seeds_rutabaga_2,
                offset: [-50, -105],
            },
        ],
        [
            {
                id: IdAssetBundleBuildings.acre_seeds_rutabaga_3,
                offset: [-42, -109],
            },
        ],
    ], rutabaga_acre3: [
        [
            {
                id: IdAssetBundleBuildings.acre_seeds_rutabaga_1,
                offset: [-49, -102],
            },
        ],
        [
            {
                id: IdAssetBundleBuildings.acre_seeds_rutabaga_2,
                offset: [-57, -115],
            },
        ],
        [
            {
                id: IdAssetBundleBuildings.acre_seeds_rutabaga_3,
                offset: [-43, -110],
            },
        ],
    ], rutabaga_acre4: [
        [
            {
                id: IdAssetBundleBuildings.acre_seeds_rutabaga_1,
                offset: [-51, -104],
            },
        ],
        [
            {
                id: IdAssetBundleBuildings.acre_seeds_rutabaga_2,
                offset: [-50, -101],
            },
        ],
        [
            {
                id: IdAssetBundleBuildings.acre_seeds_rutabaga_3,
                offset: [-37, -113],
            },
        ],
    ], rutabaga_acre5: [
        [
            {
                id: IdAssetBundleBuildings.acre_seeds_rutabaga_1,
                offset: [-52, -102],
            },
        ],
        [
            {
                id: IdAssetBundleBuildings.acre_seeds_rutabaga_2,
                offset: [-49, -109],
            },
        ],
        [
            {
                id: IdAssetBundleBuildings.acre_seeds_rutabaga_3,
                offset: [-42, -115],
            },
        ],
    ], rutabaga_acre6: [
        [
            {
                id: IdAssetBundleBuildings.acre_seeds_rutabaga_1,
                offset: [-48, -97],
            },
        ],
        [
            {
                id: IdAssetBundleBuildings.acre_seeds_rutabaga_2,
                offset: [-52, -112],
            },
        ],
        [
            {
                id: IdAssetBundleBuildings.acre_seeds_rutabaga_3,
                offset: [-46, -113],
            },
        ],
    ], rutabaga_acre7: [
        [
            {
                id: IdAssetBundleBuildings.acre_seeds_rutabaga_1,
                offset: [-48, -97],
            },
        ],
        [
            {
                id: IdAssetBundleBuildings.acre_seeds_rutabaga_2,
                offset: [-49, -109],
            },
        ],
        [
            {
                id: IdAssetBundleBuildings.acre_seeds_rutabaga_3,
                offset: [-46, -113],
            },
        ],
    ], rutabaga_acre8: [
        [
            {
                id: IdAssetBundleBuildings.acre_seeds_rutabaga_1,
                offset: [-48, -97],
            },
        ],
        [
            {
                id: IdAssetBundleBuildings.acre_seeds_rutabaga_2,
                offset: [-49, -109],
            },
        ],
        [
            {
                id: IdAssetBundleBuildings.acre_seeds_rutabaga_3,
                offset: [-46, -113],
            },
        ],
    ], vanilla_meadow1: [
        [
            {
                id: IdAssetBundleBuildings.meadow_seeds_vanilla_1,
                offset: [-37, -123],
            },
        ],
        [
            {
                id: IdAssetBundleBuildings.meadow_seeds_vanilla_2,
                offset: [-40, -121],
            },
        ],
        [
            {
                id: IdAssetBundleBuildings.meadow_seeds_vanilla_3,
                offset: [-33, -124],
            },
        ],
    ], vanilla_meadow2: [
        [
            {
                id: IdAssetBundleBuildings.meadow_seeds_vanilla_1,
                offset: [-41, -124],
            },
        ],
        [
            {
                id: IdAssetBundleBuildings.meadow_seeds_vanilla_2,
                offset: [-44, -121],
            },
        ],
        [
            {
                id: IdAssetBundleBuildings.meadow_seeds_vanilla_3,
                offset: [-38, -123],
            },
        ],
    ], vanilla_meadow3: [
        [
            {
                id: IdAssetBundleBuildings.meadow_seeds_vanilla_1,
                offset: [-46, -120],
            },
        ],
        [
            {
                id: IdAssetBundleBuildings.meadow_seeds_vanilla_2,
                offset: [-47, -118],
            },
        ],
        [
            {
                id: IdAssetBundleBuildings.meadow_seeds_vanilla_3,
                offset: [-41, -120],
            },
        ],
    ], vanilla_meadow4: [
        [
            {
                id: IdAssetBundleBuildings.meadow_seeds_vanilla_1,
                offset: [-47, -117],
            },
        ],
        [
            {
                id: IdAssetBundleBuildings.meadow_seeds_vanilla_2,
                offset: [-52, -115],
            },
        ],
        [
            {
                id: IdAssetBundleBuildings.meadow_seeds_vanilla_3,
                offset: [-43, -116],
            },
        ],
    ], vanilla_meadow5: [
        [
            {
                id: IdAssetBundleBuildings.meadow_seeds_vanilla_1,
                offset: [-47, -117],
            },
        ],
        [
            {
                id: IdAssetBundleBuildings.meadow_seeds_vanilla_2,
                offset: [-50, -112],
            },
        ],
        [
            {
                id: IdAssetBundleBuildings.meadow_seeds_vanilla_3,
                offset: [-44, -115],
            },
        ],
    ], vanilla_meadow6: [
        [
            {
                id: IdAssetBundleBuildings.meadow_seeds_vanilla_1,
                offset: [-47, -117],
            },
        ],
        [
            {
                id: IdAssetBundleBuildings.meadow_seeds_vanilla_2,
                offset: [-49, -112],
            },
        ],
        [
            {
                id: IdAssetBundleBuildings.meadow_seeds_vanilla_3,
                offset: [-44, -115],
            },
        ],
    ], vanilla_meadow7: [
        [
            {
                id: IdAssetBundleBuildings.meadow_seeds_vanilla_1,
                offset: [-47, -117],
            },
        ],
        [
            {
                id: IdAssetBundleBuildings.meadow_seeds_vanilla_2,
                offset: [-50, -114],
            },
        ],
        [
            {
                id: IdAssetBundleBuildings.meadow_seeds_vanilla_3,
                offset: [-44, -118],
            },
        ],
    ], wheat_acre1: [
        [
            {
                id: IdAssetBundleBuildings.acre_seeds_wheat_1,
                offset: [-52, -114],
            },
        ],
        [
            {
                id: IdAssetBundleBuildings.acre_seeds_wheat_2,
                offset: [-50, -120],
            },
        ],
        [
            {
                id: IdAssetBundleBuildings.acre_seeds_wheat_3,
                offset: [-54, -122],
            },
        ],
    ], wheat_acre2: [
        [
            {
                id: IdAssetBundleBuildings.acre_seeds_wheat_1,
                offset: [-51, -111],
            },
        ],
        [
            {
                id: IdAssetBundleBuildings.acre_seeds_wheat_2,
                offset: [-52, -117],
            },
        ],
        [
            {
                id: IdAssetBundleBuildings.acre_seeds_wheat_3,
                offset: [-54, -118],
            },
        ],
    ], wheat_acre3: [
        [
            {
                id: IdAssetBundleBuildings.acre_seeds_wheat_1,
                offset: [-50, -112],
            },
        ],
        [
            {
                id: IdAssetBundleBuildings.acre_seeds_wheat_2,
                offset: [-51, -118],
            },
        ],
        [
            {
                id: IdAssetBundleBuildings.acre_seeds_wheat_3,
                offset: [-50, -113],
            },
        ],
    ], wheat_acre4: [
        [
            {
                id: IdAssetBundleBuildings.acre_seeds_wheat_1,
                offset: [-43, -116],
            },
        ],
        [
            {
                id: IdAssetBundleBuildings.acre_seeds_wheat_2,
                offset: [-45, -124],
            },
        ],
        [
            {
                id: IdAssetBundleBuildings.acre_seeds_wheat_3,
                offset: [-47, -118],
            },
        ],
    ], wheat_acre5: [
        [
            {
                id: IdAssetBundleBuildings.acre_seeds_wheat_1,
                offset: [-46, -116],
            },
        ],
        [
            {
                id: IdAssetBundleBuildings.acre_seeds_wheat_2,
                offset: [-49, -116],
            },
        ],
        [
            {
                id: IdAssetBundleBuildings.acre_seeds_wheat_3,
                offset: [-51, -119],
            },
        ],
    ], wheat_acre6: [
        [
            {
                id: IdAssetBundleBuildings.acre_seeds_wheat_1,
                offset: [-59, -117],
            },
        ],
        [
            {
                id: IdAssetBundleBuildings.acre_seeds_wheat_2,
                offset: [-52, -120],
            },
        ],
        [
            {
                id: IdAssetBundleBuildings.acre_seeds_wheat_3,
                offset: [-51, -119],
            },
        ],
    ], wheat_acre7: [
        [
            {
                id: IdAssetBundleBuildings.acre_seeds_wheat_1,
                offset: [-49, -96],
            },
        ],
        [
            {
                id: IdAssetBundleBuildings.acre_seeds_wheat_2,
                offset: [-52, -108],
            },
        ],
        [
            {
                id: IdAssetBundleBuildings.acre_seeds_wheat_3,
                offset: [-51, -119],
            },
        ],
    ], wheat_acre8: [
        [
            {
                id: IdAssetBundleBuildings.acre_seeds_wheat_1,
                offset: [-49, -107],
            },
        ],
        [
            {
                id: IdAssetBundleBuildings.acre_seeds_wheat_2,
                offset: [-52, -108],
            },
        ],
        [
            {
                id: IdAssetBundleBuildings.acre_seeds_wheat_3,
                offset: [-51, -119],
            },
        ],
    ], wildflowers_acre1: [
        [
            {
                id: IdAssetBundleBuildings.acre_seeds_wildflowers_1,
                offset: [-48, -107],
            },
        ],
        [
            {
                id: IdAssetBundleBuildings.acre_seeds_wildflowers_2,
                offset: [-49, -108],
            },
        ],
        [
            {
                id: IdAssetBundleBuildings.acre_seeds_wildflowers_3,
                offset: [-55, -109],
            },
        ],
    ], wildflowers_acre2: [
        [
            {
                id: IdAssetBundleBuildings.acre_seeds_wildflowers_1,
                offset: [-48, -104],
            },
        ],
        [
            {
                id: IdAssetBundleBuildings.acre_seeds_wildflowers_2,
                offset: [-51, -107],
            },
        ],
        [
            {
                id: IdAssetBundleBuildings.acre_seeds_wildflowers_3,
                offset: [-52, -106],
            },
        ],
    ], wildflowers_acre3: [
        [
            {
                id: IdAssetBundleBuildings.acre_seeds_wildflowers_1,
                offset: [-51, -104],
            },
        ],
        [
            {
                id: IdAssetBundleBuildings.acre_seeds_wildflowers_2,
                offset: [-51, -106],
            },
        ],
        [
            {
                id: IdAssetBundleBuildings.acre_seeds_wildflowers_3,
                offset: [-51, -108],
            },
        ],
    ], wildflowers_acre4: [
        [
            {
                id: IdAssetBundleBuildings.acre_seeds_wildflowers_1,
                offset: [-46, -109],
            },
        ],
        [
            {
                id: IdAssetBundleBuildings.acre_seeds_wildflowers_2,
                offset: [-44, -111],
            },
        ],
        [
            {
                id: IdAssetBundleBuildings.acre_seeds_wildflowers_3,
                offset: [-52, -110],
            },
        ],
    ], wildflowers_acre5: [
        [
            {
                id: IdAssetBundleBuildings.acre_seeds_wildflowers_1,
                offset: [-51, -111],
            },
        ],
        [
            {
                id: IdAssetBundleBuildings.acre_seeds_wildflowers_2,
                offset: [-50, -107],
            },
        ],
        [
            {
                id: IdAssetBundleBuildings.acre_seeds_wildflowers_3,
                offset: [-50, -108],
            },
        ],
    ], wildflowers_acre6: [
        [
            {
                id: IdAssetBundleBuildings.acre_seeds_wildflowers_1,
                offset: [-50, -109],
            },
        ],
        [
            {
                id: IdAssetBundleBuildings.acre_seeds_wildflowers_2,
                offset: [-55, -111],
            },
        ],
        [
            {
                id: IdAssetBundleBuildings.acre_seeds_wildflowers_3,
                offset: [-54, -109],
            },
        ],
    ], wildflowers_acre7: [
        [
            {
                id: IdAssetBundleBuildings.acre_seeds_wildflowers_1,
                offset: [-50, -97],
            },
        ],
        [
            {
                id: IdAssetBundleBuildings.acre_seeds_wildflowers_2,
                offset: [-52, -104],
            },
        ],
        [
            {
                id: IdAssetBundleBuildings.acre_seeds_wildflowers_3,
                offset: [-52, -104],
            },
        ],
    ], wildflowers_acre8: [
        [
            {
                id: IdAssetBundleBuildings.acre_seeds_wildflowers_1,
                offset: [-47, -103],
            },
        ],
        [
            {
                id: IdAssetBundleBuildings.acre_seeds_wildflowers_2,
                offset: [-47, -100],
            },
        ],
        [
            {
                id: IdAssetBundleBuildings.acre_seeds_wildflowers_3,
                offset: [-52, -104],
            },
        ],
    ], sheepWool_sheepPen1: [
        [
            {
                id: "sheep",
                offset: [-92, -93],
                anims: [[], ["idle", "eat"], ["idle_fluffy_roll", "idle2_fluffy", "idle_fluffy"]],
                scale: 0.1665,
            },
            {
                id: "sheep",
                offset: [43, -86],
                anims: [[], ["idle", "eat"], ["idle_fluffy_roll", "idle2_fluffy", "idle_fluffy"]],
                scale: -0.1665,
            },
            {
                id: "sheep",
                offset: [-15, -121],
                anims: [[], ["idle", "eat"], ["idle_fluffy_roll", "idle2_fluffy", "idle_fluffy"]],
                scale: -0.1165,
            },
        ],
    ], sheepWool_sheepPen2: [
        [
            {
                id: "sheep",
                offset: [-73, -84],
                anims: [[], ["idle", "eat"], ["idle_fluffy_roll", "idle2_fluffy", "idle_fluffy"]],
                scale: 0.1665,
            },
            {
                id: "sheep",
                offset: [27, -81],
                anims: [[], ["idle", "eat"], ["idle_fluffy_roll", "idle2_fluffy", "idle_fluffy"]],
                scale: -0.1665,
            },
            {
                id: "sheep",
                offset: [-31, -117],
                anims: [[], ["idle", "eat"], ["idle_fluffy_roll", "idle2_fluffy", "idle_fluffy"]],
                scale: -0.1165,
            },
        ],
    ], sheepWool_sheepPen3: [
        [
            {
                id: "sheep",
                offset: [-115, -107],
                anims: [[], ["idle", "eat"], ["idle_fluffy_roll", "idle2_fluffy", "idle_fluffy"]],
                scale: 0.1665,
            },
            {
                id: "sheep",
                offset: [0, -74],
                anims: [[], ["idle", "eat"], ["idle_fluffy_roll", "idle2_fluffy", "idle_fluffy"]],
                scale: -0.1665,
            },
            {
                id: "sheep",
                offset: [-28, -125],
                anims: [[], ["idle", "eat"], ["idle_fluffy_roll", "idle2_fluffy", "idle_fluffy"]],
                scale: -0.1165,
            },
        ],
    ], sheepWool_sheepPen4: [
        [
            {
                id: "sheep",
                offset: [-97, -93],
                anims: [[], ["idle", "eat"], ["idle_fluffy_roll", "idle2_fluffy", "idle_fluffy"]],
                scale: 0.1665,
            },
            {
                id: "sheep",
                offset: [27, -96],
                anims: [[], ["idle", "eat"], ["idle_fluffy_roll", "idle2_fluffy", "idle_fluffy"]],
                scale: -0.1665,
            },
            {
                id: "sheep",
                offset: [-27, -126],
                anims: [[], ["idle", "eat"], ["idle_fluffy_roll", "idle2_fluffy", "idle_fluffy"]],
                scale: -0.1165,
            },
        ],
    ], sheepWool_sheepPen5: [
        [
            {
                id: "sheep",
                offset: [-105, -102],
                anims: [[], ["idle", "eat"], ["idle_fluffy_roll", "idle2_fluffy", "idle_fluffy"]],
                scale: 0.1665,
            },
            {
                id: "sheep",
                offset: [27, -94],
                anims: [[], ["idle", "eat"], ["idle_fluffy_roll", "idle2_fluffy", "idle_fluffy"]],
                scale: -0.1665,
            },
            {
                id: "sheep",
                offset: [-36, -120],
                anims: [[], ["idle", "eat"], ["idle_fluffy_roll", "idle2_fluffy", "idle_fluffy"]],
                scale: -0.1165,
            },
        ],
    ], sheepWool_sheepPen6: [
        [
            {
                id: "sheep",
                offset: [-87, -86],
                anims: [[], ["idle", "eat"], ["idle_fluffy_roll", "idle2_fluffy", "idle_fluffy"]],
                scale: 0.1665,
            },
            {
                id: "sheep",
                offset: [18, -91],
                anims: [[], ["idle", "eat"], ["idle_fluffy_roll", "idle2_fluffy", "idle_fluffy"]],
                scale: -0.1665,
            },
            {
                id: "sheep",
                offset: [-54, -129],
                anims: [[], ["idle", "eat"], ["idle_fluffy_roll", "idle2_fluffy", "idle_fluffy"]],
                scale: -0.1165,
            },
        ],
    ], sheepWool_sheepPen7: [
        [
            {
                id: "sheep",
                offset: [-104, -96],
                anims: [[], ["idle", "eat"], ["idle_fluffy_roll", "idle2_fluffy", "idle_fluffy"]],
                scale: 0.1665,
            },
            {
                id: "sheep",
                offset: [14, -87],
                anims: [[], ["idle", "eat"], ["idle_fluffy_roll", "idle2_fluffy", "idle_fluffy"]],
                scale: -0.1665,
            },
            {
                id: "sheep",
                offset: [-45, -111],
                anims: [[], ["idle", "eat"], ["idle_fluffy_roll", "idle2_fluffy", "idle_fluffy"]],
                scale: -0.1165,
            },
        ],
    ], xpFlowers_acre1: [
        [
            {
                id: IdAssetBundleBuildings.acre_seeds_xpFlowers_1,
                offset: [-52, -103],
            },
        ],
        [
            {
                id: IdAssetBundleBuildings.acre_seeds_xpFlowers_2,
                offset: [-50, -113],
            },
        ],
        [
            {
                id: IdAssetBundleBuildings.acre_seeds_xpFlowers_3,
                offset: [-49, -112],
            },
        ],
    ], xpFlowers_acre2: [
        [
            {
                id: IdAssetBundleBuildings.acre_seeds_xpFlowers_1,
                offset: [-52, -102],
            },
        ],
        [
            {
                id: IdAssetBundleBuildings.acre_seeds_xpFlowers_2,
                offset: [-49, -103],
            },
        ],
        [
            {
                id: IdAssetBundleBuildings.acre_seeds_xpFlowers_3,
                offset: [-49, -108],
            },
        ],
    ], xpFlowers_acre3: [
        [
            {
                id: IdAssetBundleBuildings.acre_seeds_xpFlowers_1,
                offset: [-53, -104],
            },
        ],
        [
            {
                id: IdAssetBundleBuildings.acre_seeds_xpFlowers_2,
                offset: [-50, -108],
            },
        ],
        [
            {
                id: IdAssetBundleBuildings.acre_seeds_xpFlowers_3,
                offset: [-46, -107],
            },
        ],
    ], xpFlowers_acre4: [
        [
            {
                id: IdAssetBundleBuildings.acre_seeds_xpFlowers_1,
                offset: [-53, -104],
            },
        ],
        [
            {
                id: IdAssetBundleBuildings.acre_seeds_xpFlowers_2,
                offset: [-50, -105],
            },
        ],
        [
            {
                id: IdAssetBundleBuildings.acre_seeds_xpFlowers_3,
                offset: [-50, -109],
            },
        ],
    ], xpFlowers_acre5: [
        [
            {
                id: IdAssetBundleBuildings.acre_seeds_xpFlowers_1,
                offset: [-53, -104],
            },
        ],
        [
            {
                id: IdAssetBundleBuildings.acre_seeds_xpFlowers_2,
                offset: [-53, -108],
            },
        ],
        [
            {
                id: IdAssetBundleBuildings.acre_seeds_xpFlowers_3,
                offset: [-51, -106],
            },
        ],
    ], xpFlowers_acre6: [
        [
            {
                id: IdAssetBundleBuildings.acre_seeds_xpFlowers_1,
                offset: [-56, -102],
            },
        ],
        [
            {
                id: IdAssetBundleBuildings.acre_seeds_xpFlowers_2,
                offset: [-53, -103],
            },
        ],
        [
            {
                id: IdAssetBundleBuildings.acre_seeds_xpFlowers_3,
                offset: [-49, -102],
            },
        ],
    ], xpFlowers_acre7: [
        [
            {
                id: IdAssetBundleBuildings.acre_seeds_xpFlowers_1,
                offset: [-53, -104],
            },
        ],
        [
            {
                id: IdAssetBundleBuildings.acre_seeds_xpFlowers_2,
                offset: [-46, -102],
            },
        ],
        [
            {
                id: IdAssetBundleBuildings.acre_seeds_xpFlowers_3,
                offset: [-44, -101],
            },
        ],
    ], xpFlowers_acre8: [
        [
            {
                id: IdAssetBundleBuildings.acre_seeds_xpFlowers_1,
                offset: [-52, -103],
            },
        ],
        [
            {
                id: IdAssetBundleBuildings.acre_seeds_xpFlowers_2,
                offset: [-50, -102],
            },
        ],
        [
            {
                id: IdAssetBundleBuildings.acre_seeds_xpFlowers_3,
                offset: [-46, -101],
            },
        ],
    ] }, artConfigProductionsOverrides);



//////////////////
// WEBPACK FOOTER
// ./src/assetBundles/artConfigProductions.ts
// module id = 2186
// module chunks = 3